document.addEventListener('DOMContentLoaded', async function()  {




    // Re-wire every Upcoming deliveries list to the live ShowMore after a re-render.
    // script.js's deliveryItemShowMore() cannot be used here: it looks for live's
    // `.see-more .btn`, which this page does not have (the board's button is
    // .acct-seemore, drawn outside the card), and it dereferences that null when a
    // list is down to one row.
    function refreshDeliveryShowMore() {
      if (typeof window.__acctResetShowMore !== 'function') return;
      document.querySelectorAll('.acct .delivery-items').forEach(window.__acctResetShowMore);
    }

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token') || document.querySelector('.acct')?.getAttribute('data-customer-id');
    const customerToken = token;

    // Portal Swap: Supabase customer_boxes lookup by subscription
    // contract id for box-content consumers. Permanent exclusions use subscription line attributes.
    const _FF_SB_URL  = 'https://eaagqdyrbdlahjzdppdk.supabase.co';
    const _FF_SB_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVhYWdxZHlyYmRsYWhqemRwcGRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc1OTk3NDEsImV4cCI6MjA4MzE3NTc0MX0.tnteB3igOKfgXKGTDEfRiq7TcxZIKLe3wSufhBVoiJk';
    const _ffSbBoxCache = new Map();  // sid (string) → row | null
    async function fetchSupabaseBoxForSub(sid) {
      if (!sid) return null;
      const key = String(sid);
      if (_ffSbBoxCache.has(key)) return _ffSbBoxCache.get(key);
      try {
        const url = _FF_SB_URL + '/rest/v1/customer_boxes?shopify_contract_id=eq.' + encodeURIComponent(key) + '&order=delivery_date.desc&limit=1';
        const r = await fetch(url, {
          headers: { apikey: _FF_SB_ANON, Authorization: 'Bearer ' + _FF_SB_ANON, Accept: 'application/json' }
        });
        if (!r.ok) { _ffSbBoxCache.set(key, null); return null; }
        const rows = await r.json();
        const row = (Array.isArray(rows) && rows[0]) || null;
        _ffSbBoxCache.set(key, row);
        return row;
      } catch (e) {
        _ffSbBoxCache.set(key, null);
        return null;
      }
    }
    // Expose for cross-file callers (e.g. main-collection-product-grid.liquid).
    window.__ffFetchSupabaseBoxForSub = fetchSupabaseBoxForSub;

    // Historical orders use the same Brisbane cutoff/zone rules as deliveries.
    // A billing timestamp is an input to the calculation, never the displayed delivery date.
    function historyDeliveryLabel(zone, order, subscription) {
      const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const deliveryDay = weekdays.findIndex(day => zone?.day?.includes(day));
      const checkDay = weekdays.findIndex(day => zone?.day_2?.includes(day));
      if (deliveryDay < 0 || checkDay < 0 || !order?.billingDate || !Number.isFinite(new Date(order.billingDate).getTime())) {
        return 'Delivery date unavailable';
      }
      const origin = subscription?.originOrder;
      const originId = String(origin?.id || '').split('/').pop();
      const orderId = String(order.orderId || '').split('/').pop();
      const firstOrder = originId && orderId ? originId === orderId : !!(origin?.name && order.orderName === origin.name);
      try {
        const result = getDeliveryDate(deliveryDay, checkDay, order.billingDate, firstOrder);
        return result.newFormattedDate + ' Delivery';
      } catch (_) { return 'Delivery date unavailable'; }
    }

    // Guard against duplicate event listener registration (SUB-074)
    let _historyRenderVersion = 0;
    const _registeredListeners = new Set();
    let _latestSubscriptions = [];
    let _latestUpcoming = [];
    let _latestHistory = [];

    // Central fan-out for any subscription-state mutation. Every write path
    // (address change, frequency change, cancel/resume/reactivate, discount
    // apply/remove, product add via Picked for you, etc.) should call this
    // after the successful API roundtrip so every view of the subscription
    // stays coherent:
    //   * Overview compact "Your Subscription" card
    //   * Details tab Address gate + prefill (single-active gate)
    //   * Details tab Cards gate
    //   * Picked for you filter (excluded products)
    //   * Reviews list (which items show cards)
    //   * sessionStorage cache invalidation
    // Pass the updated subscription + its index in _latestSubscriptions so
    // we splice it in first, then re-render every dependent surface.
    function _fanOutSubscriptionChange(updatedSub, index) {
      if (updatedSub && typeof index === 'number' && index >= 0) {
        _latestSubscriptions[index] = updatedSub;
      }
      try { if (typeof _invalidateCache === 'function') _invalidateCache(); } catch (e) {}
      try {
        if (typeof renderOverviewSubscription === 'function') {
          renderOverviewSubscription(_latestSubscriptions, allContractDetails);
        }
      } catch (e) { console.warn('fanOut: renderOverviewSubscription failed:', e); }
      try {
        if (typeof window.__ffRefreshDetailsAddress === 'function') {
          window.__ffRefreshDetailsAddress(_latestSubscriptions);
        }
        if (typeof window.__ffRefreshDetailsCards === 'function') {
          window.__ffRefreshDetailsCards(_latestSubscriptions);
        }
        if (typeof window.__ffRefreshPickedForYou === 'function') {
          window.__ffRefreshPickedForYou(_latestSubscriptions);
        }
        if (typeof window.__ffRefreshReviews === 'function') {
          window.__ffRefreshReviews(_latestSubscriptions);
        }
      } catch (e) { console.warn('fanOut: portal-module refresh failed:', e); }
    }
    // Subscription-level lock: blocks a new pause/cancel/resume action on
    // a subscription while a previous one is still in flight.
    const _pendingSubscriptions = new Set();
    // Per-button skip/unskip state. Keyed on the button DOM element so
    // sibling deliveries are fully isolated (Appstle's upcoming list can
    // return items sharing null/undefined ids which would collide if
    // keyed on data-id).
    //
    // Click flow is a serialized sync loop — no abort/retry thrash that
    // could trip Appstle's eventual-consistency 400s. Each click just
    // updates targetSkipped; the API call runs to completion, then we
    // re-check target vs server state and fire again if the user has
    // since toggled. Appstle only ever sees one clean skip/unskip in
    // flight per button.
    //
    // value: { serverSkipped, targetSkipped, version, flipTimerId, inFlight, retryCount, dataId, subscriptionId, findIndex, checkDay }
    const _orderSkipState = new WeakMap();
    const _skipRefreshTimers = new Map();
    const _SKIP_UI_FLIP_DELAY_MS = 500;
    const _SKIP_REFRESH_DEBOUNCE_MS = 800;
    const _SKIP_MAX_RETRIES = 2;
    const _SKIP_RETRY_DELAY_MS = 400;

    // --- Portal cache helpers ---
    const _CACHE_TTL = 2 * 60 * 1000; // 2 minutes
    const _cacheKey = token ? 'portal_cache_' + Array.from(token).reduce((h, c) => (Math.imul(31, h) + c.charCodeAt(0)) | 0, 0).toString(36) : null;

    function _invalidateCache() {
      try { if (_cacheKey) sessionStorage.removeItem(_cacheKey); } catch (e) {}
    }

    function _writeCache(contracts, subscriptions, upcoming, history) {
      try {
        // Don't cache empty results: a freshly-checked-out subscription may
        // not yet be visible via Appstle's read APIs (eventual consistency),
        // and caching that empty snapshot would make the portal show
        // "no active subscription" for the full TTL — even if the user
        // reloads — until they log out/in. Skip writing instead.
        if (!subscriptions || !subscriptions.length) return;
        if (_cacheKey) sessionStorage.setItem(_cacheKey, JSON.stringify({
          contracts, subscriptions, upcoming, history, ts: Date.now()
        }));
      } catch (e) {}
    }

    function _readCache() {
      try {
        if (!_cacheKey) return null;
        const raw = sessionStorage.getItem(_cacheKey);
        if (!raw) return null;
        const cached = JSON.parse(raw);
        if (Date.now() - cached.ts > _CACHE_TTL) return null;
        // Discard cached empty snapshots — these can poison the portal when
        // a freshly-checked-out subscription was not yet visible during the
        // first visit. Forces a fresh API call on subsequent visits until
        // there's at least one subscription to show.
        if (!cached.subscriptions || !cached.subscriptions.length) {
          sessionStorage.removeItem(_cacheKey);
          return null;
        }
        return cached;
      } catch (e) { return null; }
    }

    // Load allContractDetails from cache or API (preload if available)
    // Helpers for backoff retry + concurrency throttling — protect Appstle
    // from request bursts when many customers load the portal at once.
    const _sleep = (ms) => new Promise(r => setTimeout(r, ms));
    const _backoffDelay = () => 1500 + Math.random() * 1000; // 1.5–2.5s jitter
    async function _runWithLimit(items, limit, worker) {
      const results = new Array(items.length);
      let next = 0;
      async function loop() {
        while (true) {
          const i = next++;
          if (i >= items.length) return;
          results[i] = await worker(items[i], i);
        }
      }
      const runners = [];
      for (let i = 0; i < Math.min(limit, items.length); i++) runners.push(loop());
      await Promise.all(runners);
      return results;
    }
    const __cachedPortal = _readCache();
    let allContractDetails;
    if (__cachedPortal) {
      allContractDetails = __cachedPortal.contracts;
    } else {
      try {
        allContractDetails = window.__portalPreload ? await window.__portalPreload : await getAllContractDetails(token);
      } catch (e) {
        console.error('Failed to fetch contract details (preload), retrying after backoff:', e);
        await _sleep(_backoffDelay());
        try {
          allContractDetails = await getAllContractDetails(token);
        } catch (e2) {
          console.error('Failed to fetch contract details:', e2);
          allContractDetails = [];
        }
      }
    }
    async function contractDetails(){
      const detailsWrap = document.querySelector('.account-subscription__details');
      if (!detailsWrap) {
          return;
      }
      const subscriptionId = parseInt(queryParams.get('subscription_id') || '', 10);
      try {
        const subscription = await getContract(token, subscriptionId);
        const index = allContractDetails.findIndex(item => item.subscriptionContractId === subscriptionId);
        if (index === -1) {
          console.warn('Contract not found for subscriptionId:', subscriptionId);
          return;
        }
        //details
        let hidClass = '';
        if(subscription.status != 'CANCELLED'){
          hidClass = 'hidden';
        }
        const contract = allContractDetails[index];
        const subscriptionAmount = Number(contract.contractAmount).toFixed(2);

        const city = subscription.deliveryMethod?.address?.city;
        const state = subscription.deliveryMethod?.address?.provinceCode;
        const postcode = subscription.deliveryMethod?.address?.zip;

        const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const zone = await findZoneData(city, state, postcode);
        const findIndex = daysOfWeek.findIndex((day) => zone?.day?.includes(day));
        const checkDay = daysOfWeek.findIndex((day_2) => zone?.day_2?.includes(day_2));
        const num = index + 1;
        const subscriptionTitle = subscription.deliveryMethod?.address?.address1 || 'Subscription';
        const lastDigits = subscription.customerPaymentMethod?.instrument?.lastDigits;
        const _discounts = (subscription.discounts?.nodes || []).filter(Boolean);
        let topDiscountHTML;
        let discountHTML;
        let discountClass = '';
        let discountId = '';
        if (_discounts.length) {
          discountId = _discounts.map((d) => d.id).filter(Boolean).join(',');
          discountHTML = _discounts.map((d) => _buildDiscountHTML(d, subscription)).join('');
          const _codes = _discounts.map((d) => d.title).filter(Boolean).join(', ');
          topDiscountHTML = `
            <strong>Discount:</strong>
            <span>${_codes}</span>
          `;
          discountClass = 'has-discount';
        } else {
          discountHTML = `
            <p>No code applied</p>
          `;
          topDiscountHTML = `
            <strong>Discount:</strong>
            <span>None</span>
          `;
        }

        const intervalCount = subscription.deliveryPolicy.intervalCount;
        let newPlanName = '';
        let planId = '';
        switch (intervalCount) {
            case 1:
              newPlanName = 'Weekly';
              planId = '2067431485';
                break;
            case 2:
              newPlanName = 'Fortnightly';
              planId = '2068348989';
                break;
            case 4:
              newPlanName = 'Monthly';
              planId = '2068381757';
                break;
        }

        const customAttributes = subscription.customAttributes;
        const packagingValue = customAttributes.find(attr => attr.key === "Packaging Preferences")?.value || '';
        const veganValue = customAttributes.find(attr => attr.key === "Dietary preferences")?.value
                        || customAttributes.find(attr => attr.key === "Vegan or vegetarian?")?.value
                        || '';
        const householdValue = customAttributes.find(attr => attr.key === "Household size")?.value
                            || customAttributes.find(attr => attr.key === "Household")?.value
                            || '';

        const shippingAddressArr = subscription.deliveryMethod?.address || {};
        const shippingFirstName = shippingAddressArr.firstName || '';
        const shippingLastName = shippingAddressArr.lastName || '';
        const shippingPhone = shippingAddressArr.phone || '';
        const shippingAddress1 = shippingAddressArr.address1 || '';
        const shippingAddress2 = shippingAddressArr.address2 || '';
        const shippingSuburb = shippingAddressArr.city || '';
        const shippingState = shippingAddressArr.provinceCode || '';
        const shippingPostcode = shippingAddressArr.zip || '';
        const deliveryInstructions = customAttributes.find(attr => attr.key === "Delivery Instructions")?.value || '';
        detailsWrap.innerHTML = `
            <div class="account-subscription__details-title">
                <h2>${subscriptionTitle} 📦 #${num}</h2>
            </div>
            <div class="settings__items">
                <div class="setting-item delivery-info" 
                    data-subscription-id="${subscriptionId}" 
                    data-index="${index}"
                    data-firstname="${shippingFirstName}" 
                    data-lastname="${shippingLastName}" 
                    data-phone="${shippingPhone}" 
                    data-address1="${shippingAddress1}"
                    data-address2="${shippingAddress2}"
                    data-suburb="${shippingSuburb}"
                    data-state="${shippingState}"
                    data-postcode="${shippingPostcode}"
                    data-instructions="${deliveryInstructions}"
                    >
                    <div class="setting-item__text">
                        <h4>Delivery information</h4>
                        <p>${shippingAddress1}</p>
                    </div>
                    <span class="icon-arrow">
                        Edit
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.59961 6L15.5996 12L9.59961 18" stroke="#1B1C1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </span>
                </div>
                <div class="setting-item payment-method" data-subscription-id="${subscriptionId}">
                    <div class="setting-item__text">
                        <h4>Payment method</h4>
                        <p>Ending in ${lastDigits}</p>
                    </div>
                    <span class="icon-arrow">
                        Edit
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.59961 6L15.5996 12L9.59961 18" stroke="#1B1C1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </span>
                </div>
                <div class="setting-item edit-frequency" data-subscription-id="${subscriptionId}" data-findindex="${findIndex}" data-checkday="${checkDay}" data-plan-id="${planId}" data-subscription-amount="${subscriptionAmount}">
                  <div class="setting-item__text">
                    <h4>Frequency</h4>
                    <p>${newPlanName}</p>
                  </div>
                  <span class="icon-arrow">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.59961 6L15.5996 12L9.59961 18" stroke="#1B1C1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                </div>
                <div class="setting-item apply-code ${discountClass}" data-subscription-id="${subscriptionId}" data-discount-id="${discountId}" data-index="${index}">
                    <div class="setting-item__text">
                        <h4>Apply discount code</h4>
                        <div class="current-code-wrap">
                          ${discountHTML}
                        </div>
                    </div>
                    <span class="icon-arrow">
                        Edit
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.59961 6L15.5996 12L9.59961 18" stroke="#1B1C1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </span>
                </div>
                <div class="setting-item packaging-recycle" data-value="${packagingValue}" data-index="${index}" data-subscription-id="${subscriptionId}">
                    <div class="setting-item__text">
                        <h4>Packaging preferences</h4>
                        <p>${packagingValue}</p>
                    </div>
                    <span class="icon-arrow">
                        Edit
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.59961 6L15.5996 12L9.59961 18" stroke="#1B1C1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </span>
                </div>

                <div class="setting-item vegan-recycle" data-value="${veganValue}" data-index="${index}" data-subscription-id="${subscriptionId}">
                    <div class="setting-item__text">
                        <h4>Dietary preferences</h4>
                        <p>${veganValue}</p>
                    </div>
                    <span class="icon-arrow">
                        Edit
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.59961 6L15.5996 12L9.59961 18" stroke="#1B1C1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </span>
                </div>
                <div class="setting-item household-set" data-value="${householdValue}" data-index="${index}" data-subscription-id="${subscriptionId}">
                    <div class="setting-item__text">
                        <h4>Household size</h4>
                        <p>${householdValue}</p>
                    </div>
                    <span class="icon-arrow">
                        Edit
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.59961 6L15.5996 12L9.59961 18" stroke="#1B1C1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </span>
                </div>

            </div>
            <div class="account-subscription__bottom ${hidClass}">
                <button class="btn rebuild-box-btn" data-subscription-id="${subscriptionId}">
                    <span>Continue to Box Contents</span>
                    <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.7374 4.8444C14.7346 4.82534 14.7324 4.80618 14.7286 4.78723C14.725 4.76889 14.72 4.75113 14.7154 4.73316C14.7113 4.71674 14.7077 4.7002 14.7028 4.68396C14.6974 4.66635 14.6908 4.64928 14.6846 4.63202C14.6788 4.61575 14.6734 4.5994 14.6668 4.58333C14.6601 4.56727 14.6523 4.55182 14.6449 4.53616C14.6371 4.51963 14.6298 4.50299 14.6211 4.48682C14.6131 4.47177 14.6039 4.45744 14.5951 4.44286C14.5857 4.42697 14.5767 4.41091 14.5664 4.39547C14.5555 4.37926 14.5434 4.36403 14.5318 4.34844C14.5222 4.33562 14.5133 4.32241 14.503 4.30989C14.4802 4.28209 14.4562 4.25539 14.4308 4.23001L10.5808 0.379998C10.1555 -0.0452583 9.46606 -0.0452586 9.0408 0.379998C8.61555 0.805255  8.61555 1.49472 9.0408 1.91997L11.0318 3.91101L1.34078 3.91105C0.739381 3.91105 0.251827 4.39861 0.251827 5C0.251827 5.60139 0.739381 6.08895 1.34078 6.08895L11.0318 6.08895L9.04077 8.07999C8.61551 8.50525 8.61551 9.19471 9.04077 9.61997C9.46602 10.0452 10.1555 10.0453 10.5808 9.62L14.4308 5.76999C14.4562 5.74461 14.4802 5.71794 14.5029 5.69019C14.5132 5.6777 14.5221 5.66452 14.5317 5.65164C14.5434 5.63608 14.5555 5.62081 14.5663 5.60461C14.5766 5.58912 14.5856 5.5731 14.5951 5.55722C14.6038 5.5426 14.613 5.52831 14.621 5.51325C14.6297 5.49708 14.6371 5.48041 14.6448 5.46391C14.6522 5.44821 14.6601 5.4328 14.6667 5.41674C14.6734 5.40071 14.6787 5.38433 14.6845 5.36805C14.6907 5.3508 14.6974 5.33376 14.7027 5.31611C14.7076 5.29987 14.7112 5.28334 14.7154 5.26691C14.7199 5.24894 14.7249 5.23114 14.7286 5.21284C14.7323 5.19386 14.7346 5.17473 14.7373 5.15567C14.7396 5.13957 14.7426 5.12377 14.7443 5.10749C14.7477 5.07233 14.7496 5.037 14.7496 5.00166L14.7497 5.00007L14.7496 4.99848C14.7495 4.96318 14.7477 4.92788 14.7443 4.89266C14.7427 4.87631 14.7397 4.8605 14.7374 4.8444Z"
                        fill="black" />
                    </svg>
                </button>
            </div>
        `;


        updateOrderNoteAttributes();
        editAddress();
        changeFrequency();
        backToSubscriptions();
        rebuildBox();
        sendChangePaymentEmail();
        getDiscountDate();
        addDiscount();
        removeDiscount();
        manageAccount();
        refreshDeliveryShowMore();
      }catch (error) {
        console.error(error);
      }
    }

    contractDetails().catch(console.error);

    // Cancel flow binds to static HTML — init independently of contractDetails
    try { initCancelSubscriptionFlow(); } catch (e) { console.error('initCancelSubscriptionFlow error:', e); }

    // Expose for common-theme.js to re-render a subscription card (e.g. after reactivation)
    window._refreshSubscriptionCard = async function(subscriptionId, opts) {
      try {
        const index = allContractDetails.findIndex(c => c.subscriptionContractId === subscriptionId);
        const [subscription, upcoming, history] = await Promise.all([
          getContract(token, subscriptionId),
          getUpcomingBillings(token, subscriptionId),
          getHistory(token, subscriptionId)
        ]);
        // Update cached data
        if (index >= 0) _latestSubscriptions[index] = subscription;
        _invalidateCache();

        const inCsv = false;
        const subscriptionHTML = await updateSubscriptionUI(subscription, upcoming, history, inCsv, index >= 0 ? index : 0);
        const parent = document.querySelector('.acct-panel[data-panel="subscriptions"]');
        const targetSection = parent?.querySelector(`:scope > [data-subscription-id="${subscriptionId}"]`);
        if (targetSection && typeof subscriptionHTML === 'string') {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = subscriptionHTML;
          const newElement = tempDiv.firstElementChild;
          parent.replaceChild(newElement, targetSection);
        } else if (targetSection && parent) {
          parent.replaceChild(subscriptionHTML, targetSection);
        }
        // Reactivation flips CANCELLED→ACTIVE, which changes sort priority and
        // invalidates the displayed #N numbers. Re-sort so the reactivated card
        // moves to the top and _resort renumbers every heading from the DOM.
        // Regular updates don't change status — skip the resort to preserve
        // the original render order (resort would impose id-ascending which
        // doesn't match the initial render and visually swaps cards).
        if (!opts || opts.resort !== false) {
          _resortSubscriptionSections(parent);
        } else {
          // Resort was skipped (regular update); still renumber headings so
          // the replaced card shows its DOM-position number, not whatever
          // index updateSubscriptionUI rendered into the HTML.
          Array.from(parent.querySelectorAll(':scope > [data-subscription-id]')).forEach(function(sec, i) {
            var outerTitle = sec.querySelector('.acct-section__title');
            if (outerTitle) {
              outerTitle.textContent = outerTitle.textContent.replace(/Subscription\s+\d+/, 'Subscription ' + (i + 1));
            }
            var innerName = sec.querySelector('.acct-sub__name');
            if (innerName) {
              var _n = innerName.textContent;
              var _lastIdx = _n.lastIndexOf('#');
              if (_lastIdx !== -1 && /^\d+/.test(_n.slice(_lastIdx + 1))) {
                innerName.textContent = _n.slice(0, _lastIdx) + '#' + (i + 1);
              }
            }
          });
        }
        // Refetch all subs so any-index Overview pick is current, then
        // fan-out centrally.
        try {
          const _freshAll = await Promise.all(
            (allContractDetails || []).map(function (c) {
              return getContract(token, c.subscriptionContractId).catch(function () { return null; });
            })
          );
          _freshAll.forEach(function (s, i) { if (s) _latestSubscriptions[i] = s; });
        } catch (e) {}

        manageAccount();
        refreshDeliveryShowMore();

        _fanOutSubscriptionChange(null, -1);
        // Release Picked-for-you loading and any subscription-section overlays.
        try { if (typeof removeSubscriptionOverlay === 'function') removeSubscriptionOverlay(); } catch (e) {}
      } catch (e) {
        console.warn('_refreshSubscriptionCard error:', e);
      }
    };

    // Re-sort subscription sections by status and update display numbers (#1, #2, ...)
    function _resortSubscriptionSections(parent) {
      if (!parent) return;
      // Direct children of .acct-subs — each is either .acct-subgroup (active)
      // or .acct-section (paused/cancelled). Both carry data-subscription-id.
      var sections = Array.from(parent.querySelectorAll(':scope > [data-subscription-id]'));
      if (sections.length < 2) return;
      function getStatus(sec) {
        // CANCELLED sections have "Reactivate Now" button
        if (sec.querySelector('.reactive-subscription-btn')) return 4;
        // PAUSED sections have "Resume Now" button
        if (sec.querySelector('.resume-subscription-true-btn, .resume-subscription-false-btn')) return 3;
        // Check for "Cancelled" text anywhere in section
        var html = sec.innerHTML;
        if (html.indexOf('>Cancelled<') !== -1) return 4;
        if (html.indexOf('>Paused<') !== -1) return 3;
        // Default: ACTIVE
        return 1;
      }
      sections.sort(function(a, b) {
        var diff = getStatus(a) - getStatus(b);
        if (diff !== 0) return diff;
        // Same status: sort by subscription ID (ascending) to restore original order
        var idA = parseInt(a.getAttribute('data-subscription-id') || '0', 10);
        var idB = parseInt(b.getAttribute('data-subscription-id') || '0', 10);
        return idA - idB;
      });
      sections.forEach(function(sec, i) {
        var _addBtnR = parent.querySelector('.add-subscription-btn');
        if (_addBtnR) parent.insertBefore(sec, _addBtnR);
        else parent.appendChild(sec);
        // Renumber both the outer "Subscription N" .acct-section__title
        // and the inner "📦 #N" .acct-sub__name so DOM order = display order.
        var outerTitle = sec.querySelector('.acct-section__title');
        if (outerTitle) {
          outerTitle.textContent = outerTitle.textContent.replace(/Subscription\s+\d+/, 'Subscription ' + (i + 1));
        }
        var innerName = sec.querySelector('.acct-sub__name');
        if (innerName) {
          var _n = innerName.textContent;
          var _lastIdx = _n.lastIndexOf('#');
          if (_lastIdx !== -1 && /^\d+/.test(_n.slice(_lastIdx + 1))) {
            innerName.textContent = _n.slice(0, _lastIdx) + '#' + (i + 1);
          }
        }
      });
    }

    async function processContracts() {
      const mySubscriptions = document.querySelector('.acct-panel[data-panel="subscriptions"]');
      if (!mySubscriptions) {
          return;
      }

      // --- Render helper (used by both cache and fresh paths) ---
      async function _renderPortal(subscriptions, allUpcoming, allHistory) {
          _latestSubscriptions = subscriptions;
          _latestUpcoming = allUpcoming;
          _latestHistory = allHistory;
          let allSubscriptionsHTML = '';
          if(subscriptions.length){
            function getSubscriptionSortPriority(subscription) {
              const status = subscription.status;
              const customAttributes = subscription.customAttributes || [];
              const resumeDate = customAttributes.find(attr => attr.key === "Resume date")?.value || '';
              const nextBillingDate = subscription.nextBillingDate;

              if (status === "ACTIVE") {
                if (!resumeDate ||
                    (new Date(resumeDate).toDateString() === new Date(nextBillingDate).toDateString() &&
                    new Date() > new Date(nextBillingDate))) {
                  return 1;
                }
                return 2;
              }
              if (status === "PAUSED") return 3;
              if (status === "CANCELLED") return 4;
              return 5;
            }

            const indexedSubscriptions = subscriptions.map((sub, idx) => ({
              subscription: sub,
              upcoming: allUpcoming[idx],
              history: allHistory[idx],
              inCsv: false,
              originalIndex: idx,
              sortPriority: getSubscriptionSortPriority(sub),
            }));

            indexedSubscriptions.sort((a, b) => a.sortPriority - b.sortPriority);

            // Only hide CANCELLED subscriptions with the flag. ACTIVE/PAUSED
            // always show — the flag can linger from a prior cancel→reactivate
            // cycle and must not suppress a live subscription.
            const visibleSubscriptions = indexedSubscriptions.filter(item => {
              if (item.subscription.status !== 'CANCELLED') return true;
              const attrs = item.subscription.customAttributes || [];
              const isHidden = attrs.find(attr => attr.key === "_hidden_subscription")?.value === "true";
              return !isHidden;
            });

            const finalVisible = visibleSubscriptions.length > 0 ? visibleSubscriptions : [indexedSubscriptions[0]];
            const totalVisibleCount = finalVisible.length;

            const htmlParts = await Promise.all(
                finalVisible.map((item, displayIndex) =>
                    updateSubscriptionUI(
                      item.subscription,
                      item.upcoming,
                      item.history,
                      item.inCsv,
                      item.originalIndex,
                      totalVisibleCount,
                      displayIndex + 1,
                      allContractDetails
                    )
                )
            );
            allSubscriptionsHTML = htmlParts.join('');
          }
          if(allSubscriptionsHTML == ''){
            allSubscriptionsHTML = `
            <div class="empty-subscriptions">
              <h3>You don't have an active subscription</h3>
            </div>
            `;
          }else{
            const addSubBtn = document.querySelector('.add-subscription-btn');
            if (addSubBtn) {
              addSubBtn.classList.remove('hidden');
              addSubBtn.href = `/pages/new-step-1-suburb?token=${token}`;
            }
          }

          // Remove any prior subscription wrappers + loading placeholder,
          // then insert the freshly-rendered HTML before the Add Another
          // Subscription button so the panel keeps its h1 + button chrome.
          Array.from(mySubscriptions.querySelectorAll(':scope > [data-subscription-id], :scope > [data-loading-placeholder]')).forEach(function (el) { el.remove(); });
          const _addBtn = mySubscriptions.querySelector('.add-subscription-btn');
          if (_addBtn) _addBtn.insertAdjacentHTML('beforebegin', allSubscriptionsHTML);
          else mySubscriptions.insertAdjacentHTML('beforeend', allSubscriptionsHTML);

          renderOverviewSubscription(subscriptions, allContractDetails);
          renderOrderHistoryTab(subscriptions, allHistory, allContractDetails);
          getHistoryData(allHistory,allContractDetails,subscriptions);
          updateOrderNoteAttributes();
          editAddress();
          editExclude(subscriptions);
          updateResumeDay();

          sendChangePaymentEmail();
          manageSubscription(subscriptions);
          changeFrequency();
          getDiscountDate();
          addDiscount();
          removeDiscount();
          resumeSubscription(subscriptions);
          reactiveSubscription();

          goToEditPage();
          skipOrder();
          unskipOrder();
          manageAccount();
          refreshDeliveryShowMore();
          hideSubscription();
      }

      try {
          // --- Check sessionStorage cache (already read at top level) ---
          if (__cachedPortal && __cachedPortal.subscriptions?.length) {
            await _renderPortal(__cachedPortal.subscriptions, __cachedPortal.upcoming, __cachedPortal.history);

            // Background refresh — update cache silently
            (async () => {
              try {
                const freshContracts = await getAllContractDetails(token);
                const [freshSubs, freshUp, freshHist] = await Promise.all([
                  Promise.all(freshContracts.map(c => getContract(token, c.subscriptionContractId))),
                  Promise.all(freshContracts.map(c => getUpcomingBillings(token, c.subscriptionContractId))),
                  Promise.all(freshContracts.map(c => getHistory(token, c.subscriptionContractId))),
                ]);
                _writeCache(freshContracts, freshSubs, freshUp, freshHist);
                allContractDetails = freshContracts;

                // If ANY difference detected between cached and fresh, re-render.
                // The prior length + status + line-count heuristic missed common
                // edits (qty changes, product swaps that keep line count the
                // same, next billing date, payment method, exclusions) → Overview
                // stayed on cached stale data while Subscriptions tab rendered
                // from fresh internal state, so tabs disagreed.
                function _diffKey(subs) {
                  try {
                    return JSON.stringify((subs || []).map(function (s) {
                      return {
                        id: s.id,
                        status: s.status,
                        nb: s.nextBillingDate,
                        pmId: s.customerPaymentMethod?.id,
                        lines: (s.lines?.nodes || []).map(function (n) {
                          return [n.variantId || n.id, n.quantity, n.currentPrice?.amount].join(':');
                        }),
                        attrs: (s.customAttributes || []).map(function (a) { return a.key + '=' + a.value; })
                      };
                    }));
                  } catch (e) { return String(Math.random()); }
                }
                const changed = _diffKey(__cachedPortal.subscriptions) !== _diffKey(freshSubs);
                if (changed) {
                  __cachedPortal.subscriptions = freshSubs;
                  __cachedPortal.upcoming = freshUp;
                  __cachedPortal.history = freshHist;
                  await _renderPortal(freshSubs, freshUp, freshHist);
                }
              } catch (e) { console.error('Background refresh failed:', e); }
            })();
            return;
          }

          // --- Cold path: fetch from API (using preload or direct) ---
          let subscriptions, allUpcoming, allHistory;
          try {
            if (window.__portalSubscriptions && window.__portalUpcoming && window.__portalHistory) {
              [subscriptions, allUpcoming, allHistory] = await Promise.all([
                window.__portalSubscriptions,
                window.__portalUpcoming,
                window.__portalHistory,
              ]);
            } else {
              throw new Error('preload not available');
            }
          } catch (_preloadErr) {
            // Preload chain rejected — likely Appstle is congested/rate-limiting.
            // Wait briefly so the limit window can pass, then run fallback
            // requests with a small concurrency cap (3) instead of firing
            // 3×N requests in parallel.
            await _sleep(_backoffDelay());
            const _LIMIT = 3;
            [subscriptions, allUpcoming, allHistory] = await Promise.all([
              _runWithLimit(allContractDetails, _LIMIT, c => getContract(token, c.subscriptionContractId)),
              _runWithLimit(allContractDetails, _LIMIT, c => getUpcomingBillings(token, c.subscriptionContractId)),
              _runWithLimit(allContractDetails, _LIMIT, c => getHistory(token, c.subscriptionContractId)),
            ]);
          }

          await _renderPortal(subscriptions, allUpcoming, allHistory);
          _writeCache(allContractDetails, subscriptions, allUpcoming, allHistory);
      } catch (error) {
          console.error(error);
      }
    }

    processContracts().catch(console.error);

    function updateResumeDay() {
      if (_registeredListeners.has('updateResumeDay')) return; _registeredListeners.add('updateResumeDay');
      document.addEventListener('click', async function(event) {
        const updateResumeDayPopupWrap = document.querySelector('.delivery-update-pop-up');
        const item = event.target.closest('.detail-item.paused');
        if(item){
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const index = parseInt(item.getAttribute('data-index'), 10);
          const findIndex = parseInt(item.getAttribute('data-limit-week'), 10);
          const checkDay = parseInt(item.getAttribute('data-checkday'), 10);
          const billingWeekDay = parseInt(item.getAttribute('data-billing-week'), 10);

          const previousDate = item.getAttribute('data-previous-date');
          updateResumeDayPopupWrap.setAttribute('data-subscription-id', subscriptionId);
          updateResumeDayPopupWrap.setAttribute('data-index', index);
          updateResumeDayPopupWrap.setAttribute('data-previous-date', previousDate);
          updateResumeDayPopupWrap.setAttribute('data-findindex', findIndex);
          updateResumeDayPopupWrap.setAttribute('data-checkday', checkDay);

          updateResumeDayPopupWrap.setAttribute('data-billing-week', billingWeekDay);

        }

        const updateResumeDateBtn = event.target.closest('.update-resume-date-btn');
        if(updateResumeDateBtn){

          const contentWrap = updateResumeDateBtn.closest('.pop-content-bottom');
          const subscriptionId = parseInt(updateResumeDayPopupWrap.getAttribute('data-subscription-id'), 10);
          const index = parseInt(updateResumeDayPopupWrap.getAttribute('data-index'), 10);
          const findIndex = parseInt(updateResumeDayPopupWrap.getAttribute('data-findindex'), 10);
          const checkDay = parseInt(updateResumeDayPopupWrap.getAttribute('data-checkday'), 10);

          const previousDate = updateResumeDayPopupWrap.getAttribute('data-previous-date');
          const billingWeekDay = updateResumeDayPopupWrap.getAttribute('data-billing-week');
          const selectDate = contentWrap.getAttribute('data-select-date') || previousDate;
          if(selectDate != previousDate){
            updateResumeDateBtn.classList.add('loading');
            try{


              const inCsv = false;
              let newBillingDate;
              const { date: date } = getBillingDateFromDelivery(selectDate, billingWeekDay, checkDay);
              newBillingDate = date;
              const formatedNewBillingDate = new Date(newBillingDate).toISOString().split('T')[0];
              const dateString = `${formatedNewBillingDate}T11:00:00Z`;

              // Appstle's update-custom-note-attributes API always does full
              // replace regardless of `overwriteExistingAttributes` flag, so the
              // merge base MUST be the latest server state; using a stale local
              // `_latestSubscriptions[index]` silently drops keys on the server.
              const freshSub = await getContract(token, subscriptionId);
              const oldNoteAttributes = freshSub?.customAttributes || [];

              const newAttribute = {
                  key: "Resume date",
                  value: formatedNewBillingDate,
              };
              const orderNoteBody = mergeAttributes(oldNoteAttributes, newAttribute, subscriptionId);

              const [update_1, update_2] = await Promise.all([
                updateNoteAttributesApi(token, orderNoteBody),
                updateNextBillingDate(token, subscriptionId, dateString)
              ]);
              if (_latestSubscriptions[index]) {
                _latestSubscriptions[index].customAttributes = _mergeCustomAttrs(oldNoteAttributes, newAttribute);
                _latestSubscriptions[index].nextBillingDate = dateString;
              }
              _invalidateCache();
              const d1 = newFormatDateToDay(selectDate);
              const d2 = newFormatDateToDay(formatedNewBillingDate);
              const d1Wrap = document.querySelector('.paused--date[data-subscription-id="' + subscriptionId + '"]');
              const d2Wrap = document.querySelector('.next-billing--date[data-subscription-id="' + subscriptionId + '"]');
              const item = document.querySelector('.detail-item.paused[data-subscription-id="' + subscriptionId + '"]');
              item.setAttribute('data-previous-date', selectDate);

              d1Wrap.textContent = d1;
              d2Wrap.textContent = d2;
              updateResumeDayPopupWrap.classList.remove('is-active');
              updateResumeDateBtn.classList.remove('loading');

            } catch (error) {
              console.error('updateResumeDay error:', error);
              updateResumeDateBtn.classList.remove('loading');
              showToast("Failed to update resume date. Please try again.", 5000);
            }
          }else{
            updateResumeDayPopupWrap.classList.remove('is-active');
          }




        }
      });

    }



    function rebuildBox() {
      if (_registeredListeners.has('rebuildBox')) return; _registeredListeners.add('rebuildBox');
      document.addEventListener('click', async function(event) {
        const item = event.target.closest('.rebuild-box-btn');
        if(item){
          item.classList.add('loading');
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          window.location = `/pages/step-2-choose-your-box?token=${customerToken}&subscriptionId=${subscriptionId}&id=1&rebuild=true`;
        }
      });
    }

    function backToSubscriptions() {
      if (_registeredListeners.has('backToSubscriptions')) return; _registeredListeners.add('backToSubscriptions');
      document.addEventListener('click', async function(event) {
        const item = event.target.closest('.account-subscription-back');
        if(item){
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          window.location = `/pages/customer-portal-new?token=${customerToken}`;
        }
      });
    }

    function hideSubscription() {
      if (_registeredListeners.has('hideSubscription')) return; _registeredListeners.add('hideSubscription');
      let pendingHideBtn = null;

      function getPopup() {
        return document.querySelector('.delivery-hide-subscription-pop-up');
      }

      document.addEventListener('click', async function(event) {
        // Step 1: Click delete button -> open custom confirm popup
        const hideBtn = event.target.closest('.btn-hide-subscription');
        if (hideBtn) {
          const visibleSections = document.querySelectorAll('.acct-panel[data-panel="subscriptions"] > [data-subscription-id]');
          if (visibleSections.length <= 1) {
            showToast("You must keep at least one subscription visible.", 5000);
            return;
          }
          const hidePopupWrap = getPopup();
          if (!hidePopupWrap) return;
          pendingHideBtn = hideBtn;
          // Reset radio selection each time popup opens
          hidePopupWrap.querySelectorAll('input[name="hide_subscription"]').forEach(r => r.checked = false);
          hidePopupWrap.classList.add('is-active');
          return;
        }

        // Step 2: Click cancel or close -> close popup
        const hidePopupWrap = getPopup();
        const cancelBtn = event.target.closest('.hide-subscription-cancel-btn');
        const closeIcon = hidePopupWrap?.contains(event.target) && event.target.closest('.icon-close');
        if (cancelBtn || closeIcon) {
          hidePopupWrap.classList.remove('is-active');
          pendingHideBtn = null;
          return;
        }

        // Step 3: Click confirm -> check radio and perform hide
        const confirmBtn = event.target.closest('.hide-subscription-confirm-btn');
        if (confirmBtn && pendingHideBtn) {
          const selectedRadio = hidePopupWrap.querySelector('input[name="hide_subscription"]:checked');
          if (!selectedRadio) {
            showToast("Please select an option.", 5000);
            return;
          }
          if (selectedRadio.value === 'no') {
            hidePopupWrap.classList.remove('is-active');
            pendingHideBtn = null;
            return;
          }

          // User selected "yes"
          hidePopupWrap.classList.remove('is-active');
          const currentHideBtn = pendingHideBtn;
          pendingHideBtn = null;

          const subscriptionId = parseInt(currentHideBtn.getAttribute('data-subscription-id'), 10);
          currentHideBtn.classList.add('loading');

          try {
            // Persist the hidden flag as a custom attribute on the subscription.
            // Appstle's API always replaces the full customAttributes list, so
            // we re-fetch the latest server state before building the body —
            // using the local `_latestSubscriptions` cache risks silently
            // wiping keys (see the attribute-loss investigation).
            const _hideIndex = allContractDetails.findIndex(c => c.subscriptionContractId === subscriptionId);
            const freshSub = await getContract(token, subscriptionId);
            const oldNoteAttributes = freshSub?.customAttributes || [];
            const newAttribute = {
              key: "_hidden_subscription",
              value: "true",
            };
            const orderNoteBody = mergeAttributes(oldNoteAttributes, newAttribute, subscriptionId);
            await updateNoteAttributesApi(token, orderNoteBody);
            if (_hideIndex >= 0 && _latestSubscriptions[_hideIndex]) {
              _latestSubscriptions[_hideIndex].customAttributes = _mergeCustomAttrs(oldNoteAttributes, newAttribute);
            }
            _invalidateCache();

            // Remove the element from DOM
            const section = currentHideBtn.closest('.subscription-section');
            if (section) {
              section.style.transition = 'opacity 0.3s ease';
              section.style.opacity = '0';
              setTimeout(() => {
                section.remove();

                // After removal, check remaining sections
                const remaining = document.querySelectorAll('.acct-panel[data-panel="subscriptions"] > [data-subscription-id]');
                if (remaining.length <= 1) {
                  remaining.forEach(sec => {
                    const btn = sec.querySelector('.btn-hide-subscription');
                    if (btn) btn.remove();
                  });
                }

                if (remaining.length === 0) {
                  const wrapper = document.querySelector('.acct-panel[data-panel="subscriptions"]');
                  wrapper.innerHTML = `
                    <div class="empty-subscriptions">
                      <h3>You don't have an active subscription</h3>
                    </div>
                  `;
                }
              }, 300);
            }
          } catch (error) {
            console.error('Error hiding subscription:', error);
            currentHideBtn.classList.remove('loading');
            showToast("Failed to remove subscription. Please try again.", 5000);
          }
        }
      });
    }
    function reactiveSubscription() {
      if (_registeredListeners.has('reactiveSubscription')) return; _registeredListeners.add('reactiveSubscription');
      document.addEventListener('click', async function(event) {
        const item = event.target.closest('.reactive-subscription-btn');
        if(item){
          if (item.dataset.pending === '1') return;
          item.dataset.pending = '1';
          item.disabled = true;
          item.innerHTML = '<span>Reactivating\u2026</span><span class="btn-inline-spinner" aria-hidden="true"></span>';
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          // Pre-cache subscription data so detail page can skip getContract
          const index = allContractDetails.findIndex(c => c.subscriptionContractId === subscriptionId);
          if (index >= 0 && _latestSubscriptions[index]) {
            try {
              sessionStorage.setItem('_detailPageContract', JSON.stringify(_latestSubscriptions[index]));
            } catch(e) {}
          }
          window.location = `/pages/customer-portal-details-new?token=${customerToken}&subscription_id=${subscriptionId}&id=1`;
        }
      });
    }
    function sendChangePaymentEmail() {
      if (_registeredListeners.has('sendChangePaymentEmail')) return; _registeredListeners.add('sendChangePaymentEmail');
      document.addEventListener('click', async function(event) {
        const paymentPopupWrap = document.querySelector('.delivery-payment-pop-up');
        const item = event.target.closest('.setting-item.payment-method');
        if(item){
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          paymentPopupWrap.setAttribute('data-subscription-id', subscriptionId);
        }

        const changePaymentMethodBtn = event.target.closest('.change-payment-method-btn');
        if (changePaymentMethodBtn) {
          const subscriptionId = parseInt(paymentPopupWrap.getAttribute('data-subscription-id'), 10);
          changePaymentMethodBtn.classList.add('loading');
          try {
            // 1) Try direct URL via Worker (uses Shopify Admin
            //    customerPaymentMethodGetUpdateUrl). If we get a URL,
            //    redirect the customer straight to the hosted update
            //    page — no email step needed.
            const WORKER_URL = (window.themeApiConfig && window.themeApiConfig.workerUrl)
              || 'https://funkyfood-subscription-worker.janfemac1122.workers.dev';
            const c = window.__ffCustomer || {};
            const sub = (_latestSubscriptions || []).find(function (s) {
              return s && parseInt(String(s.id || '').split('/').pop(), 10) === subscriptionId;
            });
            const paymentMethodId = sub && sub.customerPaymentMethod && sub.customerPaymentMethod.id;
            if (c.numericId && c.email && paymentMethodId) {
              const r = await fetch(WORKER_URL + '/api/payment-update-link', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  customerId: String(c.numericId),
                  currentEmail: c.email,
                  paymentMethodId: paymentMethodId
                })
              });
              const body = await r.json().catch(function () { return null; });
              if (r.ok && body && body.ok && body.url) {
                window.location.href = body.url;
                return;
              }
              // If Worker responded ok + emailSent, Shopify already sent
              // the update-payment email — fall through to success state
              // so the "check your inbox" wrapper-text shows.
              if (r.ok && body && body.ok && body.emailSent) {
                paymentPopupWrap.querySelector('.wrapper-text').classList.add('active');
                changePaymentMethodBtn.classList.remove('loading');
                return;
              }
              // Otherwise fall through to the legacy Appstle email flow.
            }

            // 2) Fallback: legacy Appstle "send update email" endpoint.
            await changePaymentMethod(token, subscriptionId);
            paymentPopupWrap.querySelector('.wrapper-text').classList.add('active');
            changePaymentMethodBtn.classList.remove('loading');
          } catch (error) {
            console.error('changePaymentMethod error:', error);
            changePaymentMethodBtn.classList.remove('loading');
            showToast("Failed to update payment method. Please try again.", 5000);
          }
        }
      });
    }
    function editExclude(subscriptions) {
      _latestSubscriptions = subscriptions;
      if (_registeredListeners.has('editExclude')) return; _registeredListeners.add('editExclude');
      document.addEventListener('click', async function(event) {
        const excludePopupWrap = document.querySelector('.delivery-exclude-pop-up');

        const topItem = event.target.closest('.top-edit-exclude-btn');
        if (topItem) {
          const subscriptionWrap = topItem.closest('.acct-subgroup') || topItem.closest('.subscription-section');
          const eventItem = subscriptionWrap.querySelector('.setting-item.exclude');
          if(eventItem){
            const subscriptionId = parseInt(eventItem.getAttribute('data-subscription-id'), 10);
            const index = parseInt(eventItem.getAttribute('data-index'), 10);

            const idsStr = eventItem.getAttribute('data-ids');
            const excludeStr = eventItem.getAttribute('data-excluding') || '';
            const excludeArr = excludeStr ? excludeStr.split(', ') : [];
            const subscriptionProducts = _latestSubscriptions[index]?.lines?.nodes || [];

            const overlay = document.querySelector('.cart-modal-overlay');
            const boxIds = overlay?.dataset.ids
              ? overlay.dataset.ids.split(',').map(id => id.trim()).filter(Boolean)
              : [];

            const itemsWithBoxItems = subscriptionProducts?.filter(item => {
              const numericId = item.productId.split('/').pop();
              return boxIds.includes(numericId);
            });
            const boxItems = itemsWithBoxItems
                .flatMap(item => item.customAttributes)
                .find(attr => attr.key === "Box items")?.value || null;
            excludePopupWrap.setAttribute('data-subscription-id', subscriptionId);
            excludePopupWrap.setAttribute('data-gids', idsStr);
            excludePopupWrap.setAttribute('data-box-items', boxItems);
            excludePopupWrap.setAttribute('data-excluding', excludeStr);

            const tagsWrap = excludePopupWrap.querySelector('.account-is-exclude-tags');
            excludePopupWrap.querySelectorAll('.account-exclude .drop-option').forEach(option => {
              if(excludeArr.length >= 10){
                option.classList.add('disabled');
              }else{
                option.classList.remove('disabled');
              }
              option.querySelector('input').checked = false;
            });
            let tags = '';
            excludeArr.forEach(item => {
                const checkbox = excludePopupWrap.querySelector(`.account-exclude input[value="${item}"]`);
                if (checkbox) {
                    checkbox.checked = true;
                    const dropOption = checkbox.closest('.drop-option');
                    dropOption.classList.remove('disabled');
                }
                tags += `
                  <div class="tag" data-value="${item}">
                    <span>${item}</span>
                    <span class="cross">
                      <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.51321 1.54593L0.913547 8.14559M0.913547 1.54593L7.51321 8.14559" stroke="#1B1C1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                    </span>
                  </div>
                `;
            });
            tagsWrap.innerHTML = tags;

          }
        }
        
        const item = event.target.closest('.setting-item.exclude');
        if(item){
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const index = parseInt(item.getAttribute('data-index'), 10);

          const idsStr = item.getAttribute('data-ids');
          const excludeStr = item.getAttribute('data-excluding') || '';
          const excludeArr = excludeStr ? excludeStr.split(', ') : [];
          const subscriptionProducts = _latestSubscriptions[index]?.lines?.nodes || [];
          const overlay = document.querySelector('.cart-modal-overlay');
          const boxIds = overlay?.dataset.ids
            ? overlay.dataset.ids.split(',').map(id => id.trim()).filter(Boolean)
            : [];

          const itemsWithBoxItems = subscriptionProducts?.filter(item => {
            const numericId = item.productId.split('/').pop();
            return boxIds.includes(numericId);
          });
          const boxItems = itemsWithBoxItems
              .flatMap(item => item.customAttributes)
              .find(attr => attr.key === "Box items")?.value || null;
          excludePopupWrap.setAttribute('data-subscription-id', subscriptionId);
          excludePopupWrap.setAttribute('data-gids', idsStr);
          excludePopupWrap.setAttribute('data-box-items', boxItems);
          excludePopupWrap.setAttribute('data-excluding', excludeStr);

          const tagsWrap = excludePopupWrap.querySelector('.account-is-exclude-tags');
          excludePopupWrap.querySelectorAll('.account-exclude .drop-option').forEach(option => {
            if(excludeArr.length >= 10){
              option.classList.add('disabled');
            }else{
              option.classList.remove('disabled');
            }
            option.querySelector('input').checked = false;
          });
          let tags = '';
          excludeArr.forEach(item => {
              const checkbox = excludePopupWrap.querySelector(`.account-exclude input[value="${item}"]`);
              
              if (checkbox) {
                  checkbox.checked = true;
                  const dropOption = checkbox.closest('.drop-option');
                  dropOption.classList.remove('disabled');
              }
              tags += `
                <div class="tag" data-value="${item}">
                  <span>${item}</span>
                  <span class="cross">
                    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.51321 1.54593L0.913547 8.14559M0.913547 1.54593L7.51321 8.14559" stroke="#1B1C1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                  </span>
                </div>
              `;
          });
          tagsWrap.innerHTML = tags;
        }

        const changeExcludeBtn = event.target.closest('.change-exclude-btn');
        if(changeExcludeBtn){
          const subscriptionId = parseInt(excludePopupWrap.getAttribute('data-subscription-id'), 10);

          const excludeStr = excludePopupWrap.getAttribute('data-excluding') || '';
          const excludeArr = excludeStr ? excludeStr.split(', ') : [];

          const selectedCheckboxes = excludePopupWrap.querySelectorAll('.account-exclude input[type="checkbox"]:checked');
          const legacyValues = Array.from(excludePopupWrap.querySelectorAll('.account-is-exclude-tags .tag[data-value]')).map(tag=>tag.getAttribute('data-value')).filter(name=>!Array.from(excludePopupWrap.querySelectorAll('.account-exclude input')).some(input=>input.value===name));
          const selectedValues = Array.from(new Set([...legacyValues,...Array.from(selectedCheckboxes).map(checkbox => checkbox.value)]));
          const arraysEqual = (arr1, arr2) =>
              JSON.stringify([...arr1].sort()) === JSON.stringify([...arr2].sort());
          if(arraysEqual(excludeArr, selectedValues)){
            excludePopupWrap.classList.remove('is-active');
          }else{
            changeExcludeBtn.classList.add('loading');

            const excludeAccordion = document.querySelector('.setting-item.exclude[data-subscription-id="' + subscriptionId + '"]');
            const oldExcludingAttr = excludeAccordion ? excludeAccordion.getAttribute('data-excluding') : null;
            const oldAccordionText = excludeAccordion ? excludeAccordion.querySelector('.setting-item__text p').textContent : null;

            const selectedValuesStr = selectedValues.join(', ');
            const displayText = selectedValuesStr === '' ? 'None' : selectedValuesStr;

            const updatePromise = window.FFSubscriptionPreferences.save(token,subscriptionId,selectedValues,(excludePopupWrap.getAttribute('data-gids') || '').split(',').map(v=>v.trim()).filter(Boolean));

            // Hold the loading state briefly so users see feedback, then close.
            await new Promise(resolve => setTimeout(resolve, 400));
            changeExcludeBtn.classList.remove('loading');
            excludePopupWrap.classList.remove('is-active');

            // Optimistic UI.
            if (excludeAccordion) {
              excludeAccordion.setAttribute('data-excluding', selectedValuesStr);
              excludeAccordion.querySelector('.setting-item__text p').textContent = displayText;
            }

            updatePromise.then(function () {
              _invalidateCache();
            }).catch(function (error) {
              console.error('editExclude subscription write failed', error);
              if (excludeAccordion) {
                excludeAccordion.setAttribute('data-excluding', oldExcludingAttr || '');
                excludeAccordion.querySelector('.setting-item__text p').textContent = oldAccordionText;
              }
              showToast("Failed to update exclusions. Please try again.", 5000);
            });
          }
        }
      });
    }
    // Overlay + lock helpers for optimistic popup-close flows (address / frequency /
    // discount). While the background API call runs, the trigger setting-item shows
    // a spinner in its icon-arrow and clicks are swallowed in capture phase.
    function _showDeliveryUpdatingOverlay(subscriptionId) {
      const deliveryWrap = document.querySelector('.acct-subgroup[data-subscription-id="' + subscriptionId + '"] .delivery-items') || document.querySelector('.subscription-section[data-subscription-id="' + subscriptionId + '"] .delivery-items');
      if (!deliveryWrap || deliveryWrap.querySelector('.frequency-updating-overlay')) return;
      deliveryWrap.style.position = 'relative';
      deliveryWrap.insertAdjacentHTML('beforeend', '<div class="frequency-updating-overlay" style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(255,255,255,0.85);z-index:10;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;font-size:14px;font-weight:600;border-radius:8px;min-height:80px;"><svg width="24" height="24" viewBox="0 0 24 24" style="animation:spin 1s linear infinite"><style>@keyframes spin{to{transform:rotate(360deg)}}</style><circle cx="12" cy="12" r="10" stroke="#333" stroke-width="3" fill="none" stroke-dasharray="31.4 31.4" stroke-linecap="round"/></svg><span>Updating&hellip; you can safely leave this page.</span></div>');
    }
    function _hideDeliveryUpdatingOverlay(subscriptionId) {
      // .frequency-updating-overlay lives inside .delivery-items which is in
      // the sibling .subscription-contents__deliveries card (post 3-card split).
      const wrap = document.querySelector('.acct-subgroup[data-subscription-id="' + subscriptionId + '"]')
                || document.querySelector('.subscription-section[data-subscription-id="' + subscriptionId + '"]');
      const overlay = wrap?.querySelector('.frequency-updating-overlay');
      if (overlay) overlay.remove();
    }
    function _lockSettingItem(item) { if (item) item.classList.add('is-locked'); }
    function _unlockSettingItem(item) { if (item) item.classList.remove('is-locked'); }
    // Inline toast creation — independent of cart-modal-slider's showToast so
    // any scope/load-order issue can't silently drop the lock-guard message.
    function _showUpdatingToast() {
      const container = document.getElementById('toast-container');
      if (!container) return;
      const toast = document.createElement('p');
      toast.className = 'toast';
      toast.textContent = 'Updating… you can safely leave this page.';
      toast.style.setProperty('background-color', '#FECE00', 'important');
      container.appendChild(toast);
      setTimeout(() => toast.remove(), 3500);
    }
    // Capture-phase guard: a locked setting-item swallows the click so neither
    // the popup-open (script.js per-item listener) nor the data-populate
    // (document bubble listeners here) handlers run. A toast explains why.
    function _setupSettingItemLockGuard() {
      if (_registeredListeners.has('settingItemLockGuard')) return;
      _registeredListeners.add('settingItemLockGuard');
      document.addEventListener('click', function(e) {
        const locked = e.target.closest('.setting-item.is-locked');
        if (!locked) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        _showUpdatingToast();
      }, true);
    }
    _setupSettingItemLockGuard();
    // Preserve expansion state (Settings + Order History) across full-section
    // DOM replacement, so the collapsible panel the user just interacted with
    // doesn't snap shut when the fresh card renders.
    function _captureSectionUIState(section) {
      if (!section) return null;
      return {
        settingsActive: !!section.querySelector('.settings__title.active'),
        historyActive: !!section.querySelector('.order-history__title.active'),
      };
    }
    function _restoreSectionUIState(section, state) {
      if (!section || !state) return;
      if (state.settingsActive) {
        section.querySelector('.settings__title')?.classList.add('active');
        const items = section.querySelector('.settings__items');
        if (items) items.style.display = 'block';
      }
      if (state.historyActive) {
        section.querySelector('.order-history__title')?.classList.add('active');
        const items = section.querySelector('.order-history__items');
        if (items) items.style.display = 'block';
      }
    }

    function editAddress() {
      if (_registeredListeners.has('editAddress')) return; _registeredListeners.add('editAddress');
      document.addEventListener('click', async function(event) {
        const addressPopupWrap = document.querySelector('.delivery-information-pop-up');
        if (!addressPopupWrap) return;
        addressPopupWrap.classList.remove('error');
        const item = event.target.closest('.setting-item.delivery-info');
        if(item){
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const index = parseInt(item.getAttribute('data-index'), 10);
          const firstName = item.getAttribute('data-firstname');
          const lastName = item.getAttribute('data-lastname');
          const phone = item.getAttribute('data-phone');
          const address1 = item.getAttribute('data-address1');
          const address2 = item.getAttribute('data-address2');
          const suburb = item.getAttribute('data-suburb');
          const state = item.getAttribute('data-state');
          const postcode = item.getAttribute('data-postcode');
          const instructions = item.getAttribute('data-instructions');
          addressPopupWrap.setAttribute('data-subscription-id', subscriptionId);
          addressPopupWrap.setAttribute('data-index', index);
          addressPopupWrap.querySelector('input[name="firstname"]').value = firstName;
          addressPopupWrap.querySelector('input[name="lastname"]').value = lastName;
          addressPopupWrap.querySelector('input[name="phone"]').value = phone;
          addressPopupWrap.querySelector('input[name="address1"]').value = address1;
          addressPopupWrap.querySelector('input[name="address2"]').value = address2;
          addressPopupWrap.querySelector('input[name="suburb"]').value = suburb;
          addressPopupWrap.querySelector('input[name="state"]').value = state;
          const stateList = addressPopupWrap.querySelector('.state-list').querySelectorAll('li');
          stateList.forEach(li => {
            if(li.textContent == state){
              li.classList.add('active');
            }else{
              li.classList.remove('active');
            }
          });
          addressPopupWrap.querySelector('input[name="postcode"]').value = postcode;
          addressPopupWrap.querySelector('textarea[name="instructions"]').value = instructions;
        }
        const editAddressBtn = event.target.closest('.edit-shipping-address-btn');
        if(editAddressBtn){
          if(addressPopupWrap.classList.contains('error')){
            showToast("Delivery not available at this suburb :)",5000);
          }else{
            const subscriptionId = parseInt(addressPopupWrap.getAttribute('data-subscription-id'), 10);
            const index = parseInt(addressPopupWrap.getAttribute('data-index'), 10);

            const firstName = addressPopupWrap.querySelector('input[name="firstname"]').value;
            const lastName = addressPopupWrap.querySelector('input[name="lastname"]').value;
            const phone = addressPopupWrap.querySelector('input[name="phone"]').value;
            const address1 = addressPopupWrap.querySelector('input[name="address1"]').value;
            const address2 = addressPopupWrap.querySelector('input[name="address2"]').value;
            const suburb = addressPopupWrap.querySelector('input[name="suburb"]').value;
            const state = addressPopupWrap.querySelector('input[name="state"]').value;
            const postcode = addressPopupWrap.querySelector('input[name="postcode"]').value;
            const instructions = addressPopupWrap.querySelector('textarea[name="instructions"]').value;

            addressPopupWrap.classList.remove('is-active');

            const deliveryInfoItem = document.querySelector('.setting-item.delivery-info[data-subscription-id="' + subscriptionId + '"]');
            // Only the address proper affects the delivery zone/date. Name/phone/
            // instructions changes don't — so skip the "Updating…" overlay and the
            // full section rebuild in that case.
            const _norm = v => (v == null ? '' : String(v)).trim();
            const addressChanged = (
              _norm(deliveryInfoItem?.getAttribute('data-address1')) !== _norm(address1) ||
              _norm(deliveryInfoItem?.getAttribute('data-address2')) !== _norm(address2) ||
              _norm(deliveryInfoItem?.getAttribute('data-suburb'))   !== _norm(suburb)   ||
              _norm(deliveryInfoItem?.getAttribute('data-state'))    !== _norm(state)    ||
              _norm(deliveryInfoItem?.getAttribute('data-postcode')) !== _norm(postcode)
            );
            _lockSettingItem(deliveryInfoItem);
            if (addressChanged) {
              _showDeliveryUpdatingOverlay(subscriptionId);
            }

            const payload = {
              methodType: "SHIPPING",
              firstName: firstName,
              lastName: lastName,
              company: "",
              address1: address1,
              address2: address2,
              city: suburb,
              provinceCode: state,
              countryCode: "AU",
              zip: postcode,
              phone: phone
            };

            (async () => {
              try{

                const update = await updateCustomerAddress(payload, token, subscriptionId);

                const subscription = await getContract(token, subscriptionId);
                const oldNoteAttributes = subscription.customAttributes;
                let newAttribute = [
                    {
                        key: "Delivery Instructions",
                        value: instructions,
                    }
                ];
                // Widened for 3-card split — .success-upcoming-order lives in the
                // sibling deliveries card, not inside the article. Use the outer
                // .acct-subgroup wrapper (fall back to article for cancelled subs).
                const subscriptionSection = document.querySelector(
                    `.acct-subgroup[data-subscription-id="${subscriptionId}"]`
                ) || document.querySelector(
                    `.subscription-section[data-subscription-id="${subscriptionId}"]`
                );

                if (subscriptionSection) {
                    const successOrderElement = subscriptionSection.querySelector('.success-upcoming-order');
                    if (successOrderElement) {
                        const orderId = successOrderElement.getAttribute('data-order-id');
                        const day = successOrderElement.getAttribute('data-day');
                        if (orderId && day) {
                            newAttribute.push({
                                key: `order_id_is_${orderId}`,
                                value: day,
                            });
                        }

                    }
                }
                const orderNoteBody = mergeAttributes(oldNoteAttributes, newAttribute, subscriptionId);
                const updateInstructions = await updateNoteAttributesApi(token, orderNoteBody);
                _invalidateCache();
                const addressAccordion = document.querySelector('.setting-item.delivery-info[data-subscription-id="' + subscriptionId + '"]');
                if (addressAccordion) {
                  addressAccordion.setAttribute('data-firstname', firstName);
                  addressAccordion.setAttribute('data-lastname', lastName);
                  addressAccordion.setAttribute('data-phone', phone);
                  addressAccordion.setAttribute('data-address1', address1);
                  addressAccordion.setAttribute('data-address2', address2);
                  addressAccordion.setAttribute('data-suburb', suburb);
                  addressAccordion.setAttribute('data-state', state);
                  addressAccordion.setAttribute('data-postcode', postcode);
                  addressAccordion.setAttribute('data-instructions', instructions);
                  addressAccordion.querySelector('.setting-item__text p').textContent = address1;
                }

                if (!addressChanged) {
                  _unlockSettingItem(deliveryInfoItem);
                  return;
                }

                const updatedSubscription = await getContract(token, subscriptionId);

                const newZone = await findZoneData(suburb, state, postcode);
                const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                const newFindIndex = daysOfWeek.findIndex((day) => newZone?.day?.includes(day));
                const newCheckDay = daysOfWeek.findIndex((day_2) => newZone?.day_2?.includes(day_2));

                const frequencyAccordion = document.querySelector('.edit-frequency[data-subscription-id="' + subscriptionId + '"]');
                if (frequencyAccordion) {
                  frequencyAccordion.setAttribute('data-findindex', newFindIndex);
                  frequencyAccordion.setAttribute('data-checkday', newCheckDay);
                }

                const inCsv = false;
                const upcoming = await getUpcomingBillings(token, subscriptionId);
                const history = await getHistory(token, subscriptionId);

                let allContractDetails;
                try {
                  allContractDetails = await getAllContractDetails(token);
                } catch (e) {
                  console.error('Failed to fetch contract details:', e);
                  allContractDetails = [];
                }

                const subscriptionHTML = await updateSubscriptionUI(updatedSubscription, upcoming, history, inCsv, index);
                const parent = document.querySelector('.acct-panel[data-panel="subscriptions"]');
                const targetSection = parent ? parent.querySelector(`:scope > [data-subscription-id="${subscriptionId}"]`) : null;

                if (parent && targetSection) {
                  const uiState = _captureSectionUIState(targetSection);
                  let newSection;
                  if (typeof subscriptionHTML === 'string') {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = subscriptionHTML;
                    newSection = tempDiv.firstElementChild;
                    parent.replaceChild(newSection, targetSection);
                  } else {
                    newSection = subscriptionHTML;
                    parent.replaceChild(newSection, targetSection);
                  }
                  _restoreSectionUIState(newSection, uiState);
                }

                manageAccount();
                refreshDeliveryShowMore();
                editAddress();
                editExclude([updatedSubscription]);
                updateResumeDay();
                sendChangePaymentEmail();
                manageSubscription([updatedSubscription]);
                changeFrequency();
                getDiscountDate();
                addDiscount();
                removeDiscount();
                resumeSubscription([updatedSubscription]);
                goToEditPage();
                skipOrder();
                unskipOrder();

                _fanOutSubscriptionChange(updatedSubscription, typeof index === 'number' ? index : -1);

              } catch (error) {
                console.error('Error updating address:', error);
                // Release the lock + overlay so the user can retry. The card
                // replaceChild on success already destroys them, but error path
                // keeps the old DOM so we need to clear manually.
                _unlockSettingItem(document.querySelector('.setting-item.delivery-info[data-subscription-id="' + subscriptionId + '"]'));
                _hideDeliveryUpdatingOverlay(subscriptionId);
                showToast("Error updating address. Please try again.", 5000);
              }
            })();
          }
        }
      });

    }
    function changeFrequency() {
      if (_registeredListeners.has('changeFrequency')) return; _registeredListeners.add('changeFrequency');
      document.addEventListener('click', async function(event) {
        const frequencyPopupWrap = document.querySelector('.delivery-frequency-pop-up');
        // Match either the pencil (.top-edit-frequency-btn) or a click
        // anywhere on the chip (.detail-item.frequency). The new prototype
        // gave the whole chip a data-popup="delivery-frequency-pop-up",
        // so the popup opens on chip clicks — but only the pencil-hit
        // path fills .upcoming-list. Broaden the match so chip clicks
        // populate the list too.
        const topItem = event.target.closest('.top-edit-frequency-btn, .detail-item.frequency');
        if (topItem) {
          frequencyPopupWrap.setAttribute('data-next-ture-date', '');
          frequencyPopupWrap.querySelector('.upcoming-list').classList.add('loading');
          const subscriptionWrap = topItem.closest('.acct-subgroup') || topItem.closest('.subscription-section');
          const eventItem = subscriptionWrap.querySelector('.edit-frequency');
          if(eventItem){
            frequencyPopupWrap.querySelector('.upcoming-list').innerHTML = '';
            const subscriptionId = parseInt(eventItem.getAttribute('data-subscription-id'), 10);
            const findIndex = parseInt(eventItem.getAttribute('data-findindex'), 10);
            const checkDay = parseInt(eventItem.getAttribute('data-checkday'), 10);
            const planId = parseInt(eventItem.getAttribute('data-plan-id'), 10);
            const subscriptionAmount = eventItem.getAttribute('data-subscription-amount');

            frequencyPopupWrap.setAttribute('data-subscription-id', subscriptionId);
            frequencyPopupWrap.setAttribute('data-findindex', findIndex);
            frequencyPopupWrap.setAttribute('data-checkday', checkDay);

            frequencyPopupWrap.setAttribute('data-subscription-amount', subscriptionAmount);
            frequencyPopupWrap.setAttribute('data-current-plan-id', planId);

            let currentDay;
            frequencyPopupWrap.querySelectorAll('li').forEach(li => {
              const liId = parseInt(li.getAttribute('data-id'), 10);
              if(liId == planId){
                li.classList.add('active');
                currentDay = li.getAttribute('data-day');
              }else{
                li.classList.remove('active');
              }
            });
            frequencyPopupWrap.querySelector('ul').setAttribute('data-day', currentDay);
            const planName = frequencyPopupWrap.querySelector('li[data-id="' + planId + '"]').textContent;
            frequencyPopupWrap.querySelector('input').value = planName;
            const inCsv = false;
            const [subscription, upcoming, history] = await Promise.all([
              getContract(token, subscriptionId),
              getUpcomingBillings(token, subscriptionId),
              getHistory(token, subscriptionId)
            ]);
            
            const prevBillingDate = history.find(item => item.status === "SUCCESS")?.attemptTime || history.find(item => item.status === "SUCCESS")?.billingDate;
            let upcomingHTML = '';
            for (const [subindex, item] of upcoming.entries()) {
              const billingDate = item.billingDate;
              const billingRemaining = formatDateToShortString(billingDate);
              let orderDeliveryDate;
              let orderDeliveryDate_date;

              let firstOrder = true;
              if(item.orderName != subscription.originOrder?.name){
                firstOrder = false;
              }

              const { newFormattedDate: deliveryDate } = getDeliveryDate(findIndex,checkDay,billingDate,firstOrder);
              const { date: date } = getDeliveryDate(findIndex,checkDay,billingDate,firstOrder);
              orderDeliveryDate = deliveryDate;
              orderDeliveryDate_date = date;
              switch (subindex){
                case 0:
                    upcomingHTML += `
                      <div class="delivery-item next" data-prev-billing="${prevBillingDate}" data-billing-day="${billingDate}" data-delivery-day="${orderDeliveryDate_date}">
                        <h3>Next Delivery</h3>
                        <p>
                          <strong>${orderDeliveryDate}</strong>
                          • Billing on ${billingRemaining} at 9pm
                        </p>
                      </div>
                      `;
                    break;
                case 1:
                    upcomingHTML += `
                      <div class="delivery-item following">
                        <h3>Following Delivery</h3>
                        <p>
                          <strong>${orderDeliveryDate}</strong>
                          • Billing on ${billingRemaining} at 9pm
                        </p>
                      </div>
                      `;
                    break;
              }
            }
            frequencyPopupWrap.querySelector('.upcoming-list').classList.remove('loading');
            frequencyPopupWrap.querySelector('.upcoming-list').innerHTML = upcomingHTML;
          }
        }

        const item = event.target.closest('.edit-frequency');
        if (item) {
          frequencyPopupWrap.setAttribute('data-next-ture-date', '');
          frequencyPopupWrap.querySelector('.upcoming-list').classList.add('loading');
          frequencyPopupWrap.querySelector('.upcoming-list').innerHTML = '';
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const findIndex = parseInt(item.getAttribute('data-findindex'), 10);
          const checkDay = parseInt(item.getAttribute('data-checkday'), 10);

          const planId = parseInt(item.getAttribute('data-plan-id'), 10);
          const subscriptionAmount = item.getAttribute('data-subscription-amount');

          frequencyPopupWrap.setAttribute('data-subscription-id', subscriptionId);
          frequencyPopupWrap.setAttribute('data-findindex', findIndex);
          frequencyPopupWrap.setAttribute('data-checkday', checkDay);

          frequencyPopupWrap.setAttribute('data-subscription-amount', subscriptionAmount);
          frequencyPopupWrap.setAttribute('data-current-plan-id', planId);

          let currentDay;
          frequencyPopupWrap.querySelectorAll('li').forEach(li => {
            const liId = parseInt(li.getAttribute('data-id'), 10);
            if(liId == planId){
              li.classList.add('active');
              currentDay = li.getAttribute('data-day');
            }else{
              li.classList.remove('active');
            }
          });
          frequencyPopupWrap.querySelector('ul').setAttribute('data-day', currentDay);
          const planName = frequencyPopupWrap.querySelector('li[data-id="' + planId + '"]').textContent;
          frequencyPopupWrap.querySelector('input').value = planName;
          const inCsv = false;
          const [subscription, upcoming, history] = await Promise.all([
            getContract(token, subscriptionId),
            getUpcomingBillings(token, subscriptionId),
            getHistory(token, subscriptionId)
          ]);

          const prevBillingDate = history.find(item => item.status === "SUCCESS")?.attemptTime || history.find(item => item.status === "SUCCESS")?.billingDate;

          
          let upcomingHTML = '';
          for (const [subindex, item] of upcoming.entries()) {
            const billingDate = item.billingDate;
            const billingRemaining = formatDateToShortString(billingDate);
            let orderDeliveryDate;
            let orderDeliveryDate_date;
            let firstOrder = true;
            if(item.orderName != subscription.originOrder?.name){
              firstOrder = false;
            }
            const { newFormattedDate: deliveryDate } = getDeliveryDate(findIndex,checkDay,billingDate,firstOrder);
            const { date: date } = getDeliveryDate(findIndex,checkDay,billingDate,firstOrder);
            orderDeliveryDate = deliveryDate;
            orderDeliveryDate_date = date;
            switch (subindex){
              case 0:
                  upcomingHTML += `
                    <div class="delivery-item next" data-prev-billing="${prevBillingDate}" data-billing-day="${billingDate}" data-delivery-day="${orderDeliveryDate_date}">
                      <h3>Next Delivery</h3>
                      <p>
                        <strong>${orderDeliveryDate}</strong>
                        • Billing on ${billingRemaining} at 9pm
                      </p>
                    </div>
                    `;
                  break;
              case 1:
                  upcomingHTML += `
                    <div class="delivery-item following">
                      <h3>Following Delivery</h3>
                      <p>
                        <strong>${orderDeliveryDate}</strong>
                        • Billing on ${billingRemaining} at 9pm
                      </p>
                    </div>
                    `;
                  break;
            }
          }
          frequencyPopupWrap.querySelector('.upcoming-list').classList.remove('loading');
          frequencyPopupWrap.querySelector('.upcoming-list').innerHTML = upcomingHTML;
        }

        const changeFrequencyBtn = event.target.closest('.change-frequency-btn');
        if (changeFrequencyBtn) {
            const currentPlanId = parseInt(frequencyPopupWrap.getAttribute('data-current-plan-id'), 10);
            const planId = parseInt(frequencyPopupWrap.querySelector('li.active').getAttribute('data-id'), 10);
            const planName = frequencyPopupWrap.querySelector('li.active').textContent;

            if(currentPlanId == planId){
              frequencyPopupWrap.classList.remove('is-active');
            }else{
              const subscriptionId = parseInt(frequencyPopupWrap.getAttribute('data-subscription-id'), 10);

              if (_pendingSubscriptions.has(subscriptionId)) {
                showToast("Please wait for the previous action to finish.", 3000);
                return;
              }
              _pendingSubscriptions.add(subscriptionId);

              const findIndex = parseInt(frequencyPopupWrap.getAttribute('data-findindex'), 10);
              const checkDay = parseInt(frequencyPopupWrap.getAttribute('data-checkday'), 10);
              const subscriptionAmount = frequencyPopupWrap.getAttribute('data-subscription-amount');
              const fixBillingDate = frequencyPopupWrap.getAttribute('data-next-ture-date');

              // Close popup immediately and update frequency label
              frequencyPopupWrap.classList.remove('is-active');
              const frequencyAccordion = document.querySelector('.edit-frequency[data-subscription-id="' + subscriptionId + '"]');
              if (frequencyAccordion) {
                frequencyAccordion.setAttribute('data-plan-id', planId);
                frequencyAccordion.querySelector('.setting-item__text p').textContent = planName;
              }
              const detailFreqLabel = document.querySelector('.detail-item.frequency[data-subscription-id="' + subscriptionId + '"] .detail-item__label span');
              if (detailFreqLabel) detailFreqLabel.textContent = planName;

              // Lock the trigger + show updating overlay on stale delivery rows
              _lockSettingItem(frequencyAccordion);
              _showDeliveryUpdatingOverlay(subscriptionId);

              // Fire-and-forget: API calls + refresh in background
              (async () => {
                try {
                  await updateCustomerFrequency(planId, token, subscriptionId);
                  await updateNextBillingDate(token, subscriptionId, fixBillingDate);
                  _invalidateCache();

                  const [subscription, upcoming, history] = await Promise.all([
                    getContract(token, subscriptionId),
                    getUpcomingBillings(token, subscriptionId),
                    getHistory(token, subscriptionId)
                  ]);
                  const nextBillingDate = subscription.nextBillingDate;
                  const { date: nextDate } = getDeliveryDate(findIndex,checkDay,nextBillingDate,false);
                  orderNextDeliveryDate = nextDate;
                  const formattedNextDeliveryDate = new Date(orderNextDeliveryDate).toISOString().split('T')[0];
                  const formattedNextBillingDate = new Date(nextBillingDate).toISOString().split('T')[0];
                  const manageItem = document.querySelector('.setting-item.manage-subscription[data-subscription-id="' + subscriptionId + '"]');
                  if (manageItem) {
                    manageItem.setAttribute('data-pre-billing-date', formattedNextBillingDate);
                    manageItem.setAttribute('data-delivery-date', formattedNextDeliveryDate);
                  }

                  const myHistoryAndUpcoming = moveItemsBetweenArrays(history,upcoming);
                  const currentHistory = myHistoryAndUpcoming.updatedHistory;
                  const currentUpcoming = myHistoryAndUpcoming.updatedUpcoming.sort((a, b) => new Date(a.billingDate) - new Date(b.billingDate));
                  // Removed history → upcoming re-routing (per client request).

                  // Recompute amount from fresh subscription lines. The popup's
                  // data-subscription-amount was snapshotted at open time and may
                  // be stale — e.g. if a concurrent removeDiscount clears the
                  // discount before this flow's rebuild, reusing the snapshot
                  // would paint the old discounted price back over delivery-details.
                  let freshSubscriptionAmount = subscriptionAmount;
                  if (subscription?.lines?.nodes?.length) {
                    const linesTotal = subscription.lines.nodes.reduce((sum, node) => {
                      if (node.lineDiscountedPrice?.amount != null) {
                        return sum + parseFloat(node.lineDiscountedPrice.amount);
                      }
                      return sum + parseFloat(node.currentPrice?.amount || 0) * (node.quantity || 1);
                    }, 0);
                    freshSubscriptionAmount = linesTotal.toFixed(2);
                  }

                  // Sync the popup + edit-frequency node so the next open reads the latest amount.
                  frequencyPopupWrap.setAttribute('data-subscription-amount', freshSubscriptionAmount);
                  const editFrequencyNode = document.querySelector('.edit-frequency[data-subscription-id="' + subscriptionId + '"]');
                  if (editFrequencyNode) editFrequencyNode.setAttribute('data-subscription-amount', freshSubscriptionAmount);

                  // Pre-discount total: non-first delivery rows render at full price.
                  const freshOriginalAmount = subscription?.lines?.nodes?.length
                    ? subscription.lines.nodes.reduce((sum, node) =>
                        sum + parseFloat(node.currentPrice?.amount || 0) * (node.quantity || 1), 0
                      ).toFixed(2)
                    : freshSubscriptionAmount;

                  // Refresh delivery items (user may have navigated away — check element still exists)
                  const currentDeliveryWrap = document.querySelector('.acct-subgroup[data-subscription-id="' + subscriptionId + '"] .delivery-items') || document.querySelector('.subscription-section[data-subscription-id="' + subscriptionId + '"] .delivery-items');
                  if (currentDeliveryWrap) {
                    const upconimgHTML = reloadUpcomingList(findIndex,checkDay,subscriptionId,currentUpcoming,freshSubscriptionAmount,freshOriginalAmount,subscription);
                    currentDeliveryWrap.innerHTML = upconimgHTML;
                    if (typeof window.__acctResetShowMore === 'function') {
                      window.__acctResetShowMore(currentDeliveryWrap);
                    }
                  }
                  // Fan out: frequency change affects nextBillingDate → all
                  // subscription-derived views need to reflect the new date.
                  const _cfIdx = allContractDetails.findIndex(c => c.subscriptionContractId === subscriptionId);
                  _fanOutSubscriptionChange(subscription, _cfIdx);
                } catch (error) {
                  // AbortError can fire when fetch timeout exceeds but server succeeded.
                  // Verify via getContract before declaring failure.
                  const isAbort = error && (error.name === 'AbortError' || /abort/i.test(error.message || ''));
                  if (isAbort) {
                    try {
                      await new Promise(r => setTimeout(r, 1500));
                      const verify = await getContract(token, subscriptionId);
                      const verifyPlanId = parseInt(String(verify?.billingPolicy?.plan?.id || '').split('/').pop(), 10)
                        || parseInt(String(verify?.lines?.nodes?.[0]?.sellingPlanId || '').split('/').pop(), 10);
                      if (verifyPlanId === planId) {
                        // Server actually updated — silently swallow abort, keep UI optimistic
                        console.warn('changeFrequency: fetch aborted but server updated successfully');
                        _hideDeliveryUpdatingOverlay(subscriptionId);
                        return;
                      }
                    } catch (verifyErr) { /* fall through to error toast */ }
                  }
                  console.error('changeFrequency error:', error);
                  _hideDeliveryUpdatingOverlay(subscriptionId);
                  showToast("Failed to change frequency. Please try again.", 5000);
                } finally {
                  // .edit-frequency is not replaced by the delivery-items innerHTML
                  // refresh, so the lock must be released explicitly in every path.
                  _unlockSettingItem(document.querySelector('.edit-frequency[data-subscription-id="' + subscriptionId + '"]'));
                  _pendingSubscriptions.delete(subscriptionId);
                }
              })();
            }


        }
      });
    }
    function getDiscountDate() {
      if (_registeredListeners.has('getDiscountDate')) return; _registeredListeners.add('getDiscountDate');
      document.addEventListener('click', function(event) {
        // Match the pencil or a click anywhere on the discount chip.
        // The new prototype gave the whole chip data-popup="delivery-code-pop-up",
        // so the popup opens on chip clicks — mirror the frequency-chip fix.
        const topItem = event.target.closest('.top-edit-discount-btn, .detail-item.discount-code');
        if (topItem) {
          const subscriptionWrap = topItem.closest('.acct-subgroup') || topItem.closest('.subscription-section');
          const eventItem = subscriptionWrap.querySelector('.apply-code');
          if (eventItem) {
            const subscriptionId = parseInt(eventItem.getAttribute('data-subscription-id'), 10);
            const index = parseInt(eventItem.getAttribute('data-index'), 10);

            const discountPopup = document.querySelector('.delivery-code-pop-up');
            const discountBtn = discountPopup.querySelector('.apply-discount-btn');
            const discountCodeWrap = discountPopup.querySelector('.discount-label-code');

            discountBtn.setAttribute('data-subscription-id', subscriptionId);
            discountBtn.setAttribute('data-index', index);
            if (eventItem.classList.contains('has-discount')) {
              const cardWrapHTML = eventItem.querySelector('.current-code-wrap').innerHTML;
              discountCodeWrap.innerHTML = _buildPopupDiscountsHTML(cardWrapHTML, subscriptionId, index);
              discountCodeWrap.classList.add("is-show");
            } else {
              discountCodeWrap.innerHTML = '';
              discountCodeWrap.classList.remove("is-show");
            }
          }
        }
        const item = event.target.closest('.apply-code');
        if (item) {
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const index = parseInt(item.getAttribute('data-index'), 10);

          const discountPopup = document.querySelector('.delivery-code-pop-up');
          const discountBtn = discountPopup.querySelector('.apply-discount-btn');
          const discountCodeWrap = discountPopup.querySelector('.discount-label-code');
          discountBtn.setAttribute('data-subscription-id', subscriptionId);
          discountBtn.setAttribute('data-index', index);

          if (item.classList.contains('has-discount')) {
            const cardWrapHTML = item.querySelector('.current-code-wrap').innerHTML;
            discountCodeWrap.innerHTML = _buildPopupDiscountsHTML(cardWrapHTML, subscriptionId, index);
            discountCodeWrap.classList.add("is-show");
          } else {
            discountCodeWrap.innerHTML = '';
            discountCodeWrap.classList.remove("is-show");
          }
        }
      });
    }
    // Classify subscription-level discount as 'shipping' or 'order' so we can
    // enforce "at most one of each type" on apply, and combine multiple
    // discounts in display logic. SHIPPING_LINE is the authoritative signal;
    // fall back to title-based detection when targetType is missing.
    // Build popup HTML: each .discount-label gets a sibling delete button so
    // the user can remove discounts individually (one product + one shipping
    // can coexist; each row deletes independently).
    function _buildPopupDiscountsHTML(cardWrapInnerHTML, subscriptionId, index) {
      const container = document.createElement('div');
      container.innerHTML = cardWrapInnerHTML || '';
      const labels = container.querySelectorAll('.discount-label');
      labels.forEach((label) => {
        const did = label.getAttribute('data-discount-id') || '';
        if (!did) return;
        const row = document.createElement('div');
        row.className = 'discount-line';
        const btn = document.createElement('button');
        btn.className = 'discount-delete';
        btn.setAttribute('data-index', String(index));
        btn.setAttribute('data-subscription-id', String(subscriptionId));
        btn.setAttribute('data-discount-id', did);
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99481 5.11426C9.60055 5.11426 11.2063 5.11426 12.812 5.11426C13.0829 5.11426 13.2107 5.23653 13.2107 5.49591C13.2107 8.33376 13.2107 11.1716 13.2107 14.0095C13.2107 14.8244 12.6385 15.4879 11.8005 15.6406C11.6909 15.6605 11.5766 15.6663 11.4645 15.6668C9.16505 15.6681 6.86564 15.6596 4.56622 15.6719C3.58391 15.6769 2.77173 14.9483 2.77935 13.9727C2.79247 12.3242 2.78274 10.6757 2.78274 9.02724C2.78274 7.84802 2.78274 6.66837 2.78274 5.48914C2.78274 5.28351 2.87415 5.15784 3.05106 5.12188C3.09508 5.11299 3.14206 5.11469 3.18777 5.11469C4.79012 5.11469 6.39247 5.11426 7.99481 5.11426Z" fill="#1B1C1E" fill-opacity="0.7" /><path d="M4.56496 2.09926C4.63352 1.80942 4.85148 1.66133 5.08849 1.53651C5.49691 1.32115 5.94045 1.21452 6.39119 1.13371C7.06243 1.01269 7.74046 0.981384 8.42016 1.00973C9.17393 1.04104 9.91924 1.13413 10.6303 1.40746C10.8546 1.49336 11.0721 1.59533 11.2431 1.76923C11.3079 1.83523 11.3705 1.91605 11.3993 2.00152C11.4289 2.0891 11.4716 2.10095 11.5499 2.10053C12.0358 2.09799 12.5217 2.09672 13.0076 2.10053C13.3242 2.10264 13.5907 2.29432 13.6365 2.60066C13.6716 2.83633 13.6682 3.08724 13.6293 3.3225C13.5823 3.60429 13.3072 3.79512 13.0198 3.79512C9.67462 3.79596 6.32982 3.79596 2.98461 3.79512C2.59482 3.79512 2.30279 3.45578 2.3413 3.06693C2.35442 2.93491 2.3303 2.7991 2.34808 2.66793C2.39505 2.32351 2.65111 2.10264 2.99816 2.10053C3.47683 2.09757 3.95593 2.09969 4.4346 2.09969C4.4765 2.09969 4.51883 2.09926 4.56496 2.09926Z" fill="#1B1C1E" fill-opacity="0.7" /></svg>';
        const clone = label.cloneNode(true);
        row.appendChild(clone);
        row.appendChild(btn);
        label.parentNode.replaceChild(row, label);
      });
      return container.innerHTML;
    }
    // Try to apply a discount; if Shopify rejects because it cannot combine
    // with an existing code (same type, or Combinations not permitting),
    // remove the named blocker and retry once. Error format from Appstle:
    //   "Error 400: UserGeneratedError:OLDCODE cannot be combined with NEWCODE."
    async function _applyWithReplaceFallback(discountCode, token, subscriptionId) {
      try {
        return await applyDiscountCode(discountCode, token, subscriptionId);
      } catch (err) {
        const msg = (err && err.message) || '';
        // Trigger fallback on both "cannot be combined with X" (Shopify
        // Combinations rejection) and "invalid discount code" (Shopify deems
        // the new code invalid given the current contract state — typically
        // because an existing discount conflicts in a non-Combinations way).
        if (!/cannot be combined with|invalid discount code/i.test(msg)) throw err;
        // Shopify Combinations blocked the apply. Clear ALL existing discounts
        // off the subscription so the new code can apply, then re-apply any
        // existing discount whose type differs from the new one (so cross-type
        // stacking still works once the same-type collision is gone).
        const sub = await getContract(token, subscriptionId);
        const existing = (sub?.discounts?.nodes || []).filter((d) => d?.id);
        if (!existing.length) throw err;
        const existingIds = existing.map((d) => d.id);
        for (const id of existingIds) {
          try { await removeDiscountCode(id, token, subscriptionId); }
          catch (rmErr) { console.error('removeDiscountCode (replace-fallback) error:', rmErr); }
        }
        // Shopify combinability check is eventually consistent — poll until
        // the subscription no longer carries any of the removed discounts.
        const pollStart = Date.now();
        while (Date.now() - pollStart < 8000) {
          await new Promise((r) => setTimeout(r, 500));
          const s = await getContract(token, subscriptionId);
          const stillIds = (s?.discounts?.nodes || []).map((d) => d?.id).filter(Boolean);
          const anyStill = existingIds.some((id) => stillIds.includes(id));
          if (!anyStill) break;
        }
        await new Promise((r) => setTimeout(r, 800));
        const applyResult = await applyDiscountCode(discountCode, token, subscriptionId);

        // Now classify the new discount and re-apply any existing discounts of
        // the OTHER type so user only loses the same-type old code, not all.
        try {
          const subAfter = await getContract(token, subscriptionId);
          const nodesAfter = subAfter?.discounts?.nodes || [];
          const normalized = (discountCode || '').trim().toLowerCase();
          const newDiscount = nodesAfter.find((d) => (d?.title || '').trim().toLowerCase() === normalized)
                              || nodesAfter[nodesAfter.length - 1];
          if (newDiscount) {
            const newType = _classifyDiscount(newDiscount);
            const toReapply = existing.filter((d) => _classifyDiscount(d) !== newType && d?.title);
            for (const d of toReapply) {
              try {
                await applyDiscountCode(d.title, token, subscriptionId);
              } catch (reErr) {
                console.error('re-apply other-type discount error:', reErr);
              }
            }
          }
        } catch (postErr) {
          console.error('post-apply reapply phase error:', postErr);
        }
        return applyResult;
      }
    }
    function _classifyDiscount(d) {
      const tt = (d?.targetType || d?.value?.targetType || '').toString().toUpperCase();
      if (tt === 'SHIPPING_LINE') return 'shipping';
      if (!tt) {
        const tl = (d?.title || '').toLowerCase();
        if (tl.includes('shipping') || tl.includes('delivery')) return 'shipping';
      }
      return 'order';
    }
    // Render a list of discount labels separated by <br> (one per line) for
    // popup/card display, or by ", " for inline display in headers.
    function _buildDiscountsHTML(discounts, subscription, opts) {
      const list = Array.isArray(discounts) ? discounts.filter(Boolean) : [];
      if (!list.length) return '<p>No code applied</p>';
      const sep = opts && opts.inline ? ', ' : '';
      const parts = list.map((d) => _buildDiscountHTML(d, subscription));
      if (opts && opts.inline) {
        // Strip the wrapping <p> and concatenate the inner text for inline use.
        return parts.join(sep);
      }
      return parts.join('');
    }
    function _buildDiscountHTML(discount, subscription) {
      if (!discount) return '<p>No code applied</p>';
      const code = discount.title;
      let priceDisplay = '';
      let isShipAdd = false;
      const linesTotal = (subscription.lines?.nodes || []).reduce((s, n) => s + parseFloat(n.lineDiscountedPrice?.amount || n.currentPrice?.amount || 0) * (n.lineDiscountedPrice?.amount != null ? 1 : (n.quantity || 1)), 0);
      const _targetType = (discount.targetType || discount.value?.targetType || '').toString().toUpperCase();
      const _titleLower = (discount.title || '').toLowerCase();
      const _looksLikeShipping = _targetType === 'SHIPPING_LINE'
          || (!_targetType && (_titleLower.includes('shipping') || _titleLower.includes('delivery')));
      if (discount.value.__typename === 'SubscriptionDiscountPercentageValue') {
        if (discount.value.percentage === 100) {
          isShipAdd = true;
          priceDisplay = _looksLikeShipping ? 'Free Delivery' : 'Free Order';
        } else {
          priceDisplay = `${discount.value.percentage}%`;
        }
      } else if (discount.value.__typename === 'SubscriptionDiscountFixedAmountValue') {
        priceDisplay = `${discount.value.amount.amount}`;
      }
      const did = discount.id || '';
      return isShipAdd ? `
        <p class="discount-label" data-discount-id="${did}">
          <span class="code">${code}</span>
          —
          <span class="discount-price">${priceDisplay}</span>
        </p>
      ` : `
        <p class="discount-label" data-discount-id="${did}">
          Discount
          <span class="code">${code}</span>
          applied
          <span class="discount-price">${priceDisplay}</span>
          off
        </p>
      `;
    }
    function _discountDeleteBtnHTML(index, subscriptionId, discountId) {
      return `
        <button class="discount-delete" data-index="${index}" data-subscription-id="${subscriptionId}" data-discount-id="${discountId}">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.99481 5.11426C9.60055 5.11426 11.2063 5.11426 12.812 5.11426C13.0829 5.11426 13.2107 5.23653 13.2107 5.49591C13.2107 8.33376 13.2107 11.1716 13.2107 14.0095C13.2107 14.8244 12.6385 15.4879 11.8005 15.6406C11.6909 15.6605 11.5766 15.6663 11.4645 15.6668C9.16505 15.6681 6.86564 15.6596 4.56622 15.6719C3.58391 15.6769 2.77173 14.9483 2.77935 13.9727C2.79247 12.3242 2.78274 10.6757 2.78274 9.02724C2.78274 7.84802 2.78274 6.66837 2.78274 5.48914C2.78274 5.28351 2.87415 5.15784 3.05106 5.12188C3.09508 5.11299 3.14206 5.11469 3.18777 5.11469C4.79012 5.11469 6.39247 5.11426 7.99481 5.11426Z" fill="#1B1C1E" fill-opacity="0.7" />
            <path d="M4.56496 2.09926C4.63352 1.80942 4.85148 1.66133 5.08849 1.53651C5.49691 1.32115 5.94045 1.21452 6.39119 1.13371C7.06243 1.01269 7.74046 0.981384 8.42016 1.00973C9.17393 1.04104 9.91924 1.13413 10.6303 1.40746C10.8546 1.49336 11.0721 1.59533 11.2431 1.76923C11.3079 1.83523 11.3705 1.91605 11.3993 2.00152C11.4289 2.0891 11.4716 2.10095 11.5499 2.10053C12.0358 2.09799 12.5217 2.09672 13.0076 2.10053C13.3242 2.10264 13.5907 2.29432 13.6365 2.60066C13.6716 2.83633 13.6682 3.08724 13.6293 3.3225C13.5823 3.60429 13.3072 3.79512 13.0198 3.79512C9.67462 3.79596 6.32982 3.79596 2.98461 3.79512C2.59482 3.79512 2.30279 3.45578 2.3413 3.06693C2.35442 2.93491 2.3303 2.7991 2.34808 2.66793C2.39505 2.32351 2.65111 2.10264 2.99816 2.10053C3.47683 2.09757 3.95593 2.09969 4.4346 2.09969C4.4765 2.09969 4.51883 2.09926 4.56496 2.09926Z" fill="#1B1C1E" fill-opacity="0.7" />
          </svg>
        </button>
      `;
    }
    // Replace a subscription card in place using locally-mutated state
    // (no network call). Used for optimistic pause/cancel/resume renders.
    async function _renderSubscriptionLocal(localSub, subscriptionId, index) {
      const parent = document.querySelector('.acct-panel[data-panel="subscriptions"]');
      if (!parent) return;
      const target = parent.querySelector(':scope > [data-subscription-id="' + subscriptionId + '"]');
      if (!target) return;
      const upcoming = _latestUpcoming[index] || [];
      const history = _latestHistory[index] || [];
      const html = await updateSubscriptionUI(localSub, upcoming, history, false, index);
      const uiState = _captureSectionUIState(target);
      let newSection;
      if (typeof html === 'string') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        newSection = tempDiv.firstElementChild;
        parent.replaceChild(newSection, target);
      } else if (html) {
        newSection = html;
        parent.replaceChild(newSection, target);
      }
      _restoreSectionUIState(newSection, uiState);
      _resortSubscriptionSections(parent);
      manageAccount();
      refreshDeliveryShowMore();
    }
    // Close a popup instantly so the user sees the optimistically-flipped
    // card without the modal covering it. A toast confirms the action.
    function _closePopupNow(popupWrap) {
      if (!popupWrap) return;
      popupWrap.classList.remove('is-active');
      popupWrap.querySelectorAll('.content').forEach((c) => c.classList.remove('active'));
      document.querySelectorAll("html, body").forEach((el) => el.classList.remove("overflow-hidden--inside"));
    }
    // Merge a new attribute (or array of attributes) into an existing
    // customAttributes list, replacing any with matching keys.
    function _mergeCustomAttrs(oldAttrs, newAttrs) {
      const list = Array.isArray(newAttrs) ? newAttrs : [newAttrs];
      const keys = new Set(list.map((a) => a.key));
      return [...(oldAttrs || []).filter((a) => !keys.has(a.key)), ...list];
    }
    // Shared runner for pause/cancel/resume optimistic actions:
    //   t=0      button spinner, per-subscription lock, fire API
    //   t=2000   close popup, flip card to target state, toast
    //   late    if API fails (before or after the timer), roll the card
    //           back to its original state and toast the error
    // Returns true if the action was started, false if blocked by a lock.
    function _runOptimisticAction(opts) {
      const {
        btn, popupWrap, subscriptionId, index,
        originalSub, localSub,
        apiFactory, successToast, errorToast,
        onPopupClose,
      } = opts;
      if (btn && btn.dataset.pending === '1') return false;
      if (_pendingSubscriptions.has(subscriptionId)) {
        showToast("Please wait for the previous action to finish.", 3000);
        return false;
      }
      if (btn) {
        btn.dataset.pending = '1';
        btn.classList.add('loading');
      }
      _pendingSubscriptions.add(subscriptionId);

      let apiFailed = false;
      let timerFired = false;

      Promise.resolve()
        .then(() => apiFactory())
        .then(() => { _invalidateCache(); })
        .catch(async (err) => {
          console.error('Optimistic action API error:', err);
          apiFailed = true;
          if (timerFired) {
            // Timer already flipped the card to success state — roll back.
            _latestSubscriptions[index] = originalSub;
            await _renderSubscriptionLocal(originalSub, subscriptionId, index);
            showToast(errorToast, 5000);
          }
        })
        .finally(() => { _pendingSubscriptions.delete(subscriptionId); });

      setTimeout(async () => {
        timerFired = true;
        if (btn) {
          btn.classList.remove('loading');
          delete btn.dataset.pending;
        }
        if (typeof onPopupClose === 'function') {
          onPopupClose();
        } else if (popupWrap) {
          _closePopupNow(popupWrap);
        }
        if (apiFailed) {
          _latestSubscriptions[index] = originalSub;
          await _renderSubscriptionLocal(originalSub, subscriptionId, index);
          showToast(errorToast, 5000);
        } else {
          _latestSubscriptions[index] = localSub;
          await _renderSubscriptionLocal(localSub, subscriptionId, index);
          showToast(successToast, 2000);
        }
        _fanOutSubscriptionChange(apiFailed ? originalSub : localSub, index);
      }, 2000);
      return true;
    }
    function _refreshSubscriptionCard(subscription, subscriptionId, index) {
      // Non-blocking background refresh of the subscription card so price/delivery
      // totals reflect the latest state after discount/skip changes.
      const parent = document.querySelector('.acct-panel[data-panel="subscriptions"]');
      if (!parent) return;
      // Re-fetch contract alongside upcoming/history. The initial getContract
      // immediately after a mutation (apply/remove discount) can return stale
      // lineDiscountedPrice values due to Appstle eventual consistency, so we
      // pay an extra roundtrip here to let the server catch up before rendering.
      Promise.all([
        getContract(token, subscriptionId).catch(() => null),
        getUpcomingBillings(token, subscriptionId),
        getHistory(token, subscriptionId)
      ]).then(async ([freshSubscription, upcoming, history]) => {
        let effectiveSubscription = freshSubscription || subscription;
        // Appstle eventual consistency after mutations can briefly return
        // status=CANCELLED for an ACTIVE contract (seen after removeDiscount).
        // If the fresh status disagrees with the pre-mutation status, re-poll
        // a couple of times before trusting it.
        if (freshSubscription && subscription &&
            String(freshSubscription.status || '').toUpperCase() === 'CANCELLED' &&
            String(subscription.status || '').toUpperCase() !== 'CANCELLED') {
          for (let i = 0; i < 3; i++) {
            await new Promise(r => setTimeout(r, 800));
            const retry = await getContract(token, subscriptionId).catch(() => null);
            if (retry && String(retry.status || '').toUpperCase() !== 'CANCELLED') {
              effectiveSubscription = retry;
              if (index >= 0) _latestSubscriptions[index] = retry;
              break;
            }
            if (i === 2) {
              // Server still says CANCELLED after retries — fall back to the
              // original (pre-mutation) subscription rather than render a
              // misleading Cancelled card. Prices may be slightly stale but
              // status accuracy matters more.
              effectiveSubscription = subscription;
            }
          }
        } else if (freshSubscription && index >= 0) {
          _latestSubscriptions[index] = freshSubscription;
        }
        const subscriptionHTML = await updateSubscriptionUI(effectiveSubscription, upcoming, history, false, index);
        const targetSection = parent.querySelector(`:scope > [data-subscription-id="${subscriptionId}"]`);
        if (!targetSection) return;
        const uiState = _captureSectionUIState(targetSection);
        let newSection;
        if (typeof subscriptionHTML === 'string') {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = subscriptionHTML;
          newSection = tempDiv.firstElementChild;
          parent.replaceChild(newSection, targetSection);
        } else {
          newSection = subscriptionHTML;
          parent.replaceChild(newSection, targetSection);
        }
        _restoreSectionUIState(newSection, uiState);
        // Renumber headings by DOM position. updateSubscriptionUI's `index`
        // comes from data-index which may not match DOM order, so the
        // replaced card's #N can disagree with neighbours after refresh.
        Array.from(parent.querySelectorAll(':scope > [data-subscription-id]')).forEach(function(sec, i) {
          // Renumber both the outer "Subscription N" .acct-section__title
          // and the inner "📦 #N" .acct-sub__name so DOM order = display order.
          var outerTitle = sec.querySelector('.acct-section__title');
          if (outerTitle) {
            outerTitle.textContent = outerTitle.textContent.replace(/Subscription\s+\d+/, 'Subscription ' + (i + 1));
          }
          var innerName = sec.querySelector('.acct-sub__name');
          if (innerName) {
            var _n = innerName.textContent;
            var _lastIdx = _n.lastIndexOf('#');
            if (_lastIdx !== -1 && /^\d+/.test(_n.slice(_lastIdx + 1))) {
              innerName.textContent = _n.slice(0, _lastIdx) + '#' + (i + 1);
            }
          }
        });
        manageAccount();
        refreshDeliveryShowMore();
        _fanOutSubscriptionChange(effectiveSubscription, typeof index === 'number' ? index : -1);
      }).catch((err) => console.error('post-discount bg refresh:', err));
    }
    function addDiscount() {
      if (_registeredListeners.has('addDiscount')) return; _registeredListeners.add('addDiscount');

      // Enter key triggers Apply button
      const discountInput = document.querySelector('.delivery-code-pop-up .discount-code');
      if (discountInput) {
        discountInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            const applyBtn = document.querySelector('.delivery-code-pop-up .apply-discount-btn');
            if (applyBtn) applyBtn.click();
          }
        });
        // iOS Safari: raise the soft keyboard on touchstart rather than
        // waiting for touchend→click→focus. Focus called inside a touch
        // user-gesture context triggers the keyboard animation immediately.
        discountInput.addEventListener('touchstart', function () {
          if (document.activeElement !== discountInput) {
            discountInput.focus({ preventScroll: true });
          }
        }, { passive: true });
      }

      document.addEventListener('click', async function(event) {
        const item = event.target.closest('.apply-discount-btn');
        if (!item) return;
        if (item.dataset.pending === '1') return;

        const discountInputWrap = item.closest('.discount-code-input');
        const discountCodeInput = discountInputWrap.querySelector('.discount-code');
        const discountCode = discountCodeInput.value.trim();
        const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
        const index = parseInt(item.getAttribute('data-index'), 10);
        const discountPopup = document.querySelector('.delivery-code-pop-up');

        if (!discountCode) {
          showToast("Please enter discount code.", 5000);
          return;
        }

        item.dataset.pending = '1';
        discountCodeInput.value = '';
        _pendingSubscriptions.add(subscriptionId);

        // Optimistic UI: close popup immediately, rely on the setting-item
        // arrow spinner (via .is-locked) for the pending state.
        _closePopupNow(discountPopup);
        const applyCodeItem = document.querySelector('.setting-item.apply-code[data-subscription-id="' + subscriptionId + '"]');
        _lockSettingItem(applyCodeItem);

        try {
          // Appstle allows one product-discount + one shipping-discount on the
          // same subscription. Apply first (with replace-fallback if Shopify
          // Combinations rejects), then identify the new discount's type and
          // remove any OTHER existing discount of the same type.
          await _applyWithReplaceFallback(discountCode, token, subscriptionId);
          _invalidateCache();
          let subscription = await getContract(token, subscriptionId);
          const discountNodes = (subscription?.discounts?.nodes || []).filter(Boolean);
          const normalizedRequested = (discountCode || '').trim().toLowerCase();
          const newDiscount = discountNodes.find((d) => (d?.title || '').trim().toLowerCase() === normalizedRequested)
                              || discountNodes[discountNodes.length - 1];

          if (!newDiscount) {
            _unlockSettingItem(applyCodeItem);
            showToast("Discount code could not be applied.", 5000);
            return;
          }

          const newType = _classifyDiscount(newDiscount);
          const toRemove = discountNodes.filter((d) => d?.id && d.id !== newDiscount.id && _classifyDiscount(d) === newType);
          if (toRemove.length) {
            for (const d of toRemove) {
              try { await removeDiscountCode(d.id, token, subscriptionId); }
              catch (removeErr) { console.error('removeDiscountCode (same-type cleanup) error:', removeErr); }
            }
            _invalidateCache();
            subscription = await getContract(token, subscriptionId);
          }

          _latestSubscriptions[index] = subscription;
          _refreshSubscriptionCard(subscription, subscriptionId, index);
        } catch (apiError) {
          console.error('applyDiscountCode API error:', apiError);
          _unlockSettingItem(document.querySelector('.setting-item.apply-code[data-subscription-id="' + subscriptionId + '"]'));
          showToast("Invalid discount code. Please try again.", 5000);
        } finally {
          delete item.dataset.pending;
          _pendingSubscriptions.delete(subscriptionId);
        }
      });
    }
    function removeDiscount() {
      if (_registeredListeners.has('removeDiscount')) return; _registeredListeners.add('removeDiscount');
      document.addEventListener('click', async function(event) {
        const item = event.target.closest('.discount-delete');
        if (!item) return;
        if (item.dataset.pending === '1') return;

        const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
        const index = parseInt(item.getAttribute('data-index'), 10);
        const discountId = item.getAttribute('data-discount-id');
        const discountPopup = document.querySelector('.delivery-code-pop-up');
        const detailDiscountItem = document.querySelector('.detail-item.discount-code[data-subscription-id="' + subscriptionId + '"]');
        const detailEditBtn = detailDiscountItem?.querySelector('.top-edit-discount-btn');

        item.dataset.pending = '1';
        _pendingSubscriptions.add(subscriptionId);

        /* Close popup immediately; loading surfaces on the icon-edit button
           of detail-item.discount-code. The card re-render on success swaps
           the whole subscription-section, so loading clears naturally. */
        _closePopupNow(discountPopup);
        if (detailEditBtn) detailEditBtn.classList.add('loading');
        const applyCodeItem = document.querySelector('.setting-item.apply-code[data-subscription-id="' + subscriptionId + '"]');
        _lockSettingItem(applyCodeItem);

        try {
          await removeDiscountCode(discountId, token, subscriptionId);
          _invalidateCache();
          const subscription = await getContract(token, subscriptionId);
          const stillPresent = (subscription.discounts?.nodes || []).some((d) => d?.id === discountId);
          if (stillPresent) {
            throw new Error('Discount still present after removal');
          }
          _latestSubscriptions[index] = subscription;
          _refreshSubscriptionCard(subscription, subscriptionId, index);
        } catch (err) {
          console.error('removeDiscount API error:', err);
          if (detailEditBtn) detailEditBtn.classList.remove('loading');
          _unlockSettingItem(document.querySelector('.setting-item.apply-code[data-subscription-id="' + subscriptionId + '"]'));
          showToast("Failed to remove discount. Please try again.", 5000);
        } finally {
          delete item.dataset.pending;
          _pendingSubscriptions.delete(subscriptionId);
        }
      });
    }
    function reloadUpcomingList(findIndex,checkDay,subscriptionId,currentUpcoming,subscriptionAmount,originalAmount,subscription) {
      const oldNoteAttributes = subscription.customAttributes;
      let upconimgHTML = '';

      const firstQueuedIndex = currentUpcoming.findIndex(item => item.status === "QUEUED");
      // Find the SECOND QUEUED index (for .next-upcoming-2 — first two non-skipped
      // rows display delivery-details; .next-upcoming-2 covers the second slot).
      let secondQueuedIndex = -1;
      for (let i = firstQueuedIndex + 1; i < currentUpcoming.length; i++) {
        if (currentUpcoming[i].status === "QUEUED") {
          secondQueuedIndex = i;
          break;
        }
      }
      for (const [subindex, item] of currentUpcoming.entries()) {
        let firstOrder = true;
        if(item.orderName != subscription.originOrder?.name){
          firstOrder = false;
        }


          const orderID = item.orderId;

          const isFirstQueued = subindex === firstQueuedIndex;
          const isSecondQueued = subindex === secondQueuedIndex;

          const nextUpcomingClass = isFirstQueued
            ? 'next-upcoming'
            : (isSecondQueued ? 'next-upcoming-2' : '');
          const id = item.id;
          const billingDate = item.billingDate;
          let orderDeliveryDate;
          let orderDeliveryDate_date;

          const { newFormattedDate: deliveryDate } = getDeliveryDate(findIndex,checkDay,billingDate,firstOrder);
          const { date: date } = getDeliveryDate(findIndex,checkDay,billingDate,firstOrder);
          orderDeliveryDate = deliveryDate;
          orderDeliveryDate_date = date;

          const deliveryRemaining = getDaysRemaining(orderDeliveryDate_date);

          const billingRemaining = formatDateToShortString(billingDate);

          let isPaid = '';
          let orderAmount = '';
          let orderAmountText = '';
          let orderDiscountText = '';
          let skipHTML = '';
          
          if(item.status == 'SUCCESS'){
            isPaid = '• Paid';
            
            orderAmount = parseFloat(subscriptionAmount).toFixed(2);
          }else{

            const now = new Date();
            const nowUTC = new Date(now.toISOString());
            const billingDateUTC = new Date(billingDate);


            if (billingDateUTC > nowUTC) {
              const discountRow = subscription.discounts?.nodes ?? '';
                // delivery-details shows the pre-discount full price on every upcoming row;
                // the discount-note span is rendered on all QUEUED rows but only visible on
                // the .next-upcoming:not(.unskip) row (CSS-controlled), so skipping the first
                // order dynamically moves the discount annotation to the next non-skipped row.
                orderAmount = parseFloat(originalAmount).toFixed(2);
                orderAmountText = `$${orderAmount} • `;
                if(discountRow && discountRow.length > 0){
                  // Combine product + shipping discounts on the same row. A
                  // shipping discount at 100% shows "Free Delivery"; an order
                  // discount shows "Discounted $X" (or "Free Order" at 100%).
                  let _hasFreeDelivery = false;
                  let _orderNote = '';
                  for (const d of discountRow) {
                    const _type = _classifyDiscount(d);
                    const _is100Pct = d?.value?.__typename === 'SubscriptionDiscountPercentageValue'
                      && d?.value?.percentage === 100;
                    if (_type === 'shipping') {
                      if (_is100Pct) _hasFreeDelivery = true;
                    } else {
                      if (_is100Pct && parseFloat(orderAmount) > 0) _orderNote = 'Free Order';
                      else _orderNote = `Discounted $${parseFloat(subscriptionAmount).toFixed(2)}`;
                    }
                  }
                  const _noteParts = [];
                  if (_orderNote) _noteParts.push(_orderNote);
                  if (_hasFreeDelivery) _noteParts.push('Free Delivery');
                  if (_noteParts.length) {
                    orderDiscountText = `<span class="discount-note"> • ${_noteParts.join(' • ')}</span>`;
                  }
                }
              if(item.status == 'SKIPPED'){
                skipHTML = `
                  <div class="delivery-actions">
                    <button class="btn unskip-btn acct-btn acct-btn--sm acct-btn--sm-outline" data-id="${id}" data-subscription-id="${subscriptionId}" data-findindex="${findIndex}" data-checkday="${checkDay}" data-subscription-amount="${subscriptionAmount}">
                      <span>skip</span>
                      <span>Unskip</span>
                    </button>
                  </div>
                `;
              }else{
                skipHTML = `
                  <div class="delivery-actions">
                    <button class="btn skip-btn acct-btn acct-btn--sm acct-btn--sm-outline" data-id="${id}" data-subscription-id="${subscriptionId}" data-findindex="${findIndex}" data-checkday="${checkDay}" data-subscription-amount="${subscriptionAmount}">
                      <span>skip</span>
                      <span>Unskip</span>
                    </button>
                  </div>
                `;
              }
            }
          }
          let skipClass = '';
          if(item.status == 'SKIPPED'){
            skipClass = 'unskip';
          }
          switch (subindex){
          case 0:
              if(item.status == 'SKIPPED'){
                // Render skipped first order with the same structure as normal QUEUED
                // subindex 0 (no `current` class, lowercase "delivery", with delivery-details).
                // This lets optimistic unskip restore the normal display via class toggle
                // alone — no need to re-fetch and re-render the whole card.
                upconimgHTML += `
                  <div class="delivery-item ${skipClass} ${nextUpcomingClass}">
                    <div class="delivery-info">
                      <p class="delivery-date">
                        <span class="date">${orderDeliveryDate} delivery</span>${orderDiscountText}
                      </p>
                      <p class="delivery-details">${orderAmountText} Billing on ${billingRemaining} at 9pm</p>
                    </div>
                    ${skipHTML}
                  </div>
                `;
              }else{
                if(item.status == 'SUCCESS'){
                  let matchedDay = null;
                  let foundMatchingOrderId = false;

                  if (oldNoteAttributes && oldNoteAttributes.length > 0) {
                      const expectedKey = `order_id_is_${orderID}`;
                      
                      for (const attr of oldNoteAttributes) {
                          if (attr.key === expectedKey) {
                              foundMatchingOrderId = true;
                              matchedDay = attr.value;
                              break;
                          }
                      }
                  }


                  let dateDisplay = orderDeliveryDate;
                  let deliveryRemainingDisplay = deliveryRemaining;

                  if (foundMatchingOrderId && matchedDay) {
                      try {
                          const matchedDate = new Date(matchedDay);
                          
                          if (!isNaN(matchedDate.getTime())) {
                              const day = matchedDate.getDate();
                              const dayOfWeek = matchedDate.getDay();
                              const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                              const month = monthNames[matchedDate.getMonth()];
                              
                              const weekdayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                              const weekday = weekdayNames[dayOfWeek];
                              
                              const getDayWithSuffix = (day) => {
                                  if (day > 3 && day < 21) return day + "th";
                                  switch (day % 10) {
                                      case 1: return day + "st";
                                      case 2: return day + "nd";
                                      case 3: return day + "rd";
                                      default: return day + "th";
                                  }
                              };
                              
                              dateDisplay = `${weekday} ${getDayWithSuffix(day)} ${month}`;

                              const today = new Date();
                              today.setHours(0, 0, 0, 0);
                              const targetDate = new Date(matchedDate);
                              targetDate.setHours(0, 0, 0, 0);
                              
                              const diffTime = targetDate - today;
                              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                              
                              if (diffDays === 0) {
                                  deliveryRemainingDisplay = "today";
                              } else if (diffDays === 1) {
                                  deliveryRemainingDisplay = "tomorrow";
                              } else if (diffDays > 1) {
                                  deliveryRemainingDisplay = `in ${diffDays} days`;
                              } else if (diffDays === -1) {
                                  deliveryRemainingDisplay = "yesterday";
                              } else {
                                  deliveryRemainingDisplay = `${Math.abs(diffDays)} days ago`;
                              }
                          }
                      } catch (error) {
                          console.error("Error processing date:", error);
                      }
                  }

                  upconimgHTML += `
                      <div class="delivery-item current success-upcoming-order ${skipClass} ${nextUpcomingClass}" 
                          data-day="${foundMatchingOrderId && matchedDay ? matchedDay : orderDeliveryDate_date}" 
                          data-order-id="${orderID}">
                          <div class="delivery-info">
                              <p class="delivery-date">
                                  <span class="date">${dateDisplay} delivery • ${subscription.deliveryMethod?.address?.address1}</span>
                              </p>
                              <p class="delivery-details">$${orderAmount} ${isPaid} • Delivery ${deliveryRemainingDisplay}</p>
                          </div>
                          ${skipHTML}
                      </div>
                  `;
                }else{
                  upconimgHTML += `
                    <div class="delivery-item ${skipClass} ${nextUpcomingClass}">
                      <div class="delivery-info">
                        <p class="delivery-date">
                          <span class="date">${orderDeliveryDate} delivery</span>${orderDiscountText}
                        </p>
                        <p class="delivery-details">${orderAmountText} Billing on ${billingRemaining} at 9pm</p>
                      </div>
                      ${skipHTML}
                    </div>
                  `;
                }
              }
              break;
          case 1:
              if(item.status == 'SKIPPED'){
                // Match normal QUEUED case 1 structure so unskip can restore via class toggle alone.
                upconimgHTML += `
                  <div class="delivery-item ${skipClass} ${nextUpcomingClass}">
                    <div class="delivery-info">
                      <p class="delivery-date"><span class="date">${orderDeliveryDate} delivery</span>${orderDiscountText}</p>
                      <p class="delivery-details">${orderAmountText} Billing on ${billingRemaining} at 9pm</p>
                    </div>
                    ${skipHTML}
                  </div>
                `;
              }else{
                upconimgHTML += `
                  <div class="delivery-item ${skipClass} ${nextUpcomingClass}">
                    <div class="delivery-info">
                      <p class="delivery-date"><span class="date">${orderDeliveryDate} delivery</span>${orderDiscountText}</p>
                      <p class="delivery-details">${orderAmountText} Billing on ${billingRemaining} at 9pm</p>
                    </div>
                    ${skipHTML}
                  </div>
                `;
              }
              break;
          default:
              // Always include delivery-details so the first two non-skipped
              // rows can surface it via class-based CSS toggling — no DOM
              // reshuffle needed when the user skips/unskips upstream rows.
              upconimgHTML += `
                <div class="delivery-item ${skipClass} ${nextUpcomingClass}">
                  <div class="delivery-info">
                    <p class="delivery-date"><span class="date">${orderDeliveryDate} delivery</span>${orderDiscountText}</p>
                    <p class="delivery-details">${orderAmountText} Billing on ${billingRemaining} at 9pm</p>
                  </div>
                  ${skipHTML}
                </div>
              `;
          }
      }
      return upconimgHTML;
    }
    async function updateSubscriptionUI(subscription,upcoming,history,inCsv,index,totalVisibleCount,displayNum,cachedContractDetails){
      // Derive subscriptionId from the passed `subscription` parameter, not
      // from allContractDetails[index] — index can be stale (data-index from
      // initial render no longer matches array position after mutations),
      // which would render every button with another contract's ID.
      const _subIdFromSub = parseInt(String(subscription?.id || '').split('/').pop(), 10);
      const detailsList = cachedContractDetails || allContractDetails;
      let contract = detailsList[index];
      if (_subIdFromSub && (!contract || contract.subscriptionContractId !== _subIdFromSub)) {
        const realIdx = detailsList.findIndex(c => c && c.subscriptionContractId === _subIdFromSub);
        if (realIdx >= 0) { contract = detailsList[realIdx]; index = realIdx; }
      }
      const num = displayNum || (index + 1);
      const subscriptionId = _subIdFromSub || contract?.subscriptionContractId;
      // Recalculate amount from subscription lines if available (handles discount changes)
      let subscriptionAmount;
      let originalAmount;
      if (subscription?.lines?.nodes?.length) {
        const linesTotal = subscription.lines.nodes.reduce((sum, node) => {
          // lineDiscountedPrice is the total for the line (qty * discounted unit price)
          // currentPrice is the per-unit price (fallback if no discount)
          if (node.lineDiscountedPrice?.amount != null) {
            return sum + parseFloat(node.lineDiscountedPrice.amount);
          }
          return sum + parseFloat(node.currentPrice?.amount || 0) * (node.quantity || 1);
        }, 0);
        subscriptionAmount = linesTotal.toFixed(2);
        // Pre-discount total: used for per-delivery .delivery-details (non-first orders pay full price)
        originalAmount = subscription.lines.nodes.reduce((sum, node) => {
          return sum + parseFloat(node.currentPrice?.amount || 0) * (node.quantity || 1);
        }, 0).toFixed(2);
        // Sync cached contract amount
        if (contract) contract.contractAmount = subscriptionAmount;
      } else {
        subscriptionAmount = Number(contract.contractAmount).toFixed(2);
        originalAmount = subscriptionAmount;
      }
      const status = subscription.status;
      const subscriptionTitle = subscription.deliveryMethod?.address?.address1 || 'Subscription';

      // --- CANCELLED: return early with simple HTML, skip all date/delivery calculations ---
      if (status === "CANCELLED") {
        const effectiveVisibleCount = totalVisibleCount || document.querySelectorAll('.acct-panel[data-panel="subscriptions"] > [data-subscription-id]').length + 1;
        const showDeleteBtn = effectiveVisibleCount > 1;
        const deleteBtnHTML = showDeleteBtn ? `
          <button type="button" class="btn-hide-subscription" data-subscription-id="${subscriptionId}" title="Remove from list" aria-label="Remove subscription from list">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.99481 5.11426C9.60055 5.11426 11.2063 5.11426 12.812 5.11426C13.0829 5.11426 13.2107 5.23653 13.2107 5.49591C13.2107 8.33376 13.2107 11.1716 13.2107 14.0095C13.2107 14.8244 12.6385 15.4879 11.8005 15.6406C11.6909 15.6605 11.5766 15.6663 11.4645 15.6668C9.16505 15.6681 6.86564 15.6596 4.56622 15.6719C3.58391 15.6769 2.77173 14.9483 2.77935 13.9727C2.79247 12.3242 2.78274 10.6757 2.78274 9.02724C2.78274 7.84802 2.78274 6.66837 2.78274 5.48914C2.78274 5.28351 2.87415 5.15784 3.05106 5.12188C3.09508 5.11299 3.14206 5.11469 3.18777 5.11469C4.79012 5.11469 6.39247 5.11426 7.99481 5.11426Z" fill="#1B1C1E" fill-opacity="0.7" />
              <path d="M4.56496 2.09926C4.63352 1.80942 4.85148 1.66133 5.08849 1.53651C5.49691 1.32115 5.94045 1.21452 6.39119 1.13371C7.06243 1.01269 7.74046 0.981384 8.42016 1.00973C9.17393 1.04104 9.91924 1.13413 10.6303 1.40746C10.8546 1.49336 11.0721 1.59533 11.2431 1.76923C11.3079 1.83523 11.3705 1.91605 11.3993 2.00152C11.4289 2.0891 11.4716 2.10095 11.5499 2.10053C12.0358 2.09799 12.5217 2.09672 13.0076 2.10053C13.3242 2.10264 13.5907 2.29432 13.6365 2.60066C13.6716 2.83633 13.6682 3.08724 13.6293 3.3225C13.5823 3.60429 13.3072 3.79512 13.0198 3.79512C9.67462 3.79596 6.32982 3.79596 2.98461 3.79512C2.59482 3.79512 2.30279 3.45578 2.3413 3.06693C2.35442 2.93491 2.3303 2.7991 2.34808 2.66793C2.39505 2.32351 2.65111 2.10264 2.99816 2.10053C3.47683 2.09757 3.95593 2.09969 4.4346 2.09969C4.4765 2.09969 4.51883 2.09926 4.56496 2.09926Z" fill="#1B1C1E" fill-opacity="0.7" />
            </svg>
          </button>
        ` : '';
        return `
          <div class="acct-section" data-subscription-id="${subscriptionId}">
              <div class="acct-section__head">
                <h2 class="acct-section__title">Subscription ${num}</h2>
              </div>
              <article class="subscription-section acct-card acct-sub" data-subscription-id="${subscriptionId}">
                <div class="subscription-header acct-sub__head">
                  <div class="acct-sub__title">
                    <h3 class="acct-sub__name">${subscriptionTitle} 📦 #${num}</h3>
                    ${showDeleteBtn ? `<button type="button" class="acct-iconbtn btn-hide-subscription" data-popup="delivery-hide-subscription-pop-up" data-subscription-id="${subscriptionId}" aria-label="Delete subscription">
                      <svg viewBox="0 0 28 28" fill="none" aria-hidden="true"><path d="M18.6667 6.9987V6.06536C18.6667 4.75858 18.6667 4.10518 18.4123 3.60605C18.1886 3.16701 17.8317 2.81005 17.3926 2.58635C16.8935 2.33203 16.2401 2.33203 14.9333 2.33203H13.0667C11.7599 2.33203 11.1065 2.33203 10.6074 2.58635C10.1683 2.81005 9.81136 3.16701 9.58765 3.60605C9.33333 4.10518 9.33333 4.75858 9.33333 6.06536V6.9987M11.6667 13.4154V19.2487M16.3333 13.4154V19.2487M3.5 6.9987H24.5M22.1667 6.9987V20.0654C22.1667 22.0255 22.1667 23.0056 21.7852 23.7543C21.4496 24.4129 20.9142 24.9483 20.2556 25.2839C19.5069 25.6654 18.5269 25.6654 16.5667 25.6654H11.4333C9.47315 25.6654 8.49306 25.6654 7.74437 25.2839C7.0858 24.9483 6.55037 24.4129 6.21481 23.7543C5.83333 23.0056 5.83333 22.0255 5.83333 20.0654V6.9987" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </button>` : ''}
                  </div>
                  <div class="subscription-details acct-sub__tags">
                    <span class="acct-badge acct-badge--cancelled">Cancelled</span>
                  </div>
                </div>
                <button class="btn acct-btn acct-btn--dark acct-btn--block reactive-subscription-btn" type="button" data-subscription-id="${subscriptionId}" data-index="${index}">Reactivate Now</button>
              </article>
          </div>
        `;
      }

      const subscriptionDeliveryPrice = parseFloat(subscription.deliveryPrice.amount);
      const subscriptionTotal = (parseFloat(subscriptionAmount) + subscriptionDeliveryPrice).toFixed(2);
      const subscriptionItems = subscription.lines?.nodes || [];
      const myHistoryAndUpcoming = moveItemsBetweenArrays(history,upcoming);
      const currentHistory = myHistoryAndUpcoming.updatedHistory;
      const currentUpcoming = myHistoryAndUpcoming.updatedUpcoming.sort((a, b) => {
          return new Date(a.billingDate) - new Date(b.billingDate);
      });

      const city = subscription.deliveryMethod?.address?.city;
      const state = subscription.deliveryMethod?.address?.provinceCode;
      const postcode = subscription.deliveryMethod?.address?.zip;

      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const zone = await findZoneData(city, state, postcode);

      const findIndex = daysOfWeek.findIndex((day) => zone?.day?.includes(day));
      const checkDay = daysOfWeek.findIndex((day_2) => zone?.day_2?.includes(day_2));

      // Removed: history → upcoming re-routing by delivery date.
      // Per client request, display API arrays as-is.
      let g_firstOrder = false; // Existing scheduled bills already belong to this cycle; never apply the first-checkout cutoff.
      let historyHTML = '';
      for (const [subindex, item] of currentHistory.entries()) {
        const id = item.orderId;
        const status = item.status;
        const deliveryLabel = historyDeliveryLabel(zone, item, subscription);
        let disabledClass = '';
        let orderMarker = '';
        if(status == 'SKIPPED'){
          disabledClass = 'disabled';
          orderMarker = `
            <div class="tag">Skipped</div>
          `;
        }else if(status == 'CONTRACT_PAUSED'){
          disabledClass = 'disabled';
          orderMarker = `
            <div class="tag">Contract Paused</div>
          `;
        }else{
          orderMarker = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.59961 18L15.5996 12L9.59961 6" stroke="#1B1C1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          `;
        }
        historyHTML += `
          <div class="order-history-item ${disabledClass}" data-id="${id}" data-index="${index}">
            <span class="delivery-date">${deliveryLabel}</span>
            ${orderMarker}
          </div>
        `;
      }

      let noHistoryClass = '';
      if(currentHistory.length == 0){
        noHistoryClass = 'hidden';
      }


      const upconimgHTML = reloadUpcomingList(findIndex,checkDay,subscriptionId,currentUpcoming,subscriptionAmount,originalAmount,subscription);

      let slidesHTML = '';
      for (const item of subscriptionItems) {
          const img = item.variantImage?.url ?? item.variantImage?.transformedSrc ?? '';
          const title = item.title;
          if(img != ''){
            slidesHTML += `
                <div class="swiper-slide acct-thumb">
                    <div class="img"><img src="${img}" alt="${title}" /></div>
                </div>
            `;
          }
      }

      const _discounts2 = (subscription.discounts?.nodes || []).filter(Boolean);
      let topDiscountHTML;
      let discountHTML;
      let discountClass = '';
      let discountId = '';

      if (_discounts2.length) {
        discountId = _discounts2.map((d) => d.id).filter(Boolean).join(',');
        discountHTML = _discounts2.map((d) => _buildDiscountHTML(d, subscription)).join('');
        const _codes2 = _discounts2.map((d) => d.title).filter(Boolean).join(', ');
        topDiscountHTML = `
          <strong>Discount:</strong>
          <span>${_codes2}</span>
        `;
        discountClass = 'has-discount';
      } else {
        discountHTML = `
          <p>No code applied</p>
        `;
        topDiscountHTML = `
          <strong>Discount:</strong>
          <span>None</span>
        `;
      }

      const lastDigits = subscription.customerPaymentMethod?.instrument?.lastDigits;
      const customAttributes = subscription.customAttributes;
      const packagingValue = customAttributes.find(attr => attr.key === "Packaging Preferences")?.value || '';
      const veganValue = customAttributes.find(attr => attr.key === "Dietary preferences")?.value
                      || customAttributes.find(attr => attr.key === "Vegan or vegetarian?")?.value
                      || '';
      const householdValue = customAttributes.find(attr => attr.key === "Household size")?.value
                          || customAttributes.find(attr => attr.key === "Household")?.value
                          || '';

      const intervalCount = subscription.deliveryPolicy.intervalCount;
      let newPlanName = '';
      let planId = '';
      switch (intervalCount) {
          case 1:
            newPlanName = 'Weekly';
            planId = '2067431485';
              break;
          case 2:
            newPlanName = 'Fortnightly';
            planId = '2068348989';
              break;
          case 4:
            newPlanName = 'Monthly';
            planId = '2068381757';
              break;
      }

      const shippingAddressArr = subscription.deliveryMethod?.address || {};
      const shippingFirstName = shippingAddressArr.firstName || '';
      const shippingLastName = shippingAddressArr.lastName || '';
      const shippingPhone = shippingAddressArr.phone || '';
      const shippingAddress1 = shippingAddressArr.address1 || '';
      const shippingAddress2 = shippingAddressArr.address2 || '';
      const shippingSuburb = shippingAddressArr.city || '';
      const shippingState = shippingAddressArr.provinceCode || '';
      const shippingPostcode = shippingAddressArr.zip || '';
      const deliveryInstructions = customAttributes.find(attr => attr.key === "Delivery Instructions")?.value || '';



      const subscriptionProducts = subscription.lines.nodes;
      const hasCharity = subscriptionProducts?.some(item => 
        item.productId === "gid://shopify/Product/7663767552061"
      );
      const hasVariety = subscriptionProducts?.some(item => 
        item.productId === "gid://shopify/Product/7647008161853" || item.productId === "gid://shopify/Product/7806528684093" || item.productId === "gid://shopify/Product/6709203730493" || item.productId === "gid://shopify/Product/6709203304509" || item.productId === "gid://shopify/Product/7046147506237"
      );

      let editClass = '';
      if(hasCharity){
        editClass = 'relief-box';
      }

      let excludingClass = '';
      if(!hasVariety){
        excludingClass = 'hidden';
      }


      const overlay = document.querySelector('.cart-modal-overlay');
      const boxIds = overlay?.dataset.ids
        ? overlay.dataset.ids.split(',').map(id => id.trim()).filter(Boolean)
        : [];

      const itemsWithBoxItems = subscriptionProducts?.filter(item => {
        const numericId = item.productId?.split('/').pop();
        return boxIds.includes(numericId);
      });
      // const itemsWithBoxItems = subscriptionProducts?.filter(item => 
      //     item.customAttributes && 
      //     item.customAttributes.some(attr => attr.key === "Box items")
      // );

      const itemIds = itemsWithBoxItems?.map(item => item.id);

      let excludingValue = window.FFSubscriptionPreferences.read(subscription).join(', ');

      let excludingStr;
      if(excludingValue == ''){
        excludingStr = 'None';
      }else{
        excludingStr = excludingValue;
      }

      const resumeDate = customAttributes.find(attr => attr.key === "Resume date")?.value || '';
      const preorderDate = customAttributes.find(attr => attr.key === "Preorder date")?.value || '';

      const nextBillingDate = subscription.nextBillingDate;

      // For CANCELLED subscriptions, nextBillingDate is null — skip date calculations
      let billingWeekDay = 0;
      let preResumeDate = '';
      let minResumeDate = '';
      let orderNextDeliveryDate = '';
      let textOrderNextDeliveryDate = '';
      let formattedNextDeliveryDate = '';
      let formattedNextBillingDate = '';
      let textNextBillingDate = '';

      if (nextBillingDate) {
        const minResumeBillingDate = getTargetDate(preorderDate);

        const date = new Date(nextBillingDate);
        billingWeekDay = date.getDay();

        if(resumeDate != ''){
          const { date: preResume } = getDeliveryDate(findIndex,checkDay,resumeDate,g_firstOrder);
          preResumeDate = preResume;
        }

        if(preorderDate != ''){
          const { date: minResume } = getDeliveryDate(findIndex,checkDay,minResumeBillingDate,g_firstOrder);
          minResumeDate = minResume;
        }

        const { newFormattedDate: nextDeliveryDate } = getDeliveryDate(findIndex,checkDay,nextBillingDate,g_firstOrder);
        const { date: nextDate } = getDeliveryDate(findIndex,checkDay,nextBillingDate,g_firstOrder);
        textOrderNextDeliveryDate = nextDeliveryDate;
        orderNextDeliveryDate = nextDate;

        formattedNextDeliveryDate = new Date(orderNextDeliveryDate).toISOString().split('T')[0];
        formattedNextBillingDate = new Date(nextBillingDate).toISOString().split('T')[0];
        textNextBillingDate = newFormatDateToDay(nextBillingDate);
      }



      let subscriptionsHTML = "";
      switch (status) {
          case "ACTIVE":
              if (!resumeDate || 
                  (new Date(resumeDate).toDateString() === new Date(nextBillingDate).toDateString() && 
                  new Date() > new Date(nextBillingDate))) {
                subscriptionsHTML = `
                    <div class="acct-subgroup" data-subscription-id="${subscriptionId}">
                      <div class="acct-section">
                        <div class="acct-section__head">
                          <h2 class="acct-section__title">Subscription ${num}</h2>
                        </div>

                        <article class="subscription-section acct-card acct-sub" data-subscription-id="${subscriptionId}">
                          <div class="subscription-header acct-sub__head">
                            <div class="acct-sub__title">
                              <h3 class="acct-sub__name">${subscriptionTitle} 📦 #${num}</h3>
                            </div>
                            <div class="subscription-details acct-sub__tags">
                              <div class="detail-item discount-code acct-chip" data-popup="delivery-code-pop-up" data-index="${index}" data-subscription-id="${subscriptionId}">
                                <div class="detail-item__label ${discountClass}">
                                  ${topDiscountHTML}
                                </div>
                                <span class="icon-edit top-edit-discount-btn ${discountClass}" aria-label="Edit discount"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M14.8556 4.0911C14.8407 4.86813 14.5927 5.47717 14.0932 5.97691C11.4557 8.61637 8.81732 11.2546 6.17386 13.8876C6.07983 13.9812 5.93474 14.0467 5.80285 14.076C4.62472 14.3372 3.44361 14.586 2.2642 14.8412C1.85787 14.9292 1.52643 14.6047 1.61365 14.2062C1.87702 13.0017 2.13443 11.796 2.4012 10.5928C2.42503 10.4856 2.48162 10.3695 2.5582 10.2925C4.63833 8.2068 6.72357 6.12619 8.8071 4.04346C9.37 3.48078 9.92014 2.90449 10.4958 2.35457C11.2263 1.65706 12.0964 1.43037 13.0652 1.72681C14.0255 2.02027 14.5956 2.69566 14.8075 3.67217C14.842 3.83166 14.8454 3.99795 14.8552 4.0911H14.8556ZM2.78413 13.675C3.66485 13.4857 4.52388 13.3041 5.38035 13.1131C5.47609 13.0919 5.57692 13.0336 5.6467 12.9639C7.59068 11.0266 9.53126 9.08591 11.4718 7.14565C11.5076 7.1095 11.5408 7.0708 11.5663 7.04316C10.8443 6.32183 10.1316 5.60944 9.41638 4.8945C9.41212 4.89748 9.39808 4.90471 9.38745 4.91534C7.40517 6.89685 5.4229 8.87836 3.44233 10.8616C3.40319 10.9007 3.3683 10.9551 3.35681 11.0083C3.16535 11.8874 2.97814 12.7674 2.78413 13.6754V13.675ZM10.1729 4.11747C10.903 4.84729 11.6165 5.56096 12.3224 6.26654C12.6717 5.92417 13.0397 5.57329 13.3967 5.21136C13.9451 4.6559 13.9723 3.73767 13.4656 3.15797C12.9448 2.56212 12.0258 2.43495 11.4161 2.92873C10.9659 3.29322 10.5741 3.72916 10.1729 4.11704V4.11747Z" fill="#1B1C1E" fill-opacity="0.7"/><path d="M10.4365 2.29199C11.1886 1.57409 12.0909 1.33856 13.0908 1.64453C14.0834 1.94801 14.6737 2.65013 14.8916 3.6543C14.9185 3.77876 14.9289 3.91159 14.9355 4.00488H14.9434L14.9424 4.09277C14.9271 4.88995 14.6711 5.52106 14.1543 6.03809C11.5168 8.67752 8.87884 11.3161 6.23535 13.9492H6.23438C6.12531 14.0575 5.96348 14.1285 5.82129 14.1602C4.64299 14.4213 3.46091 14.6708 2.28223 14.9258C1.81714 15.0264 1.42806 14.65 1.5293 14.1875C1.79248 12.9839 2.04966 11.7773 2.31641 10.5742C2.34305 10.4544 2.40678 10.3222 2.49707 10.2314C4.57725 8.14569 6.66265 6.06506 8.74609 3.98242C9.30695 3.42178 9.86005 2.84269 10.4365 2.29199ZM3.50391 10.9229C3.47294 10.9538 3.44849 10.9939 3.44141 11.0264C3.25927 11.8627 3.08051 12.7 2.89648 13.5615C3.73184 13.3823 4.5477 13.2097 5.36133 13.0283C5.43957 13.0109 5.5267 12.9616 5.58594 12.9023C7.5296 10.9654 9.46982 9.02497 11.4102 7.08496L11.4453 7.04492C10.7627 6.36291 10.0887 5.68802 9.41211 5.01172C7.44182 6.98125 5.47247 8.95166 3.50391 10.9229ZM13.4004 3.21484C12.9066 2.64994 12.0402 2.53494 11.4707 2.99609C11.0473 3.33891 10.6791 3.74064 10.2949 4.11719C10.6391 4.46125 10.9796 4.80185 11.3174 5.13965C11.6548 5.47703 11.9903 5.8117 12.3232 6.14453C12.655 5.82038 12.9994 5.49059 13.335 5.15039C13.8518 4.62694 13.8771 3.7602 13.4004 3.21484Z" stroke="#1B1C1E" stroke-opacity="0.7" stroke-width="0.172907"/></svg></span>
                              </div>
                              <div class="detail-item frequency acct-freq" data-popup="delivery-frequency-pop-up" data-subscription-id="${subscriptionId}">
                                <div class="detail-item__label">
                                  <strong>Frequency:</strong>
                                  <span>${newPlanName}</span>
                                </div>
                                <span class="icon-edit top-edit-frequency-btn" aria-label="Edit frequency"><svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M14.8556 4.0911C14.8407 4.86813 14.5927 5.47717 14.0932 5.97691C11.4557 8.61637 8.81732 11.2546 6.17386 13.8876C6.07983 13.9812 5.93474 14.0467 5.80285 14.076C4.62472 14.3372 3.44361 14.586 2.2642 14.8412C1.85787 14.9292 1.52643 14.6047 1.61365 14.2062C1.87702 13.0017 2.13443 11.796 2.4012 10.5928C2.42503 10.4856 2.48162 10.3695 2.5582 10.2925C4.63833 8.2068 6.72357 6.12619 8.8071 4.04346C9.37 3.48078 9.92014 2.90449 10.4958 2.35457C11.2263 1.65706 12.0964 1.43037 13.0652 1.72681C14.0255 2.02027 14.5956 2.69566 14.8075 3.67217C14.842 3.83166 14.8454 3.99795 14.8552 4.0911H14.8556ZM2.78413 13.675C3.66485 13.4857 4.52388 13.3041 5.38035 13.1131C5.47609 13.0919 5.57692 13.0336 5.6467 12.9639C7.59068 11.0266 9.53126 9.08591 11.4718 7.14565C11.5076 7.1095 11.5408 7.0708 11.5663 7.04316C10.8443 6.32183 10.1316 5.60944 9.41638 4.8945C9.41212 4.89748 9.39808 4.90471 9.38745 4.91534C7.40517 6.89685 5.4229 8.87836 3.44233 10.8616C3.40319 10.9007 3.3683 10.9551 3.35681 11.0083C3.16535 11.8874 2.97814 12.7674 2.78413 13.6754V13.675ZM10.1729 4.11747C10.903 4.84729 11.6165 5.56096 12.3224 6.26654C12.6717 5.92417 13.0397 5.57329 13.3967 5.21136C13.9451 4.6559 13.9723 3.73767 13.4656 3.15797C12.9448 2.56212 12.0258 2.43495 11.4161 2.92873C10.9659 3.29322 10.5741 3.72916 10.1729 4.11704V4.11747Z" fill="#1B1C1E" fill-opacity="0.7"/><path d="M10.4365 2.29199C11.1886 1.57409 12.0909 1.33856 13.0908 1.64453C14.0834 1.94801 14.6737 2.65013 14.8916 3.6543C14.9185 3.77876 14.9289 3.91159 14.9355 4.00488H14.9434L14.9424 4.09277C14.9271 4.88995 14.6711 5.52106 14.1543 6.03809C11.5168 8.67752 8.87884 11.3161 6.23535 13.9492H6.23438C6.12531 14.0575 5.96348 14.1285 5.82129 14.1602C4.64299 14.4213 3.46091 14.6708 2.28223 14.9258C1.81714 15.0264 1.42806 14.65 1.5293 14.1875C1.79248 12.9839 2.04966 11.7773 2.31641 10.5742C2.34305 10.4544 2.40678 10.3222 2.49707 10.2314C4.57725 8.14569 6.66265 6.06506 8.74609 3.98242C9.30695 3.42178 9.86005 2.84269 10.4365 2.29199ZM3.50391 10.9229C3.47294 10.9538 3.44849 10.9939 3.44141 11.0264C3.25927 11.8627 3.08051 12.7 2.89648 13.5615C3.73184 13.3823 4.5477 13.2097 5.36133 13.0283C5.43957 13.0109 5.5267 12.9616 5.58594 12.9023C7.5296 10.9654 9.46982 9.02497 11.4102 7.08496L11.4453 7.04492C10.7627 6.36291 10.0887 5.68802 9.41211 5.01172C7.44182 6.98125 5.47247 8.95166 3.50391 10.9229ZM13.4004 3.21484C12.9066 2.64994 12.0402 2.53494 11.4707 2.99609C11.0473 3.33891 10.6791 3.74064 10.2949 4.11719C10.6391 4.46125 10.9796 4.80185 11.3174 5.13965C11.6548 5.47703 11.9903 5.8117 12.3232 6.14453C12.655 5.82038 12.9994 5.49059 13.335 5.15039C13.8518 4.62694 13.8771 3.7602 13.4004 3.21484Z" stroke="#1B1C1E" stroke-opacity="0.7" stroke-width="0.172907"/></svg></span>
                              </div>
                            </div>
                          </div>
                          <div class="subscription-contents">
                            <div class="subscription-contents-slider acct-thumbs">
                              <div class="swiper-wrapper">${slidesHTML}</div>
                              <div class="button-wrapper" style="display:none">
                                <button class="btn btn--edit edit-subscription-btn ${editClass}" data-subscription-id="${subscriptionId}"><span>Edit</span></button>
                              </div>
                            </div>
                          </div>
                          <button class="btn acct-btn acct-btn--primary acct-btn--block edit-subscription-btn ${editClass}" data-subscription-id="${subscriptionId}" type="button"><span>Edit box</span></button>
                        </article>
                      </div>

                      <div class="acct-section">
                        <div class="deliveries-title acct-section__head">
                          <h2 class="acct-section__title">Upcoming deliveries</h2>
                        </div>
                        <div class="subscription-contents__deliveries acct-card">
                          <div class="delivery-items">${upconimgHTML}</div>
                        </div>
                        <div class="acct-seemore-wrap"><button class="acct-seemore" type="button">See More</button></div>
                      </div>

                      <div class="order-history ${noHistoryClass}" style="display:none">
                        <div class="order-history__title">
                          <h3>Order History</h3>
                        </div>
                        <div class="order-history__items">
                          <div class="order-history-items">${historyHTML}</div>
                          <div class="see-more">
                            <button class="btn">See more</button>
                          </div>
                        </div>
                      </div>

                      <div class="settings acct-card">
                        <div class="settings__title active">
                          <h3>Settings</h3>
                          <button class="acct-iconbtn acct-settings__toggle" type="button" aria-expanded="true" aria-label="Collapse settings">
                            <svg class="acct-settings__ico" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                              <path d="M10.0005 2.9957L10.0005 17.0043M2.9955 10L17.0045 10" stroke="currentColor" stroke-width="2.00123" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                        </div>
                        <div class="settings__items">
                          <div class="setting-item delivery-info"
                            role="button" tabindex="0" data-popup="delivery-information-pop-up"
                            data-subscription-id="${subscriptionId}"
                            data-index="${index}"
                            data-firstname="${shippingFirstName}"
                            data-lastname="${shippingLastName}"
                            data-phone="${shippingPhone}"
                            data-address1="${shippingAddress1}"
                            data-address2="${shippingAddress2}"
                            data-suburb="${shippingSuburb}"
                            data-state="${shippingState}"
                            data-postcode="${shippingPostcode}"
                            data-instructions="${deliveryInstructions}">
                            <div class="setting-item__text">
                              <h4>Delivery Information</h4>
                              <p>${shippingAddress1}</p>
                            </div>
                            <span class="icon-arrow">
                              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                          </div>
                          <div class="setting-item payment-method" role="button" tabindex="0" data-popup="delivery-payment-pop-up" data-subscription-id="${subscriptionId}">
                            <div class="setting-item__text">
                              <h4>Payment Method</h4>
                              <p>Ending in ${lastDigits}</p>
                            </div>
                            <span class="icon-arrow">
                              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                          </div>
                          <div class="setting-item edit-frequency" role="button" tabindex="0" data-popup="delivery-frequency-pop-up" data-subscription-id="${subscriptionId}" data-findindex="${findIndex}" data-checkday="${checkDay}" data-plan-id="${planId}" data-subscription-amount="${subscriptionAmount}">
                            <div class="setting-item__text">
                              <h4>Frequency</h4>
                              <p>${newPlanName}</p>
                            </div>
                            <span class="icon-arrow">
                              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                          </div>
                          <div class="setting-item apply-code ${discountClass}" role="button" tabindex="0" data-popup="delivery-code-pop-up" data-subscription-id="${subscriptionId}" data-index="${index}" data-discount-id="${discountId}">
                            <div class="setting-item__text">
                              <h4>Apply discount code</h4>
                              <div class="current-code-wrap">
                                ${discountHTML}
                              </div>
                            </div>
                            <span class="icon-arrow">
                              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                          </div>
                          <div class="setting-item packaging-recycle" role="button" tabindex="0" data-popup="delivery-recycle-pop-up.pickaging-set" data-value="${packagingValue}" data-index="${index}" data-subscription-id="${subscriptionId}">
                            <div class="setting-item__text">
                              <h4>Packaging Preferences</h4>
                              <p>${packagingValue}</p>
                            </div>
                            <span class="icon-arrow">
                              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                          </div>
                          <div class="setting-item vegan-recycle" role="button" tabindex="0" data-popup="delivery-recycle-pop-up.vegan-set" data-value="${veganValue}" data-index="${index}" data-subscription-id="${subscriptionId}">
                            <div class="setting-item__text">
                              <h4>Dietary preferences</h4>
                              <p>${veganValue}</p>
                            </div>
                            <span class="icon-arrow">
                              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                          </div>
                          <div class="setting-item household-set" role="button" tabindex="0" data-popup="delivery-household-pop-up" data-value="${householdValue}" data-index="${index}" data-subscription-id="${subscriptionId}">
                            <div class="setting-item__text">
                              <h4>Household size</h4>
                              <p>${householdValue}</p>
                            </div>
                            <span class="icon-arrow">
                              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                          </div>
                          <div class="setting-item manage-subscription" role="button" tabindex="0" data-popup="delivery-manage-pop-up" data-billing-week="${billingWeekDay}" data-pre-billing-date="${formattedNextBillingDate}" data-index="${index}" data-subscription-id="${subscriptionId}" data-limit-week="${findIndex}" data-checkday="${checkDay}" data-delivery-date="${formattedNextDeliveryDate}" data-time="1">
                            <div class="setting-item__text">
                              <h4>Manage Subscription</h4>
                              <p>Pause or cancel</p>
                            </div>
                            <span class="icon-arrow">
                              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                `;
              } else {
                const formattedPreResumeDate = new Date(preResumeDate).toISOString().split('T')[0];
                const formattedMinResumeDate = new Date(minResumeDate).toISOString().split('T')[0];

              // Active-but-with-resumeDate is the effective "paused" state in
              // Appstle (status stays ACTIVE, resumeDate holds the future
              // billing). Render with the same prototype paused card the
              // status==="PAUSED" branch below uses. Keeps .detail-item.paused
              // + .paused--date + .next-billing--date + resume-subscription-false-btn
              // so the pause-date edit modal + Resume Now handler still fire.
              subscriptionsHTML = `
                  <div class="acct-section" data-subscription-id="${subscriptionId}">
                      <div class="acct-section__head">
                        <h2 class="acct-section__title">Subscription ${num}</h2>
                      </div>
                      <article class="subscription-section acct-card acct-sub" data-subscription-id="${subscriptionId}">
                        <div class="subscription-header acct-sub__head">
                          <div class="acct-sub__title">
                            <h3 class="acct-sub__name">${subscriptionTitle} 📦 #${num}</h3>
                          </div>
                          <div class="subscription-details acct-sub__tags">
                            <div class="detail-item paused acct-chip" data-subscription-id="${subscriptionId}" data-index="${index}" data-billing-week="${billingWeekDay}" data-limit-week="${findIndex}" data-checkday="${checkDay}" data-delivery-date="${formattedMinResumeDate}" data-time="1" data-previous-date="${formattedPreResumeDate}">
                              <div class="detail-item__label">
                                <strong>Paused:</strong>
                                <span>Until <span class="paused--date" data-subscription-id="${subscriptionId}">${textOrderNextDeliveryDate}</span> Delivery</span>
                              </div>
                              <span class="icon-edit" aria-label="Edit pause date">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                  <path d="M14.8556 4.0911C14.8407 4.86813 14.5927 5.47717 14.0932 5.97691C11.4557 8.61637 8.81732 11.2546 6.17386 13.8876C6.07983 13.9812 5.93474 14.0467 5.80285 14.076C4.62472 14.3372 3.44361 14.586 2.2642 14.8412C1.85787 14.9292 1.52643 14.6047 1.61365 14.2062C1.87702 13.0017 2.13443 11.796 2.4012 10.5928C2.42503 10.4856 2.48162 10.3695 2.5582 10.2925C4.63833 8.2068 6.72357 6.12619 8.8071 4.04346C9.37 3.48078 9.92014 2.90449 10.4958 2.35457C11.2263 1.65706 12.0964 1.43037 13.0652 1.72681C14.0255 2.02027 14.5956 2.69566 14.8075 3.67217C14.842 3.83166 14.8454 3.99795 14.8552 4.0911H14.8556ZM2.78413 13.675C3.66485 13.4857 4.52388 13.3041 5.38035 13.1131C5.47609 13.0919 5.57692 13.0336 5.6467 12.9639C7.59068 11.0266 9.53126 9.08591 11.4718 7.14565C11.5076 7.1095 11.5408 7.0708 11.5663 7.04316C10.8443 6.32183 10.1316 5.60944 9.41638 4.8945C9.41212 4.89748 9.39808 4.90471 9.38745 4.91534C7.40517 6.89685 5.4229 8.87836 3.44233 10.8616C3.40319 10.9007 3.3683 10.9551 3.35681 11.0083C3.16535 11.8874 2.97814 12.7674 2.78413 13.6754V13.675ZM10.1729 4.11747C10.903 4.84729 11.6165 5.56096 12.3224 6.26654C12.6717 5.92417 13.0397 5.57329 13.3967 5.21136C13.9451 4.6559 13.9723 3.73767 13.4656 3.15797C12.9448 2.56212 12.0258 2.43495 11.4161 2.92873C10.9659 3.29322 10.5741 3.72916 10.1729 4.11704V4.11747Z" fill="#1B1C1E" fill-opacity="0.7"/>
                                  <path d="M10.4365 2.29199C11.1886 1.57409 12.0909 1.33856 13.0908 1.64453C14.0834 1.94801 14.6737 2.65013 14.8916 3.6543C14.9185 3.77876 14.9289 3.91159 14.9355 4.00488H14.9434L14.9424 4.09277C14.9271 4.88995 14.6711 5.52106 14.1543 6.03809C11.5168 8.67752 8.87884 11.3161 6.23535 13.9492H6.23438C6.12531 14.0575 5.96348 14.1285 5.82129 14.1602C4.64299 14.4213 3.46091 14.6708 2.28223 14.9258C1.81714 15.0264 1.42806 14.65 1.5293 14.1875C1.79248 12.9839 2.04966 11.7773 2.31641 10.5742C2.34305 10.4544 2.40678 10.3222 2.49707 10.2314C4.57725 8.14569 6.66265 6.06506 8.74609 3.98242C9.30695 3.42178 9.86005 2.84269 10.4365 2.29199ZM3.50391 10.9229C3.47294 10.9538 3.44849 10.9939 3.44141 11.0264C3.25927 11.8627 3.08051 12.7 2.89648 13.5615C3.73184 13.3823 4.5477 13.2097 5.36133 13.0283C5.43957 13.0109 5.5267 12.9616 5.58594 12.9023C7.5296 10.9654 9.46982 9.02497 11.4102 7.08496L11.4453 7.04492C10.7627 6.36291 10.0887 5.68802 9.41211 5.01172C7.44182 6.98125 5.47247 8.95166 3.50391 10.9229ZM13.4004 3.21484C12.9066 2.64994 12.0402 2.53494 11.4707 2.99609C11.0473 3.33891 10.6791 3.74064 10.2949 4.11719C10.6391 4.46125 10.9796 4.80185 11.3174 5.13965C11.6548 5.47703 11.9903 5.8117 12.3232 6.14453C12.655 5.82038 12.9994 5.49059 13.335 5.15039C13.8518 4.62694 13.8771 3.7602 13.4004 3.21484Z" stroke="#1B1C1E" stroke-opacity="0.7" stroke-width="0.172907"/>
                                </svg>
                              </span>
                            </div>
                          </div>
                          <p class="edit-paused-date">
                            Edit box contents from
                            <span class="next-billing--date" data-subscription-id="${subscriptionId}">${textNextBillingDate}</span>
                          </p>
                        </div>
                        <div class="subscription-contents">
                          <div class="subscription-contents-slider">
                            <div class="subscription-contents__title">
                              <h3>Subscription Contents</h3>
                              <p class="subscription-contents__price">$${subscriptionAmount}</p>
                            </div>
                            <div class="subscription-contents__slider acct-thumbs">
                              <div class="swiper-wrapper">${slidesHTML}</div>
                            </div>
                            <div class="button-wrapper">
                              <button class="btn btn--resume resume-subscription-false-btn acct-btn acct-btn--dark acct-btn--block" type="button" data-subscription-id="${subscriptionId}" data-checkday="${checkDay}" data-index="${index}" data-next-date="${formattedMinResumeDate}" data-billing-week="${billingWeekDay}"><span>Resume Now</span></button>
                            </div>
                          </div>
                        </div>
                      </article>
                  </div>
              `;
              }
              break;
              
          case "PAUSED":
              subscriptionsHTML = `
                  <div class="acct-section" data-subscription-id="${subscriptionId}">
                      <div class="acct-section__head">
                        <h2 class="acct-section__title">Subscription ${num}</h2>
                      </div>
                      <article class="subscription-section acct-card acct-sub" data-subscription-id="${subscriptionId}">
                        <div class="subscription-header acct-sub__head">
                          <div class="acct-sub__title">
                            <h3 class="acct-sub__name">${subscriptionTitle} 📦 #${num}</h3>
                          </div>
                        </div>
                        <div class="subscription-contents">
                          <div class="subscription-contents-slider">
                            <div class="subscription-contents__title">
                              <h3>Subscription Contents</h3>
                              <p class="subscription-contents__price">$${subscriptionAmount}</p>
                            </div>
                            <div class="subscription-contents__slider acct-thumbs">
                              <div class="swiper-wrapper">${slidesHTML}</div>
                            </div>
                            <div class="button-wrapper">
                              <button class="btn btn--resume resume-subscription-true-btn acct-btn acct-btn--dark acct-btn--block" type="button" data-subscription-id="${subscriptionId}" data-index="${index}"><span>Resume Now</span></button>
                            </div>
                          </div>
                        </div>
                      </article>
                  </div>
              `;
              break;
              
          case "CANCELLED":
              // If totalVisibleCount not provided, count from DOM
              const effectiveVisibleCount = totalVisibleCount || document.querySelectorAll('.acct-panel[data-panel="subscriptions"] > [data-subscription-id]').length + 1;
              const showDeleteBtn = effectiveVisibleCount > 1;
              const deleteBtnHTML = showDeleteBtn ? `
                <button type="button" class="btn-hide-subscription" data-subscription-id="${subscriptionId}" title="Remove from list" aria-label="Remove subscription from list">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.99481 5.11426C9.60055 5.11426 11.2063 5.11426 12.812 5.11426C13.0829 5.11426 13.2107 5.23653 13.2107 5.49591C13.2107 8.33376 13.2107 11.1716 13.2107 14.0095C13.2107 14.8244 12.6385 15.4879 11.8005 15.6406C11.6909 15.6605 11.5766 15.6663 11.4645 15.6668C9.16505 15.6681 6.86564 15.6596 4.56622 15.6719C3.58391 15.6769 2.77173 14.9483 2.77935 13.9727C2.79247 12.3242 2.78274 10.6757 2.78274 9.02724C2.78274 7.84802 2.78274 6.66837 2.78274 5.48914C2.78274 5.28351 2.87415 5.15784 3.05106 5.12188C3.09508 5.11299 3.14206 5.11469 3.18777 5.11469C4.79012 5.11469 6.39247 5.11426 7.99481 5.11426Z" fill="#1B1C1E" fill-opacity="0.7" />
                    <path d="M4.56496 2.09926C4.63352 1.80942 4.85148 1.66133 5.08849 1.53651C5.49691 1.32115 5.94045 1.21452 6.39119 1.13371C7.06243 1.01269 7.74046 0.981384 8.42016 1.00973C9.17393 1.04104 9.91924 1.13413 10.6303 1.40746C10.8546 1.49336 11.0721 1.59533 11.2431 1.76923C11.3079 1.83523 11.3705 1.91605 11.3993 2.00152C11.4289 2.0891 11.4716 2.10095 11.5499 2.10053C12.0358 2.09799 12.5217 2.09672 13.0076 2.10053C13.3242 2.10264 13.5907 2.29432 13.6365 2.60066C13.6716 2.83633 13.6682 3.08724 13.6293 3.3225C13.5823 3.60429 13.3072 3.79512 13.0198 3.79512C9.67462 3.79596 6.32982 3.79596 2.98461 3.79512C2.59482 3.79512 2.30279 3.45578 2.3413 3.06693C2.35442 2.93491 2.3303 2.7991 2.34808 2.66793C2.39505 2.32351 2.65111 2.10264 2.99816 2.10053C3.47683 2.09757 3.95593 2.09969 4.4346 2.09969C4.4765 2.09969 4.51883 2.09926 4.56496 2.09926Z" fill="#1B1C1E" fill-opacity="0.7" />
                  </svg>
                </button>
              ` : '';
              subscriptionsHTML = `
          <div class="acct-section" data-subscription-id="${subscriptionId}">
              <div class="acct-section__head">
                <h2 class="acct-section__title">Subscription ${num}</h2>
              </div>
              <article class="subscription-section acct-card acct-sub" data-subscription-id="${subscriptionId}">
                <div class="subscription-header acct-sub__head">
                  <div class="acct-sub__title">
                    <h3 class="acct-sub__name">${subscriptionTitle} 📦 #${num}</h3>
                    ${showDeleteBtn ? `<button type="button" class="acct-iconbtn btn-hide-subscription" data-popup="delivery-hide-subscription-pop-up" data-subscription-id="${subscriptionId}" aria-label="Delete subscription">
                      <svg viewBox="0 0 28 28" fill="none" aria-hidden="true"><path d="M18.6667 6.9987V6.06536C18.6667 4.75858 18.6667 4.10518 18.4123 3.60605C18.1886 3.16701 17.8317 2.81005 17.3926 2.58635C16.8935 2.33203 16.2401 2.33203 14.9333 2.33203H13.0667C11.7599 2.33203 11.1065 2.33203 10.6074 2.58635C10.1683 2.81005 9.81136 3.16701 9.58765 3.60605C9.33333 4.10518 9.33333 4.75858 9.33333 6.06536V6.9987M11.6667 13.4154V19.2487M16.3333 13.4154V19.2487M3.5 6.9987H24.5M22.1667 6.9987V20.0654C22.1667 22.0255 22.1667 23.0056 21.7852 23.7543C21.4496 24.4129 20.9142 24.9483 20.2556 25.2839C19.5069 25.6654 18.5269 25.6654 16.5667 25.6654H11.4333C9.47315 25.6654 8.49306 25.6654 7.74437 25.2839C7.0858 24.9483 6.55037 24.4129 6.21481 23.7543C5.83333 23.0056 5.83333 22.0255 5.83333 20.0654V6.9987" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </button>` : ''}
                  </div>
                  <div class="subscription-details acct-sub__tags">
                    <span class="acct-badge acct-badge--cancelled">Cancelled</span>
                  </div>
                </div>
                <button class="btn acct-btn acct-btn--dark acct-btn--block reactive-subscription-btn" type="button" data-subscription-id="${subscriptionId}" data-index="${index}">Reactivate Now</button>
              </article>
          </div>
        `;
              break;
              
          default:
              break;
      }
      return subscriptionsHTML;

    }
    function goToEditPage() {
      if (_registeredListeners.has('goToEditPage')) return; _registeredListeners.add('goToEditPage');

      // Hover/touch preheat: mouseenter (desktop hover ~200–1500ms before click),
      // focusin (keyboard tab), touchstart (mobile ~100–300ms before click) all
      // fire before the click navigation. Warm the subscription + zone caches
      // during that gap so /collections/update-products can read
      // sessionStorage instead of issuing two blocking API calls on arrival.
      // Throttled per subscriptionId: 5s window prevents thrashing.
      const _preheated = new Map(); // sid -> timestamp
      const preheat = function (item) {
        try {
          if (!item || item.classList.contains('relief-box')) return;
          const sid = item.getAttribute('data-subscription-id');
          if (!sid) return;
          const now = Date.now();
          const last = _preheated.get(sid) || 0;
          if (now - last < 5000) return;
          _preheated.set(sid, now);
          // fetchCurrentSubscription writes sessionStorage `sub_<sid>` on success
          // (see appstle-api.js Batch B). maxAgeMs:60000 lets a second preheat
          // within 1 min be a no-op rather than a real request.
          if (typeof fetchCurrentSubscription === 'function') {
            fetchCurrentSubscription(customerToken, parseInt(sid, 10), { maxAgeMs: 60000 })
              .catch(function () { _preheated.delete(sid); });
          }
          // fetchZoneJsonData populates sessionStorage `cachedZoneData` via
          // findZoneData's cache-write path (common-theme.js Batch B).
          if (typeof fetchZoneJsonData === 'function' && !sessionStorage.getItem('cachedZoneData')) {
            fetchZoneJsonData().catch(function () {});
          }
        } catch (e) { /* never break portal UX for a preheat failure */ }
      };
      const onPreheat = function (event) {
        const item = event.target.closest && event.target.closest('.edit-subscription-btn');
        if (item) preheat(item);
      };
      document.addEventListener('mouseenter', onPreheat, true);
      document.addEventListener('focusin', onPreheat);
      document.addEventListener('touchstart', onPreheat, { passive: true });

      document.addEventListener('click', async function(event) {
        const item = event.target.closest('.edit-subscription-btn');
        if (item) {
          const hasReliefBoxClass = item.classList.contains('relief-box');
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          if(hasReliefBoxClass){
            showToast("Sorry you can’t edit this order since it contains a food relief box. If you’d like to shop our other products please cancel this subscription and create a new one :)",5000);
          }else{
            item.classList.add('loading');
            window.location = `/collections/update-products?token=${customerToken}&subscriptionId=${subscriptionId}`;
          }
        }
      });
    }
    function mergeAttributes(oldAttrs, newAttrs, subId) {
        const mergedMap = new Map();
        
        oldAttrs.forEach(attr => {
            mergedMap.set(attr.key, attr.value);
        });
        
        if (Array.isArray(newAttrs)) {
            newAttrs.forEach(attr => {
                mergedMap.set(attr.key, attr.value);
            });
        } else {
            mergedMap.set(newAttrs.key, newAttrs.value);
        }
        
        const customAttributesList = [];
        mergedMap.forEach((value, key) => {
            customAttributesList.push({ key, value });
        });
        
        return {
            subscriptionContractId: subId,
            customAttributesList: customAttributesList
        };
    }

    function updateOrderNoteAttributes() {
      if (_registeredListeners.has('updateOrderNoteAttributes')) return;
      _registeredListeners.add('updateOrderNoteAttributes');

      document.addEventListener('click', async function(event) {

        const packagingPopupWrap = document.querySelector('.delivery-recycle-pop-up.pickaging-set');
        const item = event.target.closest('.packaging-recycle');
        if (item) {
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const index = parseInt(item.getAttribute('data-index'), 10);
          const myValue = item.getAttribute('data-value');

          packagingPopupWrap.setAttribute('data-subscription-id', subscriptionId);
          packagingPopupWrap.setAttribute('data-index', index);
          const radios = packagingPopupWrap.querySelectorAll('input[name="packaging"]');
          if(myValue != ''){
            radios.forEach(radio => {
                if (radio.value === myValue) {
                    radio.checked = true;
                }
            });
          }else{
            radios.forEach(radio => {
                radio.checked = false;
            });
          }
        }

        const updateNoteBtn = event.target.closest('.update-order-note-btn');
        if (updateNoteBtn) {
          if(packagingPopupWrap.querySelector('input[name="packaging"]:checked') !== null){
            const subscriptionId = parseInt(packagingPopupWrap.getAttribute('data-subscription-id'), 10);
            const index = parseInt(packagingPopupWrap.getAttribute('data-index'), 10);
            const selectedRadio = packagingPopupWrap.querySelector('input[name="packaging"]:checked');
            if (selectedRadio) {
              const packagingValue = selectedRadio.value;
              const ATTR_KEY = "Packaging Preferences";
              const settingItem = document.querySelector('.packaging-recycle[data-subscription-id="' + subscriptionId + '"]');
              const settingItemText = settingItem?.querySelector('.setting-item__text p');
              const oldValue = settingItem ? settingItem.getAttribute('data-value') : null;
              const oldText = settingItemText ? settingItemText.textContent : null;

              // Optimistic UI: close popup + commit visible state instantly.
              // Lock the row so its arrow icon shows the loading spinner
              // while the background getContract + merge + POST runs.
              // Rollback on failure. (Appstle full-replaces customAttributes
              // on write, so merge base must be a server-truth snapshot.)
              packagingPopupWrap.classList.remove('is-active');
              packagingPopupWrap.querySelectorAll('input[name="packaging"]').forEach(radio => { radio.checked = false; });
              if (settingItem) settingItem.setAttribute('data-value', packagingValue);
              if (settingItemText) settingItemText.textContent = packagingValue;
              _lockSettingItem(settingItem);

              (async () => {
                let prevAttr = null;
                try {
                  const freshSub = await getContract(token, subscriptionId);
                  const oldNoteAttributes = freshSub?.customAttributes || [];
                  prevAttr = oldNoteAttributes.find(a => a.key === ATTR_KEY);
                  const newAttribute = { key: ATTR_KEY, value: packagingValue };
                  const orderNoteBody = mergeAttributes(oldNoteAttributes, newAttribute, subscriptionId);

                  if (_latestSubscriptions[index]) {
                    _latestSubscriptions[index].customAttributes = _mergeCustomAttrs(oldNoteAttributes, newAttribute);
                  }

                  await updateNoteAttributesApi(token, orderNoteBody);
                  _invalidateCache();
                } catch (error) {
                  console.error('packaging update error:', error);
                  if (settingItem && oldValue !== null) settingItem.setAttribute('data-value', oldValue);
                  if (settingItemText && oldText !== null) settingItemText.textContent = oldText;
                  if (_latestSubscriptions[index]) {
                    const current = _latestSubscriptions[index].customAttributes || [];
                    _latestSubscriptions[index].customAttributes = prevAttr
                      ? _mergeCustomAttrs(current, prevAttr)
                      : current.filter(a => a.key !== ATTR_KEY);
                  }
                  showToast("Failed to update packaging. Please try again.", 5000);
                } finally {
                  _unlockSettingItem(settingItem);
                }
              })();
            }
          }else{
            // no value
            showToast("Please choose your packaging preferences :)",5000);
          }
        }
      });

      document.addEventListener('click', async function(event) {
        const veganPopupWrap = document.querySelector('.delivery-recycle-pop-up.vegan-set');
        const item = event.target.closest('.vegan-recycle');
        if (item) {
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const index = parseInt(item.getAttribute('data-index'), 10);
          const myValue = item.getAttribute('data-value');

          veganPopupWrap.setAttribute('data-subscription-id', subscriptionId);
          veganPopupWrap.setAttribute('data-index', index);
          const radios = veganPopupWrap.querySelectorAll('input[name="vegan"]');
          // Clear every option on each open; legacy combined preferences cannot
          // safely distinguish vegetarian from vegan and require a new choice.
          const selectedValue = myValue === 'Okay with meat' ? 'No restrictions' : myValue;
          radios.forEach(radio => {
            radio.checked = radio.value === selectedValue;
          });
        }

        const updateNoteBtn = event.target.closest('.update-order-note-vegan-btn');
        if (updateNoteBtn) {
          if(veganPopupWrap.querySelector('input[name="vegan"]:checked') !== null){
            const subscriptionId = parseInt(veganPopupWrap.getAttribute('data-subscription-id'), 10);
            const index = parseInt(veganPopupWrap.getAttribute('data-index'), 10);
            const selectedRadio = veganPopupWrap.querySelector('input[name="vegan"]:checked');
            if (selectedRadio) {
              const veganValue = selectedRadio.value;
              const ATTR_KEY = "Dietary preferences";
              const LEGACY_ATTR_KEY = "Vegan or vegetarian?";
              const settingItem = document.querySelector('.vegan-recycle[data-subscription-id="' + subscriptionId + '"]');
              const settingItemText = settingItem?.querySelector('.setting-item__text p');
              const oldValue = settingItem ? settingItem.getAttribute('data-value') : null;
              const oldText = settingItemText ? settingItemText.textContent : null;

              // Optimistic UI: close popup + commit visible state instantly.
              veganPopupWrap.classList.remove('is-active');
              veganPopupWrap.querySelectorAll('input[name="vegan"]').forEach(radio => { radio.checked = false; });
              if (settingItem) settingItem.setAttribute('data-value', veganValue);
              if (settingItemText) settingItemText.textContent = veganValue;
              _lockSettingItem(settingItem);

              (async () => {
                let prevAttr = null;
                try {
                  const freshSub = await getContract(token, subscriptionId);
                  // Drop the legacy "Vegan or vegetarian?" attribute if it's
                  // still hanging around — the new value under "Dietary
                  // preferences" replaces it entirely.
                  const oldNoteAttributes = (freshSub?.customAttributes || [])
                                              .filter(a => a.key !== LEGACY_ATTR_KEY);
                  prevAttr = oldNoteAttributes.find(a => a.key === ATTR_KEY);
                  const newAttribute = { key: ATTR_KEY, value: veganValue };
                  const orderNoteBody = mergeAttributes(oldNoteAttributes, newAttribute, subscriptionId);

                  if (_latestSubscriptions[index]) {
                    _latestSubscriptions[index].customAttributes = _mergeCustomAttrs(oldNoteAttributes, newAttribute);
                  }

                  await updateNoteAttributesApi(token, orderNoteBody);
                  _invalidateCache();
                } catch (error) {
                  console.error('vegan update error:', error);
                  if (settingItem && oldValue !== null) settingItem.setAttribute('data-value', oldValue);
                  if (settingItemText && oldText !== null) settingItemText.textContent = oldText;
                  if (_latestSubscriptions[index]) {
                    const current = _latestSubscriptions[index].customAttributes || [];
                    _latestSubscriptions[index].customAttributes = prevAttr
                      ? _mergeCustomAttrs(current, prevAttr)
                      : current.filter(a => a.key !== ATTR_KEY);
                  }
                  showToast("Failed to update your option. Please try again.", 5000);
                } finally {
                  _unlockSettingItem(settingItem);
                }
              })();
            }
          }else{
            // no value
            showToast("Please choose your option :)",5000);
          }
        }

      });

      // ---- Household size settings item + popup ----
      // Match the other portal popups: lock page scroll while open.
      const _householdLockScroll = () => {
        if (window.lockScrollBar) window.lockScrollBar();
        document.body.classList.add('overflow-hidden--inside');
        document.documentElement.classList.add('overflow-hidden--inside');
      };
      const _householdUnlockScroll = () => {
        document.body.classList.remove('overflow-hidden--inside');
        document.documentElement.classList.remove('overflow-hidden--inside');
      };
      document.addEventListener('click', async function(event) {
        const householdPopupWrap = document.querySelector('.delivery-household-pop-up');
        if (!householdPopupWrap) return;

        const openItem = event.target.closest('.household-set');
        if (openItem) {
          const subscriptionId = parseInt(openItem.getAttribute('data-subscription-id'), 10);
          const index = parseInt(openItem.getAttribute('data-index'), 10);
          const currentValue = openItem.getAttribute('data-value') || '';
          householdPopupWrap.setAttribute('data-subscription-id', subscriptionId);
          householdPopupWrap.setAttribute('data-index', index);
          let curAdults = 0, curChildren = 0;
          const mA = currentValue.match(/(\d+)\s*adult/i);
          const mC = currentValue.match(/(\d+)\s*child/i);
          if (mA) curAdults = parseInt(mA[1], 10) || 0;
          if (mC) curChildren = parseInt(mC[1], 10) || 0;
          if (!currentValue) { curAdults = 1; curChildren = 0; }
          const adultsInput = householdPopupWrap.querySelector('.ff-qty[data-key="adults"] .ff-qty__value');
          const childrenInput = householdPopupWrap.querySelector('.ff-qty[data-key="children"] .ff-qty__value');
          // new-flow.js initCounters() owns these counters (it binds every .ff-qty on the
          // page and is loaded site-wide). Writing .value behind its back leaves the +/-
          // disabled states on the previous values; its own 'input' listener resyncs them.
          [[adultsInput, curAdults], [childrenInput, curChildren]].forEach(([el, v]) => {
            if (!el) return;
            el.value = String(v);
            el.dispatchEvent(new Event('input', { bubbles: true }));
          });
          householdPopupWrap.classList.add('is-active');
          _householdLockScroll();
        }

        const cancelBtn = event.target.closest('.delivery-household-pop-up .btn--cancel');
        if (cancelBtn) { householdPopupWrap.classList.remove('is-active'); _householdUnlockScroll(); }

        const confirmBtn = event.target.closest('.delivery-household-pop-up .btn--confirm');
        if (confirmBtn) {
          const subscriptionId = parseInt(householdPopupWrap.getAttribute('data-subscription-id'), 10);
          const index = parseInt(householdPopupWrap.getAttribute('data-index'), 10);
          const adultsInput = householdPopupWrap.querySelector('.ff-qty[data-key="adults"] .ff-qty__value');
          const childrenInput = householdPopupWrap.querySelector('.ff-qty[data-key="children"] .ff-qty__value');
          const adults = parseInt((adultsInput && adultsInput.value) || '0', 10) || 0;
          const children = parseInt((childrenInput && childrenInput.value) || '0', 10) || 0;
          if (adults + children === 0) {
            showToast("Add at least one adult or child :)", 5000);
            return;
          }
          const householdValue = adults + ' adult' + (adults === 1 ? '' : 's') +
                                 ', ' + children + ' child' + (children === 1 ? '' : 'ren');
          const ATTR_KEY = "Household size";
          const LEGACY_ATTR_KEY = "Household";
          const settingItem = document.querySelector('.household-set[data-subscription-id="' + subscriptionId + '"]');
          const settingItemText = settingItem?.querySelector('.setting-item__text p');
          const oldValue = settingItem ? settingItem.getAttribute('data-value') : null;
          const oldText = settingItemText ? settingItemText.textContent : null;

          householdPopupWrap.classList.remove('is-active');
          _householdUnlockScroll();
          if (settingItem) settingItem.setAttribute('data-value', householdValue);
          if (settingItemText) settingItemText.textContent = householdValue;
          _lockSettingItem(settingItem);

          (async () => {
            let prevAttr = null;
            try {
              const freshSub = await getContract(token, subscriptionId);
              const oldNoteAttributes = (freshSub?.customAttributes || [])
                                          .filter(a => a.key !== LEGACY_ATTR_KEY);
              prevAttr = oldNoteAttributes.find(a => a.key === ATTR_KEY);
              const newAttribute = { key: ATTR_KEY, value: householdValue };
              const orderNoteBody = mergeAttributes(oldNoteAttributes, newAttribute, subscriptionId);

              if (_latestSubscriptions[index]) {
                _latestSubscriptions[index].customAttributes = _mergeCustomAttrs(oldNoteAttributes, newAttribute);
              }

              await updateNoteAttributesApi(token, orderNoteBody);
              _invalidateCache();
            } catch (error) {
              console.error('household update error:', error);
              if (settingItem && oldValue !== null) settingItem.setAttribute('data-value', oldValue);
              if (settingItemText && oldText !== null) settingItemText.textContent = oldText;
              if (_latestSubscriptions[index]) {
                const current = _latestSubscriptions[index].customAttributes || [];
                _latestSubscriptions[index].customAttributes = prevAttr
                  ? _mergeCustomAttrs(current, prevAttr)
                  : current.filter(a => a.key !== ATTR_KEY);
              }
              showToast("Failed to update household size. Please try again.", 5000);
            } finally {
              _unlockSettingItem(settingItem);
            }
          })();
        }

        if (event.target.closest('.delivery-household-pop-up .icon-close')) {
          householdPopupWrap.classList.remove('is-active');
          _householdUnlockScroll();
        }
      });

    }

    function manageSubscription(subscriptions) {
      if (_registeredListeners.has('manageSubscription')) return; _registeredListeners.add('manageSubscription');
      document.addEventListener('click', async function(event) {
        const statusPopupWrap = document.querySelector('.delivery-manage-pop-up');
        const item = event.target.closest('.manage-subscription');
        if (item) {
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const index = parseInt(item.getAttribute('data-index'), 10);
          const billingWeekDay = parseInt(item.getAttribute('data-billing-week'), 10);
          const checkDay = parseInt(item.getAttribute('data-checkday'), 10);

          const preorderDate = item.getAttribute('data-pre-billing-date');
          statusPopupWrap.setAttribute('data-subscription-id', subscriptionId);
          statusPopupWrap.setAttribute('data-billing-week', billingWeekDay);
          statusPopupWrap.setAttribute('data-checkday', checkDay);

          statusPopupWrap.setAttribute('data-pre-billing-date', preorderDate);
          statusPopupWrap.setAttribute('data-index', index);

          // Restore cancel button visibility when opening manage popup normally
          const manageBtnCancel = statusPopupWrap.querySelector('.update-buttons .btn--cancel');
          if (manageBtnCancel) manageBtnCancel.classList.remove('is-hidden');
        }

        const pauseBtn = event.target.closest('.manage-pause-btn');
        if (pauseBtn) {
          const contentWrap = pauseBtn.closest('.pop-content-bottom');
          const selectDate = contentWrap.getAttribute('data-select-date') || '';
          if (selectDate === '') {
            showToast("Please select a date", 5000);
            return;
          }
          if (pauseBtn.dataset.pending === '1') return;
          const subscriptionId = parseInt(statusPopupWrap.getAttribute('data-subscription-id'), 10);
          const index = parseInt(statusPopupWrap.getAttribute('data-index'), 10);
          if (_pendingSubscriptions.has(subscriptionId)) {
            showToast("Please wait for the previous action to finish.", 3000);
            return;
          }
          const billingWeekDay = parseInt(statusPopupWrap.getAttribute('data-billing-week'), 10);
          const checkDay = parseInt(statusPopupWrap.getAttribute('data-checkday'), 10);
          const preorderDate = statusPopupWrap.getAttribute('data-pre-billing-date');
          const { date: newBillingDate } = getBillingDateFromDelivery(selectDate, billingWeekDay, checkDay);
          const formatedNewBillingDate = new Date(newBillingDate).toISOString().split('T')[0];
          const dateString = `${formatedNewBillingDate}T11:00:00Z`;

          const originalSub = _latestSubscriptions[index];
          const pauseNewAttrs = [
            { key: "Resume date", value: formatedNewBillingDate },
            { key: "Preorder date", value: preorderDate },
          ];
          const localAttrs = _mergeCustomAttrs(originalSub?.customAttributes, pauseNewAttrs);
          const localSub = { ...originalSub, customAttributes: localAttrs, nextBillingDate: dateString };

          // Appstle's note-attributes endpoint is full-replace, so the body
          // must be computed from the *freshest* server state — building it
          // upfront from the local cache silently drops any key that wasn't
          // in cache (see attribute-loss investigation). We defer the merge
          // into apiFactory so the optimistic UI flip stays instant while
          // the actual write uses up-to-date data.
          _runOptimisticAction({
            btn: pauseBtn,
            popupWrap: statusPopupWrap,
            subscriptionId,
            index,
            originalSub,
            localSub,
            apiFactory: async () => {
              const freshSub = await getContract(token, subscriptionId);
              const freshBody = mergeAttributes(
                freshSub?.customAttributes || [],
                pauseNewAttrs,
                subscriptionId
              );
              return Promise.all([
                updateNoteAttributesApi(token, freshBody),
                updateNextBillingDate(token, subscriptionId, dateString),
              ]);
            },
            successToast: "Subscription paused.",
            errorToast: "Failed to pause subscription. Please try again.",
          });
        }

        const cancelBtn = event.target.closest('.manage-cancel-btn');
        if (cancelBtn) {
          const subscriptionId = parseInt(statusPopupWrap.getAttribute('data-subscription-id'), 10);
          const index = parseInt(statusPopupWrap.getAttribute('data-index'), 10);
          const feedbackInput = statusPopupWrap.querySelector('.feedback-input');
          const reason = feedbackInput.value;
          if (reason == '') {
            feedbackInput.classList.add('error');
            return;
          }
          feedbackInput.classList.remove('error');
          feedbackInput.value = '';

          const originalSub = _latestSubscriptions[index];
          const localSub = { ...originalSub, status: 'CANCELLED' };
          _runOptimisticAction({
            btn: cancelBtn,
            popupWrap: statusPopupWrap,
            subscriptionId,
            index,
            originalSub,
            localSub,
            apiFactory: () => cancelCustomerSubsApi(token, subscriptionId, reason, 'User cancellation'),
            successToast: "Subscription cancelled.",
            errorToast: "Failed to cancel subscription. Please try again.",
            onPopupClose: () => {
              _closePopupNow(statusPopupWrap);
              // Manage popup has inner tabs that need their `.active` state
              // reset; _closePopupNow already handles that.
            },
          });
        }


      });
    }
    function resumeSubscription(subscriptions) {
      if (_registeredListeners.has('resumeSubscription')) return; _registeredListeners.add('resumeSubscription');
      document.addEventListener('click', async function(event) {
        const item = event.target.closest('.resume-subscription-true-btn');
        if (item) {
          const subscriptionId = parseInt(item.getAttribute('data-subscription-id'), 10);
          const index = parseInt(item.getAttribute('data-index'), 10);
          const originalSub = _latestSubscriptions[index];
          const localAttrs = (originalSub?.customAttributes || []).filter((a) => a.key !== 'Resume date');
          const localSub = { ...originalSub, status: 'ACTIVE', customAttributes: localAttrs };
          _runOptimisticAction({
            btn: item,
            popupWrap: null,
            subscriptionId,
            index,
            originalSub,
            localSub,
            apiFactory: () => updateCustomerStatusApi('ACTIVE', token, subscriptionId),
            successToast: "Subscription resumed.",
            errorToast: "Failed to resume subscription. Please try again.",
          });
        }

        const falseItem = event.target.closest('.resume-subscription-false-btn');
        if (falseItem) {
          const subscriptionId = parseInt(falseItem.getAttribute('data-subscription-id'), 10);
          const index = parseInt(falseItem.getAttribute('data-index'), 10);
          const selectDate = falseItem.getAttribute('data-next-date');
          const billingWeekDay = parseInt(falseItem.getAttribute('data-billing-week'), 10);
          const checkDay = parseInt(falseItem.getAttribute('data-checkday'), 10);
          const { date: newBillingDate } = getBillingDateFromDelivery(selectDate, billingWeekDay, checkDay);
          const formatedNewBillingDate = new Date(newBillingDate).toISOString().split('T')[0];
          const dateString = `${formatedNewBillingDate}T11:00:00Z`;

          const originalSub = _latestSubscriptions[index];
          const resumeNowNewAttr = { key: "Resume date", value: '' };
          const localAttrs = _mergeCustomAttrs(originalSub?.customAttributes, resumeNowNewAttr);
          const localSub = { ...originalSub, customAttributes: localAttrs, nextBillingDate: dateString };
          // Defer merge-and-post into apiFactory so the body is computed from
          // fresh server state; otherwise the full-replace API silently drops
          // any key not present in the local cache (see investigation).
          _runOptimisticAction({
            btn: falseItem,
            popupWrap: null,
            subscriptionId,
            index,
            originalSub,
            localSub,
            apiFactory: async () => {
              const freshSub = await getContract(token, subscriptionId);
              const freshBody = mergeAttributes(
                freshSub?.customAttributes || [],
                resumeNowNewAttr,
                subscriptionId
              );
              return Promise.all([
                updateNoteAttributesApi(token, freshBody),
                updateNextBillingDate(token, subscriptionId, dateString),
              ]);
            },
            successToast: "Resume date updated.",
            errorToast: "Failed to update resume date. Please try again.",
          });
        }
      });
    }
    function _refreshManageDate(subscriptionId, findIndex, checkDay) {
      return getContract(token, subscriptionId).then((subscription) => {
        if (!subscription || !subscription.nextBillingDate) return;
        const nextBillingDate = subscription.nextBillingDate;
        const { date: nextDate } = getDeliveryDate(findIndex, checkDay, nextBillingDate, false);
        orderNextDeliveryDate = nextDate;
        const formattedNextDeliveryDate = new Date(nextDate).toISOString().split('T')[0];
        const formattedNextBillingDate = new Date(nextBillingDate).toISOString().split('T')[0];
        const manageItem = document.querySelector('.setting-item.manage-subscription[data-subscription-id="' + subscriptionId + '"]');
        if (manageItem) {
          manageItem.setAttribute('data-pre-billing-date', formattedNextBillingDate);
          manageItem.setAttribute('data-delivery-date', formattedNextDeliveryDate);
        }
      }).catch((err) => { console.error('post-skip refresh error:', err); });
    }
    function _scheduleSkipRefresh(subscriptionId, findIndex, checkDay) {
      const prev = _skipRefreshTimers.get(subscriptionId);
      if (prev) clearTimeout(prev);
      const timerId = setTimeout(() => {
        _skipRefreshTimers.delete(subscriptionId);
        _invalidateCache();
        _refreshManageDate(subscriptionId, findIndex, checkDay);
      }, _SKIP_REFRESH_DEBOUNCE_MS);
      _skipRefreshTimers.set(subscriptionId, timerId);
    }
    function _applySkipUiFlip(btn, deliveryItem, targetSkipped) {
      if (targetSkipped) {
        deliveryItem.classList.add('unskip');
        btn.classList.remove('skip-btn');
        btn.classList.add('unskip-btn');
      } else {
        deliveryItem.classList.remove('unskip');
        btn.classList.remove('unskip-btn');
        btn.classList.add('skip-btn');
      }
      _recomputeNextUpcoming(deliveryItem.closest('.acct-subgroup') || deliveryItem.closest('.subscription-section'));
    }
    // Marks up to two earliest non-skipped, non-SUCCESS rows with
    //   .next-upcoming   (1st)  — also gates the .discount-note
    //   .next-upcoming-2 (2nd)
    // CSS uses these to toggle .delivery-details visibility so only the first
    // two visible upcoming deliveries show price + billing date, even after
    // the user skips/unskips upstream rows (e.g. skipping row 1 promotes rows
    // 2 & 3 to show details without any DOM replacement).
    function _recomputeNextUpcoming(section) {
      if (!section) return;
      const items = section.querySelectorAll('.delivery-item');
      const visible = [];
      for (const item of items) {
        if (item.classList.contains('unskip')) continue;
        if (item.classList.contains('success-upcoming-order')) continue;
        visible.push(item);
        if (visible.length >= 2) break;
      }
      items.forEach((item) => {
        const idx = visible.indexOf(item);
        item.classList.toggle('next-upcoming', idx === 0);
        item.classList.toggle('next-upcoming-2', idx === 1);
      });
    }
    function _handleSkipClick(btn) {
      // Silently ignore clicks during the 2s loading window on the same button.
      if (btn.classList.contains('loading')) return;

      const subscriptionId = parseInt(btn.getAttribute('data-subscription-id'), 10);
      const dataId = parseInt(btn.getAttribute('data-id'), 10);
      const findIndex = parseInt(btn.getAttribute('data-findindex'), 10);
      const checkDay = parseInt(btn.getAttribute('data-checkday'), 10);

      btn.classList.add('loading');

      let state = _orderSkipState.get(btn);
      if (!state) {
        const isCurrentlySkipped = btn.classList.contains('unskip-btn');
        state = {
          serverSkipped: isCurrentlySkipped,
          targetSkipped: !isCurrentlySkipped,
          version: 0,
          flipTimerId: null,
          inFlight: null,
          retryCount: 0,
          dataId,
          subscriptionId, findIndex, checkDay,
        };
        _orderSkipState.set(btn, state);
      } else {
        // Toggle target direction; API (if any) continues to completion
        // undisturbed — we'll reconcile after it returns.
        state.targetSkipped = !state.targetSkipped;
        state.retryCount = 0;
      }

      state.version += 1;
      const myVersion = state.version;
      if (state.flipTimerId) clearTimeout(state.flipTimerId);
      state.flipTimerId = setTimeout(() => _flipAndSync(btn, myVersion), _SKIP_UI_FLIP_DELAY_MS);

      // Fire API immediately so the request is in flight even if the user
      // navigates away before the UI flip timer runs. _syncToTarget is idempotent
      // (guards on state.inFlight), so the deferred _flipAndSync call is a no-op
      // for the API part — it still does the visual flip at t=500ms.
      _syncToTarget(btn);
    }
    function _flipAndSync(btn, version) {
      try {
        const state = _orderSkipState.get(btn);
        if (!state) return;
        if (state.version !== version) return;
        state.flipTimerId = null;

        const deliveryItem = btn.closest('.delivery-item');
        if (deliveryItem) {
          try { _applySkipUiFlip(btn, deliveryItem, state.targetSkipped); }
          catch (e) { console.error('_applySkipUiFlip failed:', e); }
        }

        _syncToTarget(btn);
      } finally {
        // 兜底清理 loading：state 已不存在 或 本次仍是最新版本时清。
        // 若已被新一轮点击递增 version，新点击负责清自己的 loading。
        // 这样 loading 与乐观 UI 同时在 t=2000ms 清除/应用，视觉节奏一致。
        const cur = _orderSkipState.get(btn);
        if (!cur || cur.version === version) {
          btn.classList.remove('loading');
        }
      }
    }
    function _syncToTarget(btn) {
      const state = _orderSkipState.get(btn);
      if (!state) return;
      // Target already reflects server → clean up when no pending flip.
      if (state.serverSkipped === state.targetSkipped) {
        if (state.flipTimerId === null && !state.inFlight) {
          _orderSkipState.delete(btn);
        }
        return;
      }
      // An API is already in flight — its completion will re-trigger sync.
      if (state.inFlight) return;

      const { dataId, subscriptionId, findIndex, checkDay } = state;
      const firing = state.targetSkipped;
      const apiCall = firing
        ? skipCurrentOrderApi(dataId, token, subscriptionId)
        : unSkipCurrentOrderApi(dataId, token, subscriptionId);
      state.inFlight = apiCall;

      apiCall
        .then(() => {
          if (state.inFlight !== apiCall) return;
          state.inFlight = null;
          state.serverSkipped = firing;
          state.retryCount = 0;
          _scheduleSkipRefresh(subscriptionId, findIndex, checkDay);
          _syncToTarget(btn);
        })
        .catch((error) => {
          if (state.inFlight !== apiCall) return;
          state.inFlight = null;
          console.error(
            (firing ? 'skipCurrentOrderApi' : 'unSkipCurrentOrderApi') + ' error:',
            error,
            { dataId, subscriptionId }
          );
          // 4xx responses (e.g. "Billing attempt does not exist") are deterministic;
          // retrying with the same stale ID just floods the console. Only retry on
          // network/5xx errors, where a transient failure may recover.
          const isClientError = /\bError 4\d\d\b/.test(error?.message || '');
          if (!isClientError && state.retryCount < _SKIP_MAX_RETRIES && state.serverSkipped !== state.targetSkipped) {
            state.retryCount += 1;
            setTimeout(() => _syncToTarget(btn), _SKIP_RETRY_DELAY_MS);
          } else {
            // Give up silently — the next page load will reconcile from the server.
            _orderSkipState.delete(btn);
          }
        });
    }
    function skipOrder() {
      if (_registeredListeners.has('skipOrder')) return; _registeredListeners.add('skipOrder');
      document.addEventListener('click', function(event) {
        const item = event.target.closest('.skip-btn');
        if (!item) return;
        _handleSkipClick(item);
      });
    }
    function unskipOrder() {
      if (_registeredListeners.has('unskipOrder')) return; _registeredListeners.add('unskipOrder');
      document.addEventListener('click', function(event) {
        const item = event.target.closest('.unskip-btn');
        if (!item) return;
        _handleSkipClick(item);
      });
    }
    // Renders the "Your Subscription" summary block on the Account
    // Overview tab. Selection preference:
    //   1. First ACTIVE regular subscription
    //   2. First paused (status="ACTIVE" with resumeDate, or "PAUSED")
    //   3. First CANCELLED
    //   4. None → hide the whole section
    // Active gets the prototype's Overview-only card (name + badge +
    // meta line + acct-thumbs strip + "Edit this box" button, no chips
    // and no settings/deliveries). Paused/cancelled reuse the same
    // article the Subscriptions tab renders — just without the outer
    // .acct-section__head that lists "Subscription N".
    async function overviewDeliveryDate(sub) {
      if (!sub.nextBillingDate) return '';
      const address = sub.deliveryMethod?.address || {};
      try {
        const zone = await findZoneData(address.city,address.provinceCode,address.zip);
        const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
        let delivery = days.findIndex(day=>zone?.day?.includes(day));
        let billing = days.findIndex(day=>zone?.day_2?.includes(day));
        let planned = null;
        try { planned = JSON.parse((sub.customAttributes || []).find(a=>a.key==='Scheduled address move')?.value || 'null'); } catch (_) {}
        if (planned) { delivery=days.indexOf(planned.deliveryDay); billing=days.indexOf(planned.billingDay); }
        if (delivery<0 || billing<0) return '';
        const firstOrder = false; // A scheduled bill is this cycle, even at the 9pm signup cutoff.
        const result = getDeliveryDate(delivery,billing,sub.nextBillingDate,planned ? false : firstOrder);
        return newFormatDateToDay(result.date);
      } catch (_) { return ''; }
    }
    let overviewRenderVersion = 0;
    async function renderOverviewSubscription(subscriptions, allContractDetails) {
      const renderVersion = ++overviewRenderVersion;
      const mount = document.querySelector('[data-your-subscription-mount]');
      if (!mount) return;
      const slot = mount.querySelector('[data-your-subscription-slot]');
      if (!slot) return;

      // "View All Subscriptions" button — reveal only when the customer
      // has more than one subscription (regardless of status), so a
      // customer with a single sub isn't shown a redundant link.
      const viewAll = mount.querySelector('[data-view-all-subs]');
      if (viewAll) {
        if (Array.isArray(subscriptions) && subscriptions.length > 1) viewAll.removeAttribute('hidden');
        else viewAll.setAttribute('hidden', '');
      }

      if (!Array.isArray(subscriptions) || subscriptions.length === 0) {
        mount.setAttribute('hidden', '');
        slot.innerHTML = '';
        return;
      }

      function isActiveRegular(sub) {
        if (sub.status !== 'ACTIVE') return false;
        const resumeDate = (sub.customAttributes || []).find(a => a.key === 'Resume date')?.value;
        if (!resumeDate) return true;
        const nb = sub.nextBillingDate;
        return nb && new Date(resumeDate).toDateString() === new Date(nb).toDateString() && new Date() > new Date(nb);
      }
      function isPaused(sub) {
        if (sub.status === 'PAUSED') return true;
        if (sub.status === 'ACTIVE') {
          const resumeDate = (sub.customAttributes || []).find(a => a.key === 'Resume date')?.value;
          if (resumeDate) {
            const nb = sub.nextBillingDate;
            if (!nb || !(new Date(resumeDate).toDateString() === new Date(nb).toDateString() && new Date() > new Date(nb))) {
              return true;
            }
          }
        }
        return false;
      }
      function isCancelled(sub) { return sub.status === 'CANCELLED'; }

      let chosenIdx = subscriptions.findIndex(isActiveRegular);
      if (chosenIdx === -1) chosenIdx = subscriptions.findIndex(isPaused);
      if (chosenIdx === -1) chosenIdx = subscriptions.findIndex(isCancelled);
      if (chosenIdx === -1) {
        mount.setAttribute('hidden', '');
        slot.innerHTML = '';
        return;
      }

      mount.removeAttribute('hidden');
      const sub = subscriptions[chosenIdx];
      const contract = (allContractDetails || [])[chosenIdx] || {};
      const subscriptionId = contract.subscriptionContractId
        || parseInt(String(sub?.id || '').split('/').pop(), 10);
      const subscriptionTitle = sub.deliveryMethod?.address?.address1 || 'Subscription';
      // Match Subscriptions-tab numbering (sorted by status asc, then id asc).
      // Using raw-array index would show #2 when the sub is actually #1 in the
      // sorted Subscriptions view — the tabs must agree.
      function _statusRank(s) {
        if (!s) return 5;
        if (s.status === 'CANCELLED') return 4;
        if (isPaused(s)) return 3;
        if (isActiveRegular(s)) return 1;
        return 2; // scheduled-to-resume etc.
      }
      const _ordered = (subscriptions || [])
        .map(function (s, i) { return { s: s, id: parseInt(String(s?.id || '').split('/').pop(), 10), i: i }; })
        .sort(function (a, b) {
          var d = _statusRank(a.s) - _statusRank(b.s);
          if (d !== 0) return d;
          return a.id - b.id;
        });
      const _sortedPos = _ordered.findIndex(function (o) { return o.i === chosenIdx; });
      const num = (_sortedPos === -1 ? chosenIdx : _sortedPos) + 1;

      if (isActiveRegular(sub)) {
        // Overview-specific compact ACTIVE card.
        // Prefer the contract-level contractAmount (same field the
        // Subscriptions tab + Order History use). Sub with discount can
        // return null currentPrice, which made the previous line-sum
        // fallback drop to 0 and hide the price line.
        var _contractAmount = allContractDetails && allContractDetails[chosenIdx] && allContractDetails[chosenIdx].contractAmount;
        var amount;
        if (_contractAmount != null && !isNaN(parseFloat(_contractAmount))) {
          amount = Number(_contractAmount).toFixed(2);
        } else {
          var linesTotal = (sub.lines && sub.lines.nodes || []).reduce(function (s, n) {
            if (n.lineDiscountedPrice && n.lineDiscountedPrice.amount != null) return s + parseFloat(n.lineDiscountedPrice.amount);
            return s + parseFloat((n.currentPrice && n.currentPrice.amount) || 0) * (n.quantity || 1);
          }, 0);
          amount = linesTotal.toFixed(2);
        }
        const intervalCount = sub.deliveryPolicy?.intervalCount;
        const planName = intervalCount === 1 ? 'Weekly' : intervalCount === 2 ? 'Fortnightly' : intervalCount === 4 ? 'Monthly' : '';
        const nextDelivery = await overviewDeliveryDate(sub);
        if (renderVersion !== overviewRenderVersion) return;
        const items = sub.lines?.nodes || [];
        let slidesHTML = '';
        items.forEach(function (it) {
          const img = it.variantImage?.url ?? it.variantImage?.transformedSrc ?? '';
          if (!img) return;
          const title = it.title || '';
          slidesHTML +=
            '<div class="swiper-slide acct-thumb"><div class="img"><img src="' + img + '" alt="' + title + '"/></div></div>';
        });

        const metaBits = [];
        if (nextDelivery) metaBits.push('Next delivery <span class="acct-sub__date">' + nextDelivery + '</span>');
        if (planName) metaBits.push(planName);
        if (amount != null && !isNaN(parseFloat(amount))) metaBits.push(parseFloat(amount) === 0 ? 'Free order' : '$' + amount);

        slot.innerHTML =
          '<article class="subscription-section acct-card acct-sub" data-subscription-id="' + subscriptionId + '">' +
            '<div class="subscription-header acct-sub__head">' +
              '<div class="acct-sub__title">' +
                '<h3 class="acct-sub__name">' + subscriptionTitle + ' 📦 #' + num + '</h3>' +
                '<span class="acct-badge acct-badge--active">Active</span>' +
              '</div>' +
              (metaBits.length ? '<p class="acct-sub__meta">' + metaBits.join(' • ') + '</p>' : '') +
            '</div>' +
            '<div class="subscription-contents__slider acct-thumbs">' +
              '<div class="swiper-wrapper">' + slidesHTML + '</div>' +
            '</div>' +
            '<button class="btn acct-btn acct-btn--primary acct-btn--block edit-subscription-btn" type="button" data-subscription-id="' + subscriptionId + '"><span>Edit this box</span></button>' +
          '</article>';
      } else {
        // Paused / active-with-resume / cancelled — reuse the exact HTML the
        // Subscriptions tab uses, then strip the outer .acct-section__head
        // (which would show "Subscription N" — Overview already has its
        // own "Your Subscription" heading above).
        (async function () {
          const upcoming = (typeof _latestUpcoming !== 'undefined' && _latestUpcoming[chosenIdx]) || [];
          const history = (typeof _latestHistory !== 'undefined' && _latestHistory[chosenIdx]) || [];
          const html = await updateSubscriptionUI(sub, upcoming, history, false, chosenIdx, undefined, num, allContractDetails);
          if (typeof html !== 'string' || !html) return;
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const wrapper = temp.firstElementChild;
          if (!wrapper) return;
          const innerHead = wrapper.querySelector('.acct-section__head');
          if (innerHead) innerHead.remove();
          slot.innerHTML = wrapper.innerHTML;
        })();
      }
    }

    // Renders the Order History tab: one .acct-section--split block per
    // subscription, each with a list of past orders. Clicking an order
    // re-uses the existing order-history-pop-up popup (getHistoryData
    // click handler matches .order-history-item, so we tag each li
    // with both .acct-order and .order-history-item).
    async function renderOrderHistoryTab(subscriptions, allHistory, allContractDetails) {
      const panel = document.querySelector('.acct-panel[data-panel="orders"]');
      if (!panel) return;

      const version = ++_historyRenderVersion;
      const zones = await Promise.all(subscriptions.map(async sub => {
        const address = sub.deliveryMethod?.address;
        try { return await findZoneData(address?.city, address?.provinceCode, address?.zip); }
        catch (_) { return null; }
      }));
      if (version !== _historyRenderVersion) return;

      // Remove any previously-rendered order blocks + prototype static ones,
      // preserving the Add Another button.
      Array.from(panel.querySelectorAll(':scope > .acct-section, :scope > [data-order-mount]')).forEach(function (el) { el.remove(); });
      const addBtn = panel.querySelector('.acct-btn--add');

      function labelForStatus(status) {
        if (status === 'SUCCESS') return 'Paid';
        if (status === 'SKIPPED') return 'Skipped';
        if (status === 'CONTRACT_PAUSED') return 'Contract Paused';
        if (status === 'FAILED') return 'Failed';
        return status || '';
      }

      let anyRendered = false;
      subscriptions.forEach(function (sub, idx) {
        const orders = (allHistory && allHistory[idx]) || [];
        if (!orders.length) return;
        anyRendered = true;
        const displayNum = idx + 1;

        const contractAmount = allContractDetails?.[idx]?.contractAmount;
        const amount = contractAmount ? Number(contractAmount).toFixed(2) : null;

        // Zone lookup has completed; use the same calculation as the subscription card.
        const ordersHTML = orders.map(function (order, oi) {
          const orderId = order.orderId;
          const deliveryLabel = historyDeliveryLabel(zones[idx], order, sub);
          const statusLabel = labelForStatus(order.status);
          const amt = amount ? ('$' + amount) : '';
          const parts = ['Variety Box'];
          if (amt) parts.push(amt);
          if (statusLabel) parts.push(statusLabel);
          const meta = parts.join(' • ');
          // Rows without a real Shopify order (SKIPPED / CONTRACT_PAUSED
          // / FAILED / missing orderId) are marked .disabled so the popup
          // handler bails out.
          const _nonClickable = !orderId || order.status === 'SKIPPED' || order.status === 'CONTRACT_PAUSED' || order.status === 'FAILED';
          return (
            '<li class="acct-order order-history-item' + (_nonClickable ? ' disabled' : '') + '"' +
            ' data-id="' + (orderId || '') + '"' +
            ' data-index="' + idx + '">' +
              '<div class="acct-order__desc">' +
                '<h3 class="acct-order__title">' + deliveryLabel + '</h3>' +
                '<p class="acct-order__meta">' + meta + '</p>' +
              '</div>' +
              '<svg class="acct-chev" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
                '<path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</li>'
          );
        }).join('');

        const seeMoreHTML = orders.length > 4
          ? '<div class="acct-seemore-wrap"><button class="acct-seemore" type="button">See More</button></div>'
          : '';

        const sectionHTML =
          '<div class="acct-section acct-section--split" data-subscription-id="' + (allContractDetails?.[idx]?.subscriptionContractId || '') + '">' +
            '<div class="acct-group">' +
              '<h2 class="acct-section__title acct-section__title--lg">' +
                '<span class="acct-lg-only">Subscription ' + displayNum + '</span>' +
                '<span class="acct-sm-only">Order History</span>' +
              '</h2>' +
              '<div class="acct-card acct-orders">' +
                '<ul class="acct-orders__list">' + ordersHTML + '</ul>' +
              '</div>' +
            '</div>' +
            seeMoreHTML +
          '</div>';

        if (addBtn) addBtn.insertAdjacentHTML('beforebegin', sectionHTML);
        else panel.insertAdjacentHTML('beforeend', sectionHTML);
      });

      if (!anyRendered) {
        const empty = '<p class="acct-note" data-order-mount>No past orders yet.</p>';
        if (addBtn) addBtn.insertAdjacentHTML('beforebegin', empty);
        else panel.insertAdjacentHTML('beforeend', empty);
      }

      // See More is the live ShowMore (script.js), wired here because the rows land
      // asynchronously - showPanel() has usually already run by the time they exist.
      if (typeof window.__acctInitShowMore === 'function') {
        window.__acctInitShowMore(panel);
      }
    }

    function getHistoryData(history,allContractDetails,subscriptions) {
      _latestSubscriptions = subscriptions;
      // Prefetch per-order Supabase final_items + items-map now so the
      // order-history popup renders sub-items instantly on click instead
      // of waiting on network round-trips after the user interacts.
      (function prefetchOrderBoxes() {
        if (!window.__ffOrderBoxCache) window.__ffOrderBoxCache = {};
        if (!window.__ffItemsMapPromise) {
          var _imUrl = (window.__ffDataUrls && window.__ffDataUrls.itemsMap) ||
            'https://funkyfood-public-data.janfemac1122.workers.dev/items-map/';
          window.__ffItemsMapPromise = fetch(_imUrl, { credentials: 'omit' })
            .then(function (r) { return r.ok ? r.json() : {}; })
            .catch(function () { return {}; });
        }
        var tasks = [];
        (history || []).forEach(function (orders, idx) {
          if (!Array.isArray(orders) || !orders.length) return;
          var contract = allContractDetails && allContractDetails[idx];
          var contractId = contract && contract.subscriptionContractId;
          if (!contractId) return;
          var orderIds = orders.map(function (o) { return o && o.orderId; }).filter(Boolean);
          if (!orderIds.length) return;
          var url = _FF_SB_URL + '/rest/v1/customer_boxes'
            + '?shopify_contract_id=eq.' + encodeURIComponent(contractId)
            + '&shopify_order_id=in.(' + orderIds.join(',') + ')'
            + '&select=shopify_order_id,final_items';
          tasks.push(fetch(url, {
            headers: { apikey: _FF_SB_ANON, Authorization: 'Bearer ' + _FF_SB_ANON, Accept: 'application/json' }
          }).then(function (r) { return r.ok ? r.json() : []; })
            .then(function (rows) {
              rows.forEach(function (row) {
                window.__ffOrderBoxCache[row.shopify_order_id] = row.final_items || [];
              });
            })
            .catch(function () {}));
        });
        window.__ffOrderBoxCachePromise = Promise.all(tasks);
      })();
      // Prefetch per-order totals (subtotal/shipping/total) + lineItems from
      // the Worker so the popup's totals render instantly instead of
      // spinning for the round-trip after the user clicks. Stores promises
      // keyed by orderId in window.__ffOrderDetailCache so the click
      // handler can await if the request is still in flight.
      (function prefetchOrderDetails() {
        if (!window.__ffOrderDetailCache) window.__ffOrderDetailCache = {};
        var WORKER_URL = (window.themeApiConfig && window.themeApiConfig.workerUrl)
          || 'https://funkyfood-subscription-worker.janfemac1122.workers.dev';
        (history || []).forEach(function (orders, idx) {
          if (!Array.isArray(orders) || !orders.length) return;
          var contract = allContractDetails && allContractDetails[idx];
          var contractId = contract && contract.subscriptionContractId;
          if (!contractId) return;
          orders.forEach(function (o) {
            if (!o || !o.orderId) return;
            if (window.__ffOrderDetailCache[o.orderId]) return; // already prefetched
            var url = WORKER_URL + '/api/order/' + o.orderId
              + '?contractId=' + encodeURIComponent(contractId)
              + '&token=' + encodeURIComponent(token);
            window.__ffOrderDetailCache[o.orderId] = fetch(url, { method: 'GET' })
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          });
        });
      })();
      if (_registeredListeners.has('getHistoryData')) return; _registeredListeners.add('getHistoryData');
      document.addEventListener('click', async function(event) {
          const item = event.target.closest('.order-history-item');
          if (!item || item.classList.contains('disabled')) return;

          const dataId = parseInt(item.getAttribute('data-id'), 10);
          const dataIndex = parseInt(item.getAttribute('data-index'), 10);
          // Two markups carry .order-history-item: the subscription card's rows put the date in
          // .delivery-date, the Order History tab's rows in .acct-order__title. Reading only the
          // first threw on the tab's rows, and this handler is async — the rejection was silent,
          // so the popup simply never opened.
          const dateEl = item.querySelector('.delivery-date, .acct-order__title');
          const date = dateEl ? dateEl.textContent.trim() : '';

          const subscription = _latestSubscriptions && _latestSubscriptions[dataIndex];
          const contract = allContractDetails && allContractDetails[dataIndex];
          const subscriptionDeliveryPrice = parseFloat(subscription?.deliveryPrice?.amount || 0);
          const orders = (history && history[dataIndex]) || [];
          const order = orders.find(o => Number(o?.orderId) === dataId) || {};

          const historyWrap = document.querySelector('.order-history-pop-up');
          if (!historyWrap) return;
          // This handler only fills the popup. Opening it is script.js's job (manageAccount,
          // 2957), but that binds per item under `.order-history__items` — the Order History
          // tab's rows sit in `.acct-orders__list`, so nothing ever opened it there. Adding the
          // class here covers both markups; on the subscription card it is a no-op re-add.
          historyWrap.classList.add('is-active');

          // selfBlur's updateScrollLock already ran on this click - body bubbles before
          // document, and the popup was still shut - so it cleared the lock. Re-take it.
          if (window.lockScrollBar) window.lockScrollBar();
          document.body.classList.add('overflow-hidden--inside');
          document.documentElement.classList.add('overflow-hidden--inside');

          // Render an immediate placeholder using the (incomplete) Appstle data
          // so the popup opens instantly. Real values come from the Worker
          // below — Appstle's `orderAmount` excludes one-time line items,
          // which makes its total massively under-report orders that mix
          // subscribed + one-off products.
          const placeholderProducts = (order?.variantList || []).map(p => `
            <div class="order-list">
              <div class="order-list__image"><img src="${p.image}" alt="${p.title}"></div>
              <div class="order-list__title"><h4>${p.title}</h4></div>
              <div class="order-list__qty"><span class="qty">Qty ${p.quantity}</span></div>
            </div>
          `).join('');
          historyWrap.querySelector('.order-lists').innerHTML = placeholderProducts;
          historyWrap.querySelector('.history-pop-up-deliveryday').textContent = date;
          historyWrap.querySelector('.subtotal-val').textContent = '…';
          historyWrap.querySelector('.delivery-val').textContent = '…';
          historyWrap.querySelector('.total-val').textContent = '…';

          // Renders customer_boxes.final_items under the box line item.
          // Idempotent: strips any previous .order-list__box-items right
          // before insert so concurrent calls (placeholder + Worker
          // refresh) don't double-insert.
          async function _injectBoxItems() {
            try {
              if (window.__ffOrderBoxCachePromise) {
                try { await window.__ffOrderBoxCachePromise; } catch (e) {}
              }
              let finalItems = (window.__ffOrderBoxCache && window.__ffOrderBoxCache[order.orderId]) || null;
              if (finalItems == null && contract?.subscriptionContractId) {
                const bxUrl = _FF_SB_URL + '/rest/v1/customer_boxes'
                  + '?shopify_contract_id=eq.' + encodeURIComponent(contract.subscriptionContractId)
                  + '&shopify_order_id=eq.' + encodeURIComponent(order.orderId)
                  + '&select=final_items&limit=1';
                const bxRes = await fetch(bxUrl, {
                  headers: { apikey: _FF_SB_ANON, Authorization: 'Bearer ' + _FF_SB_ANON, Accept: 'application/json' }
                });
                const bxRows = bxRes.ok ? await bxRes.json() : [];
                finalItems = (bxRows[0] && bxRows[0].final_items) || [];
                if (window.__ffOrderBoxCache) window.__ffOrderBoxCache[order.orderId] = finalItems;
              }
              if (!finalItems || !finalItems.length) return;
              const itemsMap = (window.__ffItemsMapPromise ? (await window.__ffItemsMapPromise).items : {}) || {};
              const subList = finalItems.map(function (fi) {
                const img = (fi.funky_item_id && itemsMap[fi.funky_item_id]) || '';
                const name = String(fi.item_name || '').replace(/[<>&"']/g, function (c) {
                  return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' }[c];
                });
                return '<div class="order-list order-list--box-item">'
                  + '<div class="order-list__image">' + (img ? '<img src="' + img + '" alt="' + name + '">' : '') + '</div>'
                  + '<div class="order-list__title"><h4>' + name + '</h4></div>'
                  + '</div>';
              }).join('');
              const rows = Array.from(historyWrap.querySelectorAll('.order-lists > .order-list'));
              // Prefer the veg-box row (any title containing "box" that
              // ISN'T a meat/beef box). Only fall back to any box row if
              // there's no veg-box line in the order. Prior behaviour
              // matched the first /box/i and misplaced the sub-items list
              // under a Beef Only Box when it appeared before the veg box.
              const _titleOf = function (el) {
                return (el.querySelector('.order-list__title') || {}).textContent || '';
              };
              let boxRow = rows.find(function (el) {
                const t = _titleOf(el);
                return /box/i.test(t) && !/beef|meat/i.test(t);
              });
              if (!boxRow) boxRow = rows.find(function (el) { return /box/i.test(_titleOf(el)); });
              // Strip any existing box-items right before insert (moved
              // from function start) — this closes the race window where a
              // concurrent placeholder + Worker-refresh call could both
              // insert and produce two lists side by side.
              historyWrap.querySelectorAll('.order-list__box-items').forEach(function (n) { n.remove(); });
              const wrap = '<div class="order-list__box-items"><h5 class="order-list__box-items-title">Including:</h5>' + subList + '</div>';
              (boxRow || historyWrap.querySelector('.order-lists')).insertAdjacentHTML(boxRow ? 'afterend' : 'beforeend', wrap);
            } catch (e) { console.warn('order box enrichment failed:', e); }
          }
          // First injection uses the placeholder rows — appears immediately
          // from cache, doesn't wait for the Worker round-trip.
          _injectBoxItems();

          // Fetch the real Shopify order via Worker (correct totals + per-line prices).
          if (!order?.orderId || !contract?.subscriptionContractId) return;
          const WORKER_URL = window.themeApiConfig?.workerUrl
            || 'https://funkyfood-subscription-worker.janfemac1122.workers.dev';
          const url = `${WORKER_URL}/api/order/${order.orderId}`
            + `?contractId=${encodeURIComponent(contract.subscriptionContractId)}`
            + `&token=${encodeURIComponent(token)}`;
          try {
            // Prefer the prefetch cache populated in getHistoryData. Awaiting
            // an already-resolved promise is synchronous-fast; if the
            // prefetch is still in flight the popup will wait for it (still
            // faster than starting fresh here).
            let d;
            if (window.__ffOrderDetailCache && window.__ffOrderDetailCache[order.orderId]) {
              d = await window.__ffOrderDetailCache[order.orderId];
            }
            if (!d) {
              const r = await fetch(url, { method: 'GET' });
              if (!r.ok) throw new Error(`Worker ${r.status}`);
              d = await r.json();
              if (window.__ffOrderDetailCache) window.__ffOrderDetailCache[order.orderId] = Promise.resolve(d);
            }

            // Re-render product list with real Shopify line items (so the
            // popup includes one-off products that Appstle omits).
            const lines = (d.lineItems || []).map(li => {
              const variantInfo = (order?.variantList || []).find(v => Number(v.variantId) === Number(li.variantId));
              const img = variantInfo?.image || '';
              return `
                <div class="order-list">
                  <div class="order-list__image">${img ? `<img src="${img}" alt="${li.title}">` : ''}</div>
                  <div class="order-list__title"><h4>${li.title}</h4></div>
                  <div class="order-list__qty"><span class="qty">Qty ${li.quantity}</span></div>
                </div>
              `;
            }).join('');
            if (lines) historyWrap.querySelector('.order-lists').innerHTML = lines;

            // Re-inject box items — Worker's innerHTML replace wiped the
            // sub-list the first _injectBoxItems() call attached.
            _injectBoxItems();

            historyWrap.querySelector('.subtotal-val').textContent = `$${d.subtotal.toFixed(2)}`;
            historyWrap.querySelector('.delivery-val').textContent = `$${d.shipping.toFixed(2)}`;
            historyWrap.querySelector('.total-val').textContent = `$${d.total.toFixed(2)}`;
            historyWrap.querySelector('.history-pop-up-deliveryday').textContent = `${date} $${d.total.toFixed(2)}`;
          } catch (err) {
            console.error('Order detail fetch failed, falling back to Appstle data:', err);
            // Fall back to Appstle's (incomplete) data so the popup isn't blank.
            const orderTotal = (order.orderAmount || 0).toFixed(2);
            const orderSubtotal = ((order.orderAmount || 0) - subscriptionDeliveryPrice).toFixed(2);
            historyWrap.querySelector('.subtotal-val').textContent = `$${orderSubtotal}`;
            historyWrap.querySelector('.delivery-val').textContent = `$${subscriptionDeliveryPrice.toFixed(2)}`;
            historyWrap.querySelector('.total-val').textContent = `$${orderTotal}`;
            historyWrap.querySelector('.history-pop-up-deliveryday').textContent = `${date} $${orderTotal}`;
          }
      });
    }
    function isDateAfterToday(isoDateString) {
        const inputDate = new Date(isoDateString);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return inputDate > today;
    }
    function formatCurrency(amount, currencyCode) {
      const numericAmount = parseFloat(amount);
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numericAmount);
    }

function moveItemsBetweenArrays(historyArray, upcomingArray) {
    // Once an order is skipped, Appstle drops it from top-orders (upcoming)
    // and returns it under past-orders (history) with status=SKIPPED. Since
    // the history render doesn't emit an unskip button, the customer loses
    // the ability to recover the skip after a page refresh. Rescue any
    // SKIPPED past-orders whose billingDate is still in the future by
    // moving them back into the upcoming array so the normal skip/unskip
    // toggle re-appears.
    const nowUTC = new Date();
    const rescued = [];
    const keptHistory = [];
    (historyArray || []).forEach(function (item) {
        if (!item || item.status !== 'SKIPPED' || !item.billingDate) {
            keptHistory.push(item);
            return;
        }
        const bd = new Date(item.billingDate);
        if (!isNaN(bd.getTime()) && bd > nowUTC) rescued.push(item);
        else keptHistory.push(item);
    });
    const upcomingIds = new Set((upcomingArray || []).map(function (i) { return i && i.id; }));
    const merged = (upcomingArray || []).slice();
    rescued.forEach(function (r) { if (!upcomingIds.has(r.id)) merged.push(r); });
    merged.sort(function (a, b) {
        const da = new Date(a && a.billingDate || 0).getTime();
        const db = new Date(b && b.billingDate || 0).getTime();
        return da - db;
    });
    return { updatedHistory: keptHistory, updatedUpcoming: merged };
}
function moveItemsBetweenArrays_legacy(historyArray, upcomingArray) {
    const nowUTC = new Date(); // Use current UTC time

    // Arrays to track items that need to be moved
    const itemsToMoveToUpcoming = [];
    const remainingHistoryItems = [];

    for (const item of historyArray) {
        if (!item.billingDate) {
            remainingHistoryItems.push(item);
        } else {
            const billingDate = new Date(item.billingDate);
            if (isNaN(billingDate.getTime())) {
                remainingHistoryItems.push(item);
            } else if (billingDate > nowUTC) {
                itemsToMoveToUpcoming.push(item);
            } else {
                remainingHistoryItems.push(item);
            }
        }
    }

    const itemsToMoveToHistory = [];
    const remainingUpcomingItems = [];

    for (const item of upcomingArray) {
        if (!item.billingDate) {
            remainingUpcomingItems.push(item);
        } else {
            const billingDate = new Date(item.billingDate);
            if (isNaN(billingDate.getTime())) {
                remainingUpcomingItems.push(item);
            } else if (billingDate <= nowUTC) {
                itemsToMoveToHistory.push(item);
            } else {
                remainingUpcomingItems.push(item);
            }
        }
    }

    // Use Sets for O(1) lookup to optimize performance
    const upcomingIds = new Set(remainingUpcomingItems.map(item => item.id));
    const historyIds = new Set(remainingHistoryItems.map(item => item.id));

    // Filter items to move to upcoming (avoid duplicates)
    const itemsToActuallyMoveToUpcoming = itemsToMoveToUpcoming.filter(item => {
        if (upcomingIds.has(item.id)) {
            return false;
        }
        return true;
    });

    // Add items to the beginning of upcoming array (maintain chronological order)
    if (itemsToActuallyMoveToUpcoming.length > 0) {
        remainingUpcomingItems.unshift(...itemsToActuallyMoveToUpcoming);
    }

    // Filter items to move to history (avoid duplicates)
    const itemsToActuallyMoveToHistory = itemsToMoveToHistory.filter(item => {
        if (historyIds.has(item.id)) {
            return false;
        }
        return true;
    });

    // Add items to the end of history array
    if (itemsToActuallyMoveToHistory.length > 0) {
        remainingHistoryItems.push(...itemsToActuallyMoveToHistory);
    }

    // Update original arrays (mutates input arrays)
    historyArray.length = 0;
    historyArray.push(...remainingHistoryItems);

    upcomingArray.length = 0;
    upcomingArray.push(...remainingUpcomingItems);

    // Return comprehensive result object
    return {
        updatedHistory: [...historyArray],
        updatedUpcoming: [...upcomingArray],
        movedToUpcoming: itemsToMoveToUpcoming,
        movedToHistory: itemsToMoveToHistory,
        actuallyMovedToUpcoming: itemsToActuallyMoveToUpcoming,
        actuallyMovedToHistory: itemsToActuallyMoveToHistory
    };
}

    function getTargetDate(targetDateStr) {
        const targetDate = new Date(targetDateStr);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        return today >= targetDate 
            ? new Date(targetDate.setDate(targetDate.getDate() + 7)).toISOString().split('T')[0]
            : targetDateStr;
    }
    function getDiscountAmount(discount, currentPrice) {
      if (!discount || !discount.value) return 0;

      const value = discount.value;

      if (value.__typename === "SubscriptionDiscountFixedAmountValue") {
        return parseFloat(value.amount?.amount) || 0;
      }

      if (value.__typename === "SubscriptionDiscountPercentageValue") {
        const percentage = parseFloat(value.percentage) || 0;
        const price = parseFloat(currentPrice) || 0;

        if (percentage >= 100) {
          return price;
        }

        return price * (percentage / 100);
      }

      return 0;
    }

    // === Cancel Subscription Flow (multi-step retention funnel) ===
    function initCancelSubscriptionFlow() {
      if (!document.querySelector('.cancel-subscription-pop-up')) return;

      const bodyEle = document.body;
      const htmlEle = document.documentElement;

      const cancelPopupSelectors = [
        '.cancel-subscription-pop-up',
        '.cancel-subscription-holidays-pop-up',
        '.cancel-subscription-expensive-pop-up',
        '.cancel-subscription-size-pop-up',
        '.cancel-subscription-discount-pop-up',
        '.cancel-subscription-malfunction-pop-up',
        '.cancel-subscription-discontent-pop-up',
        '.cancel-subscription-discontent-feedback-pop-up',
        '.cancel-subscription-other-pop-up'
      ];

      const reasonPopupMap = {
        'holidays': '.cancel-subscription-holidays-pop-up',
        'expensive': '.cancel-subscription-expensive-pop-up',
        'size': '.cancel-subscription-size-pop-up',
        'malfunction': '.cancel-subscription-malfunction-pop-up',
        'discontent': '.cancel-subscription-discontent-pop-up',
        'other': '.cancel-subscription-discontent-feedback-pop-up'
      };

      const reasonLabelMap = {
        'holidays': 'Going away or on holiday',
        'expensive': 'Too expensive right now',
        'size': 'Box size not right',
        'malfunction': 'Delivery timing does not work',
        'discontent': 'Did not love the last box',
        'other': 'Other'
      };

      let selectedCancelReason = 'Other';

      function openCancelPopup(selector) {
        const el = document.querySelector(selector);
        if (!el) return;
        if (window.lockScrollBar) window.lockScrollBar();
        el.classList.add('is-active');
        bodyEle.classList.add('overflow-hidden--inside');
        htmlEle.classList.add('overflow-hidden--inside');
      }

      function closeCancelPopup(selector) {
        const el = document.querySelector(selector);
        if (!el) return;
        el.classList.remove('is-active');
      }

      function switchCancelPopup(fromSelector, toSelector) {
        const fromEl = document.querySelector(fromSelector);
        const toEl = document.querySelector(toSelector);
        if (!fromEl || !toEl) return;
        fromEl.classList.add('no-transition');
        toEl.classList.add('no-transition');
        fromEl.classList.remove('is-active');
        toEl.classList.add('is-active');
        void toEl.offsetHeight;
        fromEl.classList.remove('no-transition');
        toEl.classList.remove('no-transition');
      }

      function resetCancelFormStates() {
        selectedCancelReason = 'Other';
        var cancelPopup = document.querySelector('.cancel-subscription-pop-up');
        if (cancelPopup) {
          cancelPopup.querySelectorAll('input[name="cancel-reason"]').forEach(function(r) {
            r.checked = false;
          });
        }
        document.querySelectorAll('.cancel-feedback-textarea').forEach(function(ta) {
          ta.value = '';
          ta.classList.remove('error');
        });
        document.querySelectorAll('.cancel-feedback-input .words-limit .current').forEach(function(el) {
          el.textContent = '0';
        });
      }

      function closeAllCancelPopups() {
        cancelPopupSelectors.forEach(function(sel) {
          closeCancelPopup(sel);
        });
        closeCancelPopup('.delivery-manage-pop-up');
        resetCancelFormStates();
        bodyEle.classList.remove('overflow-hidden--inside');
        htmlEle.classList.remove('overflow-hidden--inside');
      }

      function closeSingleCancelPopup(selector) {
        closeCancelPopup(selector);
        var anyActive = cancelPopupSelectors.some(function(sel) {
          var el = document.querySelector(sel);
          return el && el.classList.contains('is-active');
        });
        var manageActive = document.querySelector('.delivery-manage-pop-up.is-active');
        if (!anyActive && !manageActive) {
          resetCancelFormStates();
          bodyEle.classList.remove('overflow-hidden--inside');
          htmlEle.classList.remove('overflow-hidden--inside');
        }
      }

      function openManageWithoutCancel() {
        const activeCancel = cancelPopupSelectors.find(function(sel) {
          const el = document.querySelector(sel);
          return el && el.classList.contains('is-active');
        });
        if (activeCancel) {
          cancelPopupSelectors.forEach(function(sel) {
            if (sel !== activeCancel) closeCancelPopup(sel);
          });
          const manageBtnCancel = document.querySelector('.delivery-manage-pop-up .update-buttons .btn--cancel');
          if (manageBtnCancel) manageBtnCancel.classList.add('is-hidden');
          switchCancelPopup(activeCancel, '.delivery-manage-pop-up');
        } else {
          closeAllCancelPopups();
          const manageBtnCancel = document.querySelector('.delivery-manage-pop-up .update-buttons .btn--cancel');
          if (manageBtnCancel) manageBtnCancel.classList.add('is-hidden');
          openCancelPopup('.delivery-manage-pop-up');
        }
      }

      function getSubscriptionInfo() {
        const managePopup = document.querySelector('.delivery-manage-pop-up');
        const subscriptionId = managePopup ? managePopup.getAttribute('data-subscription-id') : '';
        return { subscriptionId: subscriptionId, token: token };
      }

      function getPortalUrl() {
        const info = getSubscriptionInfo();
        return '/collections/update-products?token=' + info.token + '&subscriptionId=' + info.subscriptionId;
      }

      async function recordCancellationFlowOutcome(reason, outcome, feedbackText) {
        try {
          const info = getSubscriptionInfo();
          if (!info.subscriptionId || !info.token) return;
          const subscriptionId = parseInt(info.subscriptionId, 10);
          if (isNaN(subscriptionId)) return;
          const now = new Date().toLocaleString('en-AU', { timeZone: 'Australia/Brisbane', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).replace(',', '');
          const newAttributes = [
            { key: 'Cancel Flow - Reason', value: reason || '' },
            { key: 'Cancel Flow - Outcome', value: outcome || '' },
            { key: 'Cancel Flow - Feedback', value: feedbackText || '' },
            { key: 'Cancel Flow - Date', value: now }
          ];
          const subscription = await getContract(info.token, subscriptionId);
          const oldNoteAttributes = subscription?.customAttributes || [];
          const orderNoteBody = mergeAttributes(oldNoteAttributes, newAttributes, subscriptionId);
          await updateNoteAttributesApi(info.token, orderNoteBody);
        } catch (err) {
          console.error('Failed to record cancellation flow outcome:', err);
        }
      }

      async function performCancelSubscription(btn, feedbackText, reasonLabel) {
        const info = getSubscriptionInfo();
        if (!info.subscriptionId || !info.token) return;
        const feedback = feedbackText || reasonLabel || 'User cancellation';
        const reason = reasonLabel || 'User cancellation';
        const subscriptionId = parseInt(info.subscriptionId, 10);
        const managePopup = document.querySelector('.delivery-manage-pop-up');
        const index = managePopup ? parseInt(managePopup.getAttribute('data-index'), 10) : 0;
        const originalSub = _latestSubscriptions[index];
        const localSub = { ...originalSub, status: 'CANCELLED' };
        _runOptimisticAction({
          btn,
          popupWrap: null,
          subscriptionId,
          index,
          originalSub,
          localSub,
          apiFactory: () => cancelCustomerSubsApi(info.token, subscriptionId, feedback, reason).then(() => {
            // Fire-and-forget telemetry; does not gate success.
            recordCancellationFlowOutcome(selectedCancelReason, 'Cancelled', feedbackText || '')
              .catch((e) => console.error('recordCancellationFlowOutcome error:', e));
          }),
          successToast: "Subscription cancelled.",
          errorToast: "Failed to cancel subscription. Please try again.",
          onPopupClose: () => closeAllCancelPopups(),
        });
      }

      function validateRequiredFeedback(popupSelector) {
        const popup = document.querySelector(popupSelector);
        if (!popup) return false;
        const textarea = popup.querySelector('.cancel-feedback-textarea');
        if (!textarea) return '';
        const label = popup.querySelector('.cancel-feedback-input .label label');
        const isRequired = label && label.textContent.indexOf('required') !== -1;
        if (isRequired && textarea.value.trim() === '') {
          textarea.classList.add('error');
          return false;
        }
        textarea.classList.remove('error');
        return textarea.value.trim();
      }

      /* Optimistic UI: popup closes at t=2s; API chain (remove old → apply new →
         verify) runs in background. On verify, apply-code wrap swaps the
         placeholder for the real discount HTML and refreshes the card. On
         failure, UI rolls back and an error toast surfaces. */
      function applyConfiguredDiscount(btn) {
        const codeInput = document.getElementById('cancel-discount-code');
        const discountCode = (codeInput && codeInput.value) ? codeInput.value : 'FFRUBYG20';
        const info = getSubscriptionInfo();
        if (!info.subscriptionId || !info.token) return;
        const subscriptionId = parseInt(info.subscriptionId, 10);
        if (isNaN(subscriptionId)) return;
        const managePopup = document.querySelector('.delivery-manage-pop-up');
        const index = managePopup ? parseInt(managePopup.getAttribute('data-index'), 10) : 0;

        if (btn && btn.dataset.pending === '1') return;
        if (_pendingSubscriptions.has(subscriptionId)) {
          showToast("Please wait for the previous action to finish.", 3000);
          return;
        }
        if (btn) {
          btn.dataset.pending = '1';
          btn.classList.add('loading');
        }
        _pendingSubscriptions.add(subscriptionId);

        const applyCodeWrap = document.querySelector('.apply-code[data-subscription-id="' + subscriptionId + '"]');
        const prevApplyCodeHTML = applyCodeWrap?.querySelector('.current-code-wrap')?.innerHTML ?? '';
        const prevHasDiscount = applyCodeWrap?.classList.contains('has-discount') ?? false;
        const prevDiscountId = applyCodeWrap?.getAttribute('data-discount-id') ?? '';

        const detailDiscountItem = document.querySelector('.detail-item.discount-code[data-subscription-id="' + subscriptionId + '"]');
        const detailLabel = detailDiscountItem?.querySelector('.detail-item__label');
        const detailEditBtn = detailDiscountItem?.querySelector('.top-edit-discount-btn');
        const prevDetailLabelHTML = detailLabel?.innerHTML ?? '';
        const prevDetailLabelHasDiscount = detailLabel?.classList.contains('has-discount') ?? false;
        const prevDetailEditBtnHasDiscount = detailEditBtn?.classList.contains('has-discount') ?? false;

        let apiFailed = false;
        let verifiedSubscription = null;
        let verifiedDiscount = null;
        let timerFired = false;

        function rollbackApplyCode() {
          if (applyCodeWrap) {
            const ccw = applyCodeWrap.querySelector('.current-code-wrap');
            if (ccw) ccw.innerHTML = prevApplyCodeHTML;
            if (prevHasDiscount) applyCodeWrap.classList.add('has-discount');
            else applyCodeWrap.classList.remove('has-discount');
            applyCodeWrap.setAttribute('data-discount-id', prevDiscountId);
          }
          if (detailLabel) {
            detailLabel.innerHTML = prevDetailLabelHTML;
            if (prevDetailLabelHasDiscount) detailLabel.classList.add('has-discount');
            else detailLabel.classList.remove('has-discount');
          }
          if (detailEditBtn) {
            if (prevDetailEditBtnHasDiscount) detailEditBtn.classList.add('has-discount');
            else detailEditBtn.classList.remove('has-discount');
          }
        }

        function finalizeSuccess(subscription, discount) {
          if (applyCodeWrap) {
            const allDiscounts = (subscription?.discounts?.nodes || []).filter(Boolean);
            const realHTML = allDiscounts.length
              ? allDiscounts.map((d) => _buildDiscountHTML(d, subscription)).join('')
              : '<p>No code applied</p>';
            const ccw = applyCodeWrap.querySelector('.current-code-wrap');
            if (ccw) ccw.innerHTML = realHTML;
            if (allDiscounts.length) {
              applyCodeWrap.classList.add('has-discount');
              applyCodeWrap.setAttribute('data-discount-id', allDiscounts.map((d) => d.id).filter(Boolean).join(','));
            }
          }
          _latestSubscriptions[index] = subscription;
          _refreshSubscriptionCard(subscription, subscriptionId, index);
        }

        (async () => {
          try {
            await _applyWithReplaceFallback(discountCode, token, subscriptionId);

            let subscription = await getContract(token, subscriptionId);
            const discountNodes = (subscription?.discounts?.nodes || []).filter(Boolean);
            const normalizedRequested = (discountCode || '').trim().toLowerCase();
            const discount = discountNodes.find((d) => (d?.title || '').trim().toLowerCase() === normalizedRequested);
            if (!discount) throw new Error('Discount code was not applied.');

            // Remove any OTHER discount of the same type so we end up with at
            // most one product-discount + one shipping-discount.
            const newType = _classifyDiscount(discount);
            const toRemove = discountNodes.filter((d) => d?.id && d.id !== discount.id && _classifyDiscount(d) === newType);
            for (const d of toRemove) {
              try { await removeDiscountCode(d.id, token, subscriptionId); }
              catch (removeErr) { console.error('removeDiscountCode (cancel flow same-type cleanup) error:', removeErr); }
            }
            if (toRemove.length) {
              subscription = await getContract(token, subscriptionId);
            }

            _invalidateCache();
            verifiedSubscription = subscription;
            verifiedDiscount = discount;

            recordCancellationFlowOutcome(selectedCancelReason, 'Applied Discount', '')
              .catch((e) => console.error('recordCancellationFlowOutcome error:', e));

            if (timerFired) finalizeSuccess(subscription, discount);
          } catch (err) {
            apiFailed = true;
            console.error('applyConfiguredDiscount error:', err);
            if (timerFired) {
              rollbackApplyCode();
              showToast('Invalid discount code. Please try again.', 5000);
            }
          } finally {
            _pendingSubscriptions.delete(subscriptionId);
          }
        })();

        setTimeout(() => {
          timerFired = true;
          if (btn) {
            btn.classList.remove('loading');
            delete btn.dataset.pending;
          }
          closeAllCancelPopups();

          if (apiFailed) {
            rollbackApplyCode();
            showToast('Invalid discount code. Please try again.', 5000);
            return;
          }

          /* Placeholder optimistic state — real discount value replaces it
             once the verify step resolves (price/% available only from API). */
          if (applyCodeWrap) {
            const ccw = applyCodeWrap.querySelector('.current-code-wrap');
            if (ccw) {
              ccw.innerHTML = '<p class="discount-label">Discount <span class="code"></span> applied</p>';
              const codeSpan = ccw.querySelector('.code');
              if (codeSpan) codeSpan.textContent = discountCode;
            }
            applyCodeWrap.classList.add('has-discount');
          }
          if (detailLabel) {
            detailLabel.innerHTML = '<strong>Discount:</strong> <span></span>';
            const codeSpan = detailLabel.querySelector('span');
            if (codeSpan) codeSpan.textContent = discountCode;
            detailLabel.classList.add('has-discount');
          }
          if (detailEditBtn) detailEditBtn.classList.add('has-discount');
          showToast('Discount applied.', 2000);

          if (verifiedSubscription && verifiedDiscount) {
            finalizeSuccess(verifiedSubscription, verifiedDiscount);
          }
        }, 2000);
      }

      // 1. manage popup btn--cancel → open cancel reason popup
      const manageCancelBtn = document.querySelector('.delivery-manage-pop-up .update-buttons .btn--cancel');
      if (manageCancelBtn) {
        manageCancelBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          document.querySelectorAll('.cancel-subscription-pop-up input[name="cancel-reason"]').forEach(function(r) { r.checked = false; });
          switchCancelPopup('.delivery-manage-pop-up', '.cancel-subscription-pop-up');
        });
      }

      // 2. cancel reason popup Confirm → open corresponding sub-popup
      const mainConfirmBtn = document.querySelector('.cancel-subscription-pop-up .btn--confirm');
      if (mainConfirmBtn) {
        mainConfirmBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          const selected = document.querySelector('.cancel-subscription-pop-up input[name="cancel-reason"]:checked');
          if (!selected) return;
          selectedCancelReason = reasonLabelMap[selected.value] || 'Other';
          const targetSelector = reasonPopupMap[selected.value];
          if (!targetSelector) return;
          switchCancelPopup('.cancel-subscription-pop-up', targetSelector);
        });
      }

      // 3. holidays: Cancel → other popup, Pause → manage without cancel btn
      const holidaysCancelBtn = document.querySelector('.cancel-subscription-holidays-pop-up .btn--cancel');
      if (holidaysCancelBtn) {
        holidaysCancelBtn.addEventListener('click', function () {
          switchCancelPopup('.cancel-subscription-holidays-pop-up', '.cancel-subscription-other-pop-up');
        });
      }
      const holidaysPauseBtn = document.querySelector('.cancel-subscription-holidays-pop-up .btn--pause-back');
      if (holidaysPauseBtn) {
        holidaysPauseBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openManageWithoutCancel();
          recordCancellationFlowOutcome(selectedCancelReason, 'Paused', '');
        });
      }

      // 4. expensive: Cancel → other popup, Apply discount → auto-apply
      const expensiveCancelBtn = document.querySelector('.cancel-subscription-expensive-pop-up .btn--cancel');
      if (expensiveCancelBtn) {
        expensiveCancelBtn.addEventListener('click', function () {
          switchCancelPopup('.cancel-subscription-expensive-pop-up', '.cancel-subscription-other-pop-up');
        });
      }
      const expensiveConfirmBtn = document.querySelector('.cancel-subscription-expensive-pop-up .btn--confirm');
      if (expensiveConfirmBtn) {
        expensiveConfirmBtn.addEventListener('click', function () {
          applyConfiguredDiscount(this);
        });
      }

      // 5. size: Cancel → discount popup, Link back → portal
      const sizeCancelBtn = document.querySelector('.cancel-subscription-size-pop-up .btn--cancel-to-discount');
      if (sizeCancelBtn) {
        sizeCancelBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          switchCancelPopup('.cancel-subscription-size-pop-up', '.cancel-subscription-discount-pop-up');
        });
      }
      document.querySelectorAll('.btn--link-portal').forEach(function(btn) {
        btn.addEventListener('click', async function (e) {
          e.preventDefault();
          this.classList.add('loading');
          await recordCancellationFlowOutcome(selectedCancelReason, 'Returned to Product Listing Page', '');
          window.location.href = getPortalUrl();
        });
      });

      // 5b. discount: Cancel → other popup, Claim discount → auto-apply
      const discountCancelBtn = document.querySelector('.cancel-subscription-discount-pop-up .btn--cancel');
      if (discountCancelBtn) {
        discountCancelBtn.addEventListener('click', function () {
          switchCancelPopup('.cancel-subscription-discount-pop-up', '.cancel-subscription-other-pop-up');
        });
      }
      const discountConfirmBtn = document.querySelector('.cancel-subscription-discount-pop-up .btn--confirm');
      if (discountConfirmBtn) {
        discountConfirmBtn.addEventListener('click', function () {
          applyConfiguredDiscount(this);
        });
      }

      // 6. malfunction: Cancel with required feedback
      const malfunctionCancelBtn = document.querySelector('.cancel-subscription-malfunction-pop-up .btn--cancel');
      if (malfunctionCancelBtn) {
        malfunctionCancelBtn.addEventListener('click', function () {
          const feedback = validateRequiredFeedback('.cancel-subscription-malfunction-pop-up');
          if (feedback === false) return;
          performCancelSubscription(this, feedback, 'Delivery timing does not work');
        });
      }

      // 7. discontent: Cancel → other popup
      const discontentFeedbackBtn = document.querySelector('.cancel-subscription-discontent-pop-up .btn--to-feedback');
      if (discontentFeedbackBtn) {
        discontentFeedbackBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          switchCancelPopup('.cancel-subscription-discontent-pop-up', '.cancel-subscription-other-pop-up');
        });
      }

      // 7b. discontent-feedback: Cancel (requires feedback), Pause → manage without cancel btn
      const feedbackCancelBtn = document.querySelector('.cancel-subscription-discontent-feedback-pop-up .btn--cancel');
      if (feedbackCancelBtn) {
        feedbackCancelBtn.addEventListener('click', function () {
          const feedback = validateRequiredFeedback('.cancel-subscription-discontent-feedback-pop-up');
          if (feedback === false) return;
          performCancelSubscription(this, feedback, selectedCancelReason);
        });
      }
      const feedbackPauseBtn = document.querySelector('.cancel-subscription-discontent-feedback-pop-up .btn--pause-back');
      if (feedbackPauseBtn) {
        feedbackPauseBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openManageWithoutCancel();
          recordCancellationFlowOutcome(selectedCancelReason, 'Paused', '');
        });
      }

      // 8. other/final: Go Back → close, Cancel Subscription → cancel (requires feedback)
      const otherCancelBtn = document.querySelector('.cancel-subscription-other-pop-up .btn--cancel');
      if (otherCancelBtn) {
        otherCancelBtn.addEventListener('click', function () {
          closeSingleCancelPopup('.cancel-subscription-other-pop-up');
        });
      }
      const otherConfirmBtn = document.querySelector('.cancel-subscription-other-pop-up .btn--confirm');
      if (otherConfirmBtn) {
        otherConfirmBtn.addEventListener('click', function () {
          const feedback = validateRequiredFeedback('.cancel-subscription-other-pop-up');
          if (feedback === false) return;
          performCancelSubscription(this, feedback, selectedCancelReason);
        });
      }

      // Icon close for all cancel popups
      cancelPopupSelectors.forEach(function(sel) {
        const popup = document.querySelector(sel);
        if (!popup) return;
        const closeBtn = popup.querySelector('.icon-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            closeSingleCancelPopup(sel);
          });
        }
      });

      // Clear error state on textarea input
      document.querySelectorAll('.cancel-feedback-textarea').forEach(function(textarea) {
        textarea.addEventListener('input', function () {
          if (this.value.trim() !== '') {
            this.classList.remove('error');
          }
        });
      });

      // Textarea character count
      document.querySelectorAll('.cancel-feedback-textarea').forEach(function(textarea) {
        const container = textarea.closest('.cancel-feedback-input');
        if (!container) return;
        const currentEl = container.querySelector('.words-limit .current');
        const maxLen = parseInt(textarea.getAttribute('maxlength')) || 500;

        textarea.addEventListener('input', function () {
          let text = this.value;
          if (text.length > maxLen) {
            this.value = text.substring(0, maxLen);
            text = this.value;
          }
          if (currentEl) currentEl.textContent = text.length;
        });
      });

      // Restore btn--cancel visibility when manage popup is closed via X
      document.querySelectorAll('.delivery-manage-pop-up .icon-close').forEach(function(btn) {
        btn.addEventListener('click', function () {
          const manageBtnCancel = document.querySelector('.delivery-manage-pop-up .update-buttons .btn--cancel');
          if (manageBtnCancel) manageBtnCancel.classList.remove('is-hidden');
        });
      });
    }
    // === End Cancel Subscription Flow ===
});